export const Slot = {
  PG: [
    {
      name: "Honey Trap of Diao Chan",
      image:
        "/assets/newSlot/PG0002.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-001",
    },
    {
      name: "Gem Saviour",
      image:
        "/assets/newSlot/PG0014.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-002",
    },
    {
      name: "Fortune Gods",
      image:
        "/assets/newSlot/PG0003.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-003",
    },
    {
      name: "Medusa",
      image:
        "/assets/newSlot/PG0009.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-006",
    },
    {
      name: "Hood vs Wolf",
      image:
        "/assets/newSlot/PG0017.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-009",
    },
    {
      name: "Win Win Won",
      image:
        "/assets/newSlot/PG0004.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-011",
    },
    {
      name: "Plushie Frenzy",
      image:
        "/assets/newSlot/PG0012.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-012",
    },
    {
      name: "Tree of Fortune",
      image:
        "/assets/newSlot/PG0007.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-013",
    },
    {
      name: "Hotpot",
      image:
        "/assets/newSlot/PG0018.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-015",
    },
    {
      name: "Dragon Legend",
      image:
        "/assets/newSlot/PG0019.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-016",
    },
    {
      name: "Hip Hop Panda",
      image:
        "/assets/newSlot/PG0024.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-017",
    },
    {
      name: "Legend of Hou Yi",
      image:
        "/assets/newSlot/PG0021.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-018",
    },
    {
      name: "Mr. Hallow-Win",
      image:
        "/assets/newSlot/PG0020.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
    },
    {
      name: "Prosperity Lion",
      image:
        "/assets/newSlot/PG0023.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-020",
    },
    {
      name: "Gem Saviour Sword",
      image:
        "/assets/newSlot/PG0027.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-022",
    },
    {
      name: "Piggy Gold",
      image:
        "/assets/newSlot/PG0028.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-023",
    },
    {
      name: "Jungle Delight",
      image:
        "/assets/newSlot/PG0033.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-024",
    },
    {
      name: "Symbols of Egypt",
      image:
        "/assets/newSlot/PG0029.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-025",
    },
    {
      name: "Ganesha Gold",
      image:
        "/assets/newSlot/PG0031.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-026",
    },
    {
      name: "Double Fortune",
      image:
        "/assets/newSlot/PG0035.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-030",
    },
    {
      name: "The Great Icescape",
      image:
        "/assets/newSlot/PG0037.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-032",
    },
    {
      name: "Dragon Tiger Luck",
      image:
        "/assets/newSlot/PG0045.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-035",
    },
    {
      name: "Flirting Scholar",
      image:
        "/assets/newSlot/PG0042.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-036",
    },
    {
      name: "Leprechaun Riches",
      image:
        "/assets/newSlot/PG0041.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-038",
    },
    {
      name: "Muay Thai Champion",
      image:
        "/assets/newSlot/PG0044.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-039",
    },
    {
      name: "Ninja vs Samurai",
      image:
        "/assets/newSlot/PG0043.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-040",
    },
    {
      name: "Mahjong Ways",
      image:
        "/assets/newSlot/PG0046.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-041",
    },
    {
      name: "Dragon Hatch",
      image:
        "/assets/newSlot/PG0047.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-042",
    },
    {
      name: "Fortune Mouse",
      image:
        "/assets/newSlot/PG0048.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-043",
    },
    {
      name: "Reel Love",
      image:
        "/assets/newSlot/PG0049.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-044",
    },
    {
      name: "Gem Saviour Conquest",
      image:
        "/assets/newSlot/PG0051.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-045",
    },
    {
      name: "Shaolin Soccer",
      image:
        "/assets/newSlot/PG0050.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-046",
    },
    {
      name: "Caishen Wins",
      image:
        "/assets/newSlot/PG0052.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-047",
    },
    {
      name: "Candy Burst",
      image:
        "/assets/newSlot/PG0053.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-048",
    },
    {
      name: "Bikini Paradise",
      image:
        "/assets/newSlot/PG0054.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-049",
    },
    {
      name: "Mahjong Ways 2",
      image:
        "/assets/newSlot/PG0055.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-050",
    },
    {
      name: "Egypt's Book of Mystery",
      image:
        "/assets/newSlot/PG0056.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-051",
    },
    {
      name: "Ganesha Fortune",
      image:
        "/assets/newSlot/PG0057.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-052",
    },
    {
      name: "Phoenix Rises",
      image:
        "/assets/newSlot/PG0059.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-053",
    },
    {
      name: "Wild Fireworks",
      image:
        "/assets/newSlot/PG0063.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-055",
    },
    {
      name: "Genie's 3 Wishes",
      image:
        "/assets/newSlot/PG0065.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-057",
    },
    {
      name: "Treasures of Aztec",
      image:
        "/assets/newSlot/PG0066.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-058",
    },
    {
      name: "Circus Delight",
      image:
        "/assets/newSlot/PG0067.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-059",
    },
    {
      name: "Thai River Wonders",
      image:
        "/assets/newSlot/PG0068.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-060",
    },
    {
      name: "Secret of Cleopatra",
      image:
        "/assets/newSlot/PG0069.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-061",
    },
    {
      name: "Vampire's Charm",
      image:
        "/assets/newSlot/PG0070.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-062",
    },
    {
      name: "Jewels of Prosperity",
      image:
        "/assets/newSlot/PG0072.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-064",
    },
    {
      name: "Lucky Neko",
      image:
        "/assets/newSlot/PG0073.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-065",
    },
    {
      name: "Jack Frost's Winter",
      image:
        "/assets/newSlot/PG0074.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-066",
    },
    {
      name: "Galactic Gems",
      image:
        "/assets/newSlot/PG0075.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-067",
    },
    {
      name: "Guardians of Ice and Fire",
      image:
        "/assets/newSlot/PG0076.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-068",
    },
    {
      name: "Opera Dynasty",
      image:
        "/assets/newSlot/PG0077.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-069",
    },
    {
      name: "Fortune Ox",
      image:
        "/assets/newSlot/PG0078.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-070",
    },
    {
      name: "Bali Vacation",
      image:
        "/assets/newSlot/PG0079.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-071",
    },
    {
      name: "Crypto Gold",
      image:
        "/assets/newSlot/PG0080.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-072",
    },
    {
      name: "Majestic Treasures",
      image:
        "/assets/newSlot/PG0081.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-073",
    },
    {
      name: "Candy Bonanza",
      image:
        "/assets/newSlot/PG0082.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-074",
    },
    {
      name: "Wild Bandito",
      image:
        "/assets/newSlot/PG0083.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-075",
    },
    {
      name: "Jurassic Kingdom",
      image:
        "/assets/newSlot/PG0088.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-079",
    },
    {
      name: "Mermaid Riches",
      image:
        "/assets/newSlot/PG0089.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-081",
    },
    {
      name: "Raider Jane's Crypt of Fortune",
      image:
        "/assets/newSlot/PG0091.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-083",
    },
    {
      name: "Supermarket Spree",
      image:
        "/assets/newSlot/PG0092.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-084",
    },
    {
      name: "Buffalo Win",
      image:
        "/assets/newSlot/PG0093.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-085",
    },
    {
      name: "Legendary Monkey King",
      image:
        "/assets/newSlot/PG0094.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-086",
    },
    {
      name: "Spirited Wonders",
      image:
        "/assets/newSlot/PG0095.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-087",
    },
    {
      name: "Emoji Riches",
      image:
        "/assets/newSlot/PG0097.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-089",
    },
    {
      name: "Cocktail Nights",
      image:
        "/assets/newSlot/PG0098.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-090",
    },
    {
      name: "Mask Carnival",
      image:
        "/assets/newSlot/PG0099.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-091",
    },
    {
      name: "Oriental Prosperity",
      image:
        "/assets/newSlot/PG0100.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-092",
    },
    {
      name: "Fortune Tiger",
      image:
        "/assets/newSlot/PG0101.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-093",
    },
    {
      name: "Garuda Gems",
      image:
        "/assets/newSlot/PG0102.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-094",
    },
    {
      name: "Butterfly Blossom",
      image:
        "/assets/newSlot/PG0104.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-096",
    },
    {
      name: "Rooster Rumble",
      image:
        "/assets/newSlot/PG0105.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-097",
    },
    {
      name: "The Queen's Banquet",
      image:
        "/assets/newSlot/PG0106.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-098",
    },
    {
      name: "Battleground Royale",
      image:
        "/assets/newSlot/PG0107.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-099",
    },
    {
      name: "Win Win Fish Prawn Crab",
      image:
        "/assets/newSlot/PG0108.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-100",
    },
    {
      name: "Lucky Piggy",
      image:
        "/assets/newSlot/PG0109.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-101",
    },
    {
      name: "Speed Winner",
      image:
        "/assets/newSlot/PG0110.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-102",
    },
    {
      name: "Legend of Perseus",
      image:
        "/assets/newSlot/PG0111.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-103",
    },
    {
      name: "Wild Coaster",
      image:
        "/assets/newSlot/PG0112.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-104",
    },
    {
      name: "Wild Bounty Showdown",
      image:
        "/assets/newSlot/PG0113.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-105",
    },
    {
      name: "Prosperity Fortune Tree",
      image:
        "/assets/newSlot/PG0114.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-106",
    },
    {
      name: "Totem Wonders",
      image:
        "/assets/newSlot/PG0115.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-107",
    },
    {
      name: "Alchemy Gold",
      image:
        "/assets/newSlot/PG0116.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-108",
    },
    {
      name: "Diner Delights",
      image:
        "/assets/newSlot/PG0117.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-109",
    },
    {
      name: "Asgardian Rising",
      image:
        "/assets/newSlot/PG0118.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-110",
    },
    {
      name: "Midas Fortune",
      image:
        "/assets/newSlot/PG0119.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-111",
    },
    {
      name: "Fortune Rabbit",
      image:
        "/assets/newSlot/PG0120.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-112",
    },
    {
      name: "Rave Party Fever",
      image:
        "/assets/newSlot/PG0121.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-113",
    },
    {
      name: "Hawaiian Tiki",
      image:
        "/assets/newSlot/PG0122.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-114",
    },
    {
      name: "Bakery Bonanza",
      image:
        "/assets/newSlot/PG0123.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-115",
    },
    {
      name: "Songkran Splash",
      image:
        "/assets/newSlot/PG0124.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-116",
    },
    {
      name: "Mystical Spirits",
      image:
        "/assets/newSlot/PG0125.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-117",
    },
    {
      name: "Super Golf Drive",
      image:
        "/assets/newSlot/PG0126.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-118",
    },
    {
      name: "Lucky Clover Riches",
      image:
        "/assets/newSlot/PG0127.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-119",
    },
    {
      name: "Cruise Royale",
      image:
        "/assets/newSlot/PG0129.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-121",
    },
    {
      name: "Safari Wilds",
      image:
        "/assets/newSlot/PG0130.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-122",
    },
    {
      name: "Gladiator's Glory",
      image:
        "/assets/newSlot/PG0131.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-123",
    },
    {
      name: "Ninja Raccoon Frenzy",
      image:
        "/assets/newSlot/PG0132.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-124",
    },
    {
      name: "Ultimate Striker",
      image:
        "/assets/newSlot/PG0133.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-125",
    },
    {
      name: "Wild Heist Cashout",
      image:
        "/assets/newSlot/PG0134.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-126",
    },
    {
      name: "Forge of Wealth",
      image:
        "/assets/newSlot/PG0135.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-127",
    },
    {
      name: "Mafia Mayhem",
      image:
        "/assets/newSlot/PG0136.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-128",
    },
    {
      name: "Tsar Treasures",
      image:
        "/assets/newSlot/PG0137.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-129",
    },
    {
      name: "Werewolf's Hunt",
      image:
        "/assets/newSlot/PG0138.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-130",
    },
    {
      name: "Dragon Hatch 2",
      image:
        "/assets/newSlot/PG0139.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-131",
    },
    {
      name: "Fortune Dragon",
      image:
        "/assets/newSlot/PG0140.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-132",
    },
    {
      name: "Gemstones Gold",
      image:
        "/assets/newSlot/PG0141.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-133",
    },
    {
      name: "Cash Mania",
      image:
        "/assets/newSlot/PG0142.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-134",
    },
    {
      name: "Pinata Wins",
      image:
        "/assets/newSlot/PG0144.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-136",
    },
    {
      name: "Mystic Potion",
      image:
        "/assets/newSlot/PG0145.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-137",
    },
    {
      name: "Anubis Wrath",
      image:
        "/assets/newSlot/PG0146.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-138",
    },
    {
      name: "Zombie Outbreak",
      image:
        "/assets/newSlot/PG0148.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-139",
    },
    {
      name: "Chicky Run",
      image:
        "/assets/newSlot/PG0147.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-140",
    },
    {
      name: "Futebol Fever",
      image:
        "/assets/newSlot/PG0149.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-141",
    },
    {
      name: "Shark Bounty",
      image:
        "/assets/newSlot/PG0150.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-142",
    },
    {
      name: "Yakuza Honor",
      image:
        "/assets/newSlot/PG0151.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-143",
    },
    {
      name: "Wings of Iguazu",
      image:
        "/assets/newSlot/PG0152.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-144",
    },
    {
      name: "Three Crazy Piggies",
      image:
        "/assets/newSlot/PG0153.webp",
      platformImage:
        "/assets/platformHeader/PG-WHITE.webp",
      platFormCode: "PG",
      gameType: "SLOT",
      casinoType: "PG-SLOT-145",
    },
  ],
  PP: [
    {
      name: "Gates of Olympus",
      image:
        "/assets/newSlot/PP0218.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-197",
    },
    {
      name: "Hot to Burn Hold and Spin",
      image:
        "/assets/newSlot/PP0284.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-003",
    },
    {
      name: "The Hand of Midas",
      image:
        "/assets/newSlot/PP0205.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-005",
    },
    {
      name: "Eye of the Storm",
      image:
        "/assets/newSlot/PP0203.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-006",
    },
    {
      name: "Congo Cash",
      image:
        "/assets/newSlot/PP0196.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-009",
    },
    {
      name: "Emerald King Rainbow Road",
      image:
        "/assets/newSlot/PP0193.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-010",
    },
    {
      name: "Mysterious Egypt",
      image:
        "/assets/newSlot/PP0192.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-011",
    },
    {
      name: "Golden Ox",
      image:
        "/assets/newSlot/PP0191.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-012",
    },
    {
      name: "Voodoo Magic",
      image:
        "/assets/newSlot/PP0189.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-013",
    },
    {
      name: "Bonanza Gold",
      image:
        "/assets/newSlot/PP0187.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-015",
    },
    {
      name: "John Hunter and the Mayan Gods",
      image:
        "/assets/newSlot/PP0186.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-016",
    },
    {
      name: "Spartan King",
      image:
        "/assets/newSlot/PP0185.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-017",
    },
    {
      name: "Cowboys Gold",
      image:
        "/assets/newSlot/PP0183.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-019",
    },
    {
      name: "Pirate Gold Deluxe",
      image:
        "/assets/newSlot/PP0182.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-020",
    },
    {
      name: "Emerald King",
      image:
        "/assets/newSlot/PP0181.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-021",
    },
    {
      name: "The Dragon Tiger",
      image:
        "/assets/newSlot/PP0180.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-022",
    },
    {
      name: "Wild Walker",
      image:
        "/assets/newSlot/PP0175.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-026",
    },
    {
      name: "Rise of Samurai",
      image:
        "/assets/newSlot/PP0174.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-027",
    },
    {
      name: "5 Lions Dance",
      image:
        "/assets/newSlot/PP0173.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-028",
    },
    {
      name: "Great Rhino Deluxe",
      image:
        "/assets/newSlot/PP0171.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-030",
    },
    {
      name: "Curse of the Werewolf Megaways",
      image:
        "/assets/newSlot/PP0219.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-033",
    },
    {
      name: "Jungle Gorilla",
      image:
        "/assets/newSlot/PP0168.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-034",
    },
    {
      name: "Aztec Gems Deluxe",
      image:
        "/assets/newSlot/PP0166.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-035",
    },
    {
      name: "Street Racer",
      image:
        "/assets/newSlot/PP0163.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-038",
    },
    {
      name: "Drago - Jewels of Fortune",
      image:
        "/assets/newSlot/PP0161.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-040",
    },
    {
      name: "Pyramid King",
      image:
        "/assets/newSlot/PP0572.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-042",
    },
    {
      name: "Ultra Burn",
      image:
        "/assets/newSlot/PP0570.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-043",
    },
    {
      name: "Money Money Money",
      image:
        "/assets/newSlot/PP0159.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-044",
    },
    {
      name: "Starz Megaways",
      image:
        "/assets/newSlot/PP0140.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-045",
    },
    {
      name: "Fruit Party",
      image:
        "/assets/newSlot/PP0139.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-046",
    },
    {
      name: "John Hunter and the Book of Tut",
      image:
        "/assets/newSlot/PP0138.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-047",
    },
    {
      name: "Three Star Fortune",
      image:
        "/assets/newSlot/PP0137.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-048",
    },
    {
      name: "Great Rhino Megaways",
      image:
        "/assets/newSlot/PP0135.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-049",
    },
    {
      name: "Hot to Burn",
      image:
        "/assets/newSlot/PP0136.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-050",
    },
    {
      name: "Dance Party",
      image:
        "/assets/newSlot/PP0134.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-051",
    },
    {
      name: "Wild West Gold",
      image:
        "/assets/newSlot/PP0133.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-052",
    },
    {
      name: "Fruit Rainbow",
      image:
        "/assets/newSlot/PP0128.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-054",
    },
    {
      name: "The Wild Machine",
      image:
        "/assets/newSlot/PP0127.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-055",
    },
    {
      name: "Aztec Bonanza",
      image:
        "/assets/newSlot/PP0126.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-056",
    },
    {
      name: "Mysterious",
      image:
        "/assets/newSlot/PP0125.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-057",
    },
    {
      name: "Master Joker",
      image:
        "/assets/newSlot/PP0123.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-059",
    },
    {
      name: "Super 7s",
      image:
        "/assets/newSlot/PP0122.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-060",
    },
    {
      name: "Release the Kraken",
      image:
        "/assets/newSlot/PP0121.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-061",
    },
    {
      name: "Buffalo King",
      image:
        "/assets/newSlot/PP0120.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-062",
    },
    {
      name: "Magic Journey",
      image:
        "/assets/newSlot/PP0119.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-063",
    },
    {
      name: "Money Mouse",
      image:
        "/assets/newSlot/PP0117.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-064",
    },
    {
      name: "Aladdin and the Sorcerer",
      image:
        "/assets/newSlot/PP0118.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-065",
    },
    {
      name: "Greek Gods",
      image:
        "/assets/newSlot/PP0116.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-066",
    },
    {
      name: "Sweet Bonanza Xmas",
      image:
        "/assets/newSlot/PP0115.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-067",
    },
    {
      name: "Hercules and Pegasus",
      image:
        "/assets/newSlot/PP0114.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-068",
    },
    {
      name: "Fire Strike",
      image:
        "/assets/newSlot/PP0113.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-069",
    },
    {
      name: "Honey Honey Honey",
      image:
        "/assets/newSlot/PP0112.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-070",
    },
    {
      name: "John Hunter and the Tomb of the Scarab Queen",
      image:
        "/assets/newSlot/PP0109.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-072",
    },
    {
      name: "Tree of Riches",
      image:
        "/assets/newSlot/PP0108.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-073",
    },
    {
      name: "The Great Chicken Escape",
      image:
        "/assets/newSlot/PP0107.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-074",
    },
    {
      name: "Hot Chilli",
      image:
        "/assets/newSlot/PP0106.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-076",
    },
    {
      name: "John Hunter and the Aztec Treasure",
      image:
        "/assets/newSlot/PP0096.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-077",
    },
    {
      name: "Monkey Warrior",
      image:
        "/assets/newSlot/PP0091.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-078",
    },
    {
      name: "5 Lions Gold",
      image:
        "/assets/newSlot/PP0088.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-080",
    },
    {
      name: "Wild Pixies",
      image:
        "/assets/newSlot/PP0633.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-081",
    },
    {
      name: "Sweet Bonanza",
      image:
        "/assets/newSlot/PP0086.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-082",
    },
    {
      name: "Caishen's Cash",
      image:
        "/assets/newSlot/PP0085.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-083",
    },
    {
      name: "Pirate Gold",
      image:
        "/assets/newSlot/PP0084.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-084",
    },
    {
      name: "The Dog House",
      image:
        "/assets/newSlot/PP0083.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-085",
    },
    {
      name: "Extra Juicy",
      image:
        "/assets/newSlot/PP0082.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-087",
    },
    {
      name: "Golden Pig",
      image:
        "/assets/newSlot/PP0080.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-089",
    },
    {
      name: "Treasure Horse",
      image:
        "/assets/newSlot/PP0079.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-090",
    },
    {
      name: "Safari King",
      image:
        "/assets/newSlot/PP0078.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-091",
    },
    {
      name: "Leprechaun Carol",
      image:
        "/assets/newSlot/PP0094.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-092",
    },
    {
      name: "Mustang Gold",
      image:
        "/assets/newSlot/PP0095.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-093",
    },
    {
      name: "Triple Dragons",
      image:
        "/assets/newSlot/PP0097.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-094",
    },
    {
      name: "Ancient Egypt Classic",
      image:
        "/assets/newSlot/PP0110.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-095",
    },
    {
      name: "Vegas Magic",
      image:
        "/assets/newSlot/PP0098.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-096",
    },
    {
      name: "Master Chen's Fortune",
      image:
        "/assets/newSlot/PP0099.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-097",
    },
    {
      name: "Da Vinci's Treasure",
      image:
        "/assets/newSlot/PP0100.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-098",
    },
    {
      name: "Peking Luck",
      image:
        "/assets/newSlot/PP0101.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-099",
    },
    {
      name: "Leprechaun Song",
      image:
        "/assets/newSlot/PP0102.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-100",
    },
    {
      name: "Jade Butterfly",
      image:
        "/assets/newSlot/PP0103.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-101",
    },
    {
      name: "Madame Destiny",
      image:
        "/assets/newSlot/PP0104.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-102",
    },
    {
      name: "Asgard",
      image:
        "/assets/newSlot/PP0105.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-103",
    },
    {
      name: "5 Lions",
      image:
        "/assets/newSlot/PP0001.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-104",
    },
    {
      name: "Great Rhino",
      image:
        "/assets/newSlot/PP0003.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-106",
    },
    {
      name: "Joker's Jewels",
      image:
        "/assets/newSlot/PP0004.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-107",
    },
    {
      name: "Fairytale Fortune",
      image:
        "/assets/newSlot/PP0005.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-108",
    },
    {
      name: "Fire 88",
      image:
        "/assets/newSlot/PP0006.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-109",
    },
    {
      name: "Chilli Heat",
      image:
        "/assets/newSlot/PP0007.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-110",
    },
    {
      name: "Aztec Gems",
      image:
        "/assets/newSlot/PP0009.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-111",
    },
    {
      name: "Ancient Egypt",
      image:
        "/assets/newSlot/PP0010.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-006",
    },
    {
      name: "Lucky New Year",
      image:
        "/assets/newSlot/PP0011.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-113",
    },
    {
      name: "Gold Rush",
      image:
        "/assets/newSlot/PP0014.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-114",
    },
    {
      name: "888 Gold",
      image:
        "/assets/newSlot/PP0847.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-169",
    },
    {
      name: "Diamonds are Forever 3 Lines",
      image:
        "/assets/newSlot/PP0072.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-170",
    },
    {
      name: "Temujin Treasures",
      image:
        "/assets/newSlot/PP0207.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-171",
    },
    {
      name: "Wild Booster",
      image:
        "/assets/newSlot/PP0221.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-173",
    },
    {
      name: "Power of Thor Megaways",
      image:
        "/assets/newSlot/PP0210.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-174",
    },
    {
      name: "Hot Fiesta",
      image:
        "/assets/newSlot/PP0220.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-175",
    },
    {
      name: "Buffalo King Megaways",
      image:
        "/assets/newSlot/PP0211.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-176",
    },
    {
      name: "Aztec King",
      image:
        "/assets/newSlot/PP0215.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-180",
    },
    {
      name: "Cash Elevator",
      image:
        "/assets/newSlot/PP0230.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-182",
    },
    {
      name: "5 Lions Megaways",
      image:
        "/assets/newSlot/PP0228.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-183",
    },
    {
      name: "Dragon Hot Hold and Spin",
      image:
        "/assets/newSlot/PP0227.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-184",
    },
    {
      name: "Yum Yum Powerways",
      image:
        "/assets/newSlot/PP0236.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-185",
    },
    {
      name: "Pyramid Bonanza",
      image:
        "/assets/newSlot/PP0238.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-187",
    },
    {
      name: "Raging Bull",
      image:
        "/assets/newSlot/PP0239.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-188",
    },
    {
      name: "Starlight Princess",
      image:
        "/assets/newSlot/PP0240.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-189",
    },
    {
      name: "Bigger Bass Bonanza",
      image:
        "/assets/newSlot/PP0244.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-190",
    },
    {
      name: "Heart of Rio",
      image:
        "/assets/newSlot/PP0226.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-191",
    },
    {
      name: "Lucky Lightning",
      image:
        "/assets/newSlot/PP0225.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-192",
    },
    {
      name: "Fruit Party 2",
      image:
        "/assets/newSlot/PP0223.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-194",
    },
    {
      name: "Chicken Drop",
      image:
        "/assets/newSlot/PP0232.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-196",
    },
    {
      name: "Chilli Heat Megaways",
      image:
        "/assets/newSlot/PP0235.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-199",
    },
    {
      name: "Day of Dead",
      image:
        "/assets/newSlot/PP0250.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-203",
    },
    {
      name: "Candy Village",
      image:
        "/assets/newSlot/PP0251.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-204",
    },
    {
      name: "Mystic Chief",
      image:
        "/assets/newSlot/PP0252.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-205",
    },
    {
      name: "The Tweety House",
      image:
        "/assets/newSlot/PP0253.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-206",
    },
    {
      name: "Christmas Big Bass Bonanza",
      image:
        "/assets/newSlot/PP0258.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-211",
    },
    {
      name: "Emperor Caishen",
      image:
        "/assets/newSlot/PP0288.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-220",
    },
    {
      name: "Crystal Caverns Megaways",
      image:
        "/assets/newSlot/PP0289.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-221",
    },
    {
      name: "Smugglers Cove",
      image:
        "/assets/newSlot/PP0290.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-222",
    },
    {
      name: "Extra Juicy Megaways",
      image:
        "/assets/newSlot/PP0292.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-224",
    },
    {
      name: "Fire Portals",
      image:
        "/assets/newSlot/PP0702.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-444",
    },
    {
      name: "The Dog House – Dog or Alive",
      image:
        "/assets/newSlot/PP0711.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-327",
    },
    {
      name: "Release the Bison",
      image:
        "/assets/newSlot/PP0730.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-446",
    },
    {
      name: "Aztec Powernudge",
      image:
        "/assets/newSlot/PP0712.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-447",
    },
    {
      name: "Ripe Rewards",
      image:
        "/assets/newSlot/PP0724.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-449",
    },
    {
      name: "Big Bass Secrets of the Golden Lake",
      image:
        "/assets/newSlot/PP0731.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-450",
    },
    {
      name: "Ice Lobster",
      image:
        "/assets/newSlot/PP0715.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-451",
    },
    {
      name: "Candy Blitz Bombs",
      image:
        "/assets/newSlot/PP0725.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-453",
    },
    {
      name: "Joker's Jewels Wild",
      image:
        "/assets/newSlot/PP0733.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-454",
    },
    {
      name: "Heroic Spin",
      image:
        "/assets/newSlot/PP0734.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-455",
    },
    {
      name: "Lobster Bob's Sea Food and Win It",
      image:
        "/assets/newSlot/PP0723.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-456",
    },
    {
      name: "Heart of Cleopatra",
      image:
        "/assets/newSlot/PP0728.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-457",
    },
    {
      name: "Odds On Winner",
      image:
        "/assets/newSlot/PP0735.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-458",
    },
    {
      name: "Dwarf & Dragon",
      image:
        "/assets/newSlot/PP0736.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-459",
    },
    {
      name: "Rise of Pyramids",
      image:
        "/assets/newSlot/PP0756.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-460",
    },
    {
      name: "Fruity Treats",
      image:
        "/assets/newSlot/PP0726.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-461",
    },
    {
      name: "Revenge of Loki Megaways",
      image:
        "/assets/newSlot/PP0757.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-462",
    },
    {
      name: "Starlight Princess Pachi",
      image:
        "/assets/newSlot/PP0738.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-463",
    },
    {
      name: "Sweet Bonanza 1000",
      image:
        "/assets/newSlot/PP0739.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-464",
    },
    {
      name: "Wildies",
      image:
        "/assets/newSlot/PP0764.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-465",
    },
    {
      name: "Devilicious",
      image:
        "/assets/newSlot/PP0765.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-466",
    },
    {
      name: "Medusa's Stone",
      image:
        "/assets/newSlot/PP0742.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-468",
    },
    {
      name: "Hand of Midas 2",
      image:
        "/assets/newSlot/PP0755.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-472",
    },
    {
      name: "Sweet Kingdom",
      image:
        "/assets/newSlot/PP0753.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-473",
    },
    {
      name: "Samurai Code",
      image:
        "/assets/newSlot/PP0775.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-475",
    },
    {
      name: "6 Jokers",
      image:
        "/assets/newSlot/PP0776.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-477",
    },
    {
      name: "Dynamite Diggin Doug",
      image:
        "/assets/newSlot/PP0777.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-478",
    },
    {
      name: "Joker's Jewels Hot",
      image:
        "/assets/newSlot/PP0822.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-479",
    },
    {
      name: "Sumo Supreme Megaways",
      image:
        "/assets/newSlot/PP0797.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-480",
    },
    {
      name: "Bow of Artemis",
      image:
        "/assets/newSlot/PP0793.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-481",
    },
    {
      name: "Gates of Olympus Xmas 1000",
      image:
        "/assets/newSlot/PP0868.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-524",
    },
    {
      name: "Tiny Toads",
      image:
        "/assets/newSlot/PP0871.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-526",
    },
    {
      name: "Dragon King Hot Pots",
      image:
        "/assets/newSlot/PP0875.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-527",
    },
    {
      name: "Money Stacks Megaways",
      image:
        "/assets/newSlot/PP0876.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-528",
    },
    {
      name: "Big Bass Bonanza 3 Reeler",
      image:
        "/assets/newSlot/PP0880.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-529",
    },
    {
      name: "Mining Rush",
      image:
        "/assets/newSlot/PP0878.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-530",
    },
    {
      name: "Aztec Smash",
      image:
        "/assets/newSlot/PP0893.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-531",
    },
    {
      name: "Fonzo’s Feline Fortunes",
      image:
        "/assets/newSlot/PP0894.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-532",
    },
    {
      name: "Floating Dragon – Year of the Snake",
      image:
        "/assets/newSlot/PP0895.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-533",
    },
    {
      name: "Brick House Bonanza",
      image:
        "/assets/newSlot/PP0896.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-534",
    },
    {
      name: "Aztec Gems Megaways™",
      image:
        "/assets/newSlot/PP0910.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "Wild Wild Pearls",
      image:
        "/assets/newSlot/PP0912.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-536",
    },
    {
      name: "Irish Crown",
      image:
        "/assets/newSlot/PP0907.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-537",
    },
    {
      name: "Wild Wildebeest Wins",
      image:
        "/assets/newSlot/PP0913.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-538",
    },
    {
      name: "John Hunter and Galileo’s Secrets",
      image:
        "/assets/newSlot/PP0918.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-541",
    },
    {
      name: "Savannah Legend",
      image:
        "/assets/newSlot/PP0920.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-542",
    },
    {
      name: "Bigger Bass Splash",
      image:
        "/assets/newSlot/PP0919.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-543",
    },
    {
      name: "Big Bass Return to the Races",
      image:
        "/assets/newSlot/PP0924.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-544",
    },
    {
      name: "Peppe’s Pepperoni Pizza Plaza",
      image:
        "/assets/newSlot/PP0925.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-545",
    },
    {
      name: "Greedy Fortune Pig",
      image:
        "/assets/newSlot/PP0922.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-547",
    },
    {
      name: "Wild Wild Joker",
      image:
        "/assets/newSlot/PP0943.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-549",
    },
    {
      name: "Lucky's Wild Pub",
      image:
        "/assets/newSlot/PP0941.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-550",
    },
    {
      name: "Volcano Goddess",
      image:
        "/assets/newSlot/PP0946.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-551",
    },
    {
      name: "Book of Monsters",
      image:
        "/assets/newSlot/PP0968.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-554",
    },
    {
      name: "Blitz Super Wheel",
      image:
        "/assets/newSlot/PP0965.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-555",
    },
    {
      name: "Ride The Lightning",
      image:
        "/assets/newSlot/PP0971.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-558",
    },
    {
      name: "5 Lions Reborn",
      image:
        "/assets/newSlot/PP0976.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-559",
    },
    {
      name: "Big Bass Bonanza 1000",
      image:
        "/assets/newSlot/PP0990.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-560",
    },
    {
      name: "Cash Surge",
      image:
        "/assets/newSlot/PP0989.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-561",
    },
    {
      name: "Gates of Olympus Super Scatter",
      image:
        "/assets/newSlot/PP0992.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-562",
    },
    {
      name: "Sleeping Dragon",
      image:
        "/assets/newSlot/PP0997.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-564",
    },
    {
      name: "Fiesta Fortune",
      image:
        "/assets/newSlot/PP0998.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-565",
    },
    {
      name: "Jumbo Safari",
      image:
        "/assets/newSlot/PP1001.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-566",
    },
    {
      name: "Resurrecting Riches",
      image:
        "/assets/newSlot/PP0996.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-567",
    },
    {
      name: "Gates of Hades",
      image:
        "/assets/newSlot/PP1006.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-569",
    },
    {
      name: "Mummy’s Jewels",
      image:
        "/assets/newSlot/PP1010.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-571",
    },
    {
      name: "Big Bass Boxing Bonus Round",
      image:
        "/assets/newSlot/PP1018.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-572",
    },
    {
      name: "Temple Guardians",
      image:
        "/assets/newSlot/PP1019.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-573",
    },
    {
      name: "Finger Lick’n Free Spins",
      image:
        "/assets/newSlot/PP1022.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "Wild West Gold Blazing Bounty",
      image:
        "/assets/newSlot/PP1009.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-576",
    },
    {
      name: "Gem Fire Fortune",
      image:
        "/assets/newSlot/PP1024.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-577",
    },
    {
      name: "Waves of Poseidon",
      image:
        "/assets/newSlot/PP1025.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-578",
    },
    {
      name: "Club Tropicana – Happy Hour",
      image:
        "/assets/newSlot/PP1027.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "Alien Invaders",
      image:
        "/assets/newSlot/PP1028.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-580",
    },
    {
      name: "You Can Piggy Bank On It",
      image:
        "/assets/newSlot/PP1032.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-581",
    },
    {
      name: "Chilli Heat Spicy Spins",
      image:
        "/assets/newSlot/PP1033.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-582",
    },
    {
      name: "Gem Trio",
      image:
        "/assets/newSlot/PP1037.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-583",
    },
    {
      name: "Wolf Gold 4 Pack",
      image:
        "/assets/newSlot/PP1040.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-584",
    },
    {
      name: "Big Bass Reel Repeat",
      image:
        "/assets/newSlot/PP1046.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-585",
    },
    {
      name: "Sweet Bonanza Super Scatter",
      image:
        "/assets/newSlot/PP1029.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-586",
    },
    {
      name: "Argonauts",
      image:
        "/assets/newSlot/PP1042.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-587",
    },
    {
      name: "Ice Mints",
      image:
        "/assets/newSlot/PP1048.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-588",
    },
    {
      name: "Zombie School Megaways",
      image:
        "/assets/newSlot/PP1043.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-590",
    },
    {
      name: "Fire Stampede 2",
      image:
        "/assets/newSlot/PP1055.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-591",
    },
    {
      name: "Jackpot Blaze",
      image:
        "/assets/newSlot/PP1057.webp",
      platformImage:
        "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "SLOT",
      casinoType: "PP-SLOT-592",
    },
  ],
  JILI: [
     {
    
    name: "Super Ace Deluxe",
    image: "/assets/newSlot/JILI-SLOT-102.webp",
    platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
    platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-102",
  },
    {
    image: "../assets/newSlot/JILI-SLOT-194.avif",
    name: "Party Ape",
     platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
  
    gameType: "SLOT",
    casinoType: "JILI-SLOT-194",
  },
    {
    image: "../assets/images/slot/JILI-SLOT-148.webp",
    name: "Clover Coins",
     platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
  
    gameType: "SLOT",
    casinoType: "JILI-SLOT-148",
  },
    {
    image: "../assets/images/slot/jili/JILI-SLOT-138.webp",
    name: "Fortune game 500",
    
    platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
    gameType: "SLOT",
    casinoType: "JILI-SLOT-138",
  },
    {
      name: "Hot Chilli",
      image: "/assets/newSlot/JL0011.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-002",
    },
    {
      name: "Chin Shi Huang",
      image: "/assets/newSlot/JL0012.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-003",
    },
    {
      name: "War Of Dragons",
      image: "/assets/newSlot/JL0013.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-004",
    },
    {
      name: "Fortune Tree",
      image: "/assets/newSlot/JL0014.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-005",
    },
    {
      name: "Lucky Ball",
      image: "/assets/newSlot/JL0015.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-006",
    },
    {
      name: "Hyper Burst",
      image: "/assets/newSlot/JL0016.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-007",
    },
    {
      name: "Shanghai Beauty",
      image: "/assets/newSlot/JL0017.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-008",
    },
    {
      name: "Fa Fa Fa",
      image: "/assets/newSlot/JL0018.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-009",
    },
    {
      name: "God Of Martial",
      image: "/assets/newSlot/JL0019.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-010",
    },
    {
      name: "Hawaii Beauty",
      image: "/assets/newSlot/JL0199.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-012",
    },
    {
      name: "Crazy777",
      image: "/assets/newSlot/JL0021.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-014",
    },
    {
      name: "Bubble Beauty",
      image: "/assets/newSlot/JL0022.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-015",
    },
    {
      name: "Crazy FaFaFa",
      image: "/assets/newSlot/JL0024.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-017",
    },
    {
      name: "Candy Baby",
      image: "/assets/newSlot/JL0027.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-020",
    },
    {
      name: "Diamond Party",
      image: "/assets/newSlot/JL0200.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-021",
    },
    {
      name: "Fengshen",
      image: "/assets/newSlot/JL0028.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-022",
    },
    {
      name: "Golden Bank",
      image: "/assets/newSlot/JL0029.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-023",
    },
    {
      name: "Lucky Goldbricks",
      image: "/assets/newSlot/JL0030.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-024",
    },
    {
      name: "Dragon Treasure",
      image: "/assets/newSlot/JL0031.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-025",
    },
    {
      name: "Charge Buffalo",
      image: "/assets/newSlot/JL0032.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-026",
    },
    {
      name: "Super Ace",
      image: "/assets/newSlot/JL0033.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-027",
    },
    {
      name: "Jungle King",
      image: "/assets/newSlot/JL0037.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-028",
    },
    {
      name: "Money Coming",
      image: "/assets/newSlot/JL0036.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-029",
    },
    {
      name: "Golden Queen",
      image: "/assets/newSlot/JL0034.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-030",
    },
    {
      name: "Boxing King",
      image: "/assets/newSlot/JL0038.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-031",
    },
    {
      name: "Lucky Coming",
      image: "/assets/newSlot/JL0041.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-037",
    },
    {
      name: "Pharaoh Treasure",
      image: "/assets/newSlot/JL0040.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-038",
    },
    {
      name: "Secret Treasure",
      image: "/assets/newSlot/JL0039.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-039",
    },
    {
      name: "RomaX",
      image: "/assets/newSlot/JL0043.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-040",
    },
    {
      name: "Super Rich",
      image: "/assets/newSlot/JL0042.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-041",
    },
    {
      name: "Golden Empire",
      image: "/assets/newSlot/JL0044.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-042",
    },
    {
      name: "Fortune Gems",
      image: "/assets/newSlot/JL0045.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-043",
    },
    {
      name: "Party Night",
      image: "/assets/newSlot/JL0098.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-044",
    },
    {
      name: "Crazy Hunter",
      image: "/assets/newSlot/JL0046.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-045",
    },
    {
      name: "Magic Lamp",
      image: "/assets/newSlot/JL0099.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-046",
    },
    {
      name: "Agent Ace",
      image: "/assets/newSlot/JL0097.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-048",
    },
    {
      name: "Medusa",
      image: "/assets/newSlot/JL0047.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-050",
    },
    {
      name: "Mega Ace",
      image: "/assets/newSlot/JL0093.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-051",
    },
    {
      name: "Thor X",
      image: "/assets/newSlot/JL0051.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-052",
    },
    {
      name: "Book of Gold",
      image: "/assets/newSlot/JL0048.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-053",
    },
    {
      name: "Crazy Pusher",
      image: "/assets/newSlot/JL0056.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-054",
    },
    {
      name: "Happy Taxi",
      image: "/assets/newSlot/JL0053.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-056",
    },
    {
      name: "Gold Rush",
      image: "/assets/newSlot/JL0054.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-057",
    },
    {
      name: "Mayan Empire",
      image: "/assets/newSlot/JL0055.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-058",
    },
    {
      name: "Bone Fortune",
      image: "/assets/newSlot/JL0057.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-059",
    },
    {
      name: "Win Drop",
      image: "/assets/newSlot/JL0086.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-061",
    },
    {
      name: "Bonus Hunter",
      image: "/assets/newSlot/JL0085.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-062",
    },
    {
      name: "World Cup",
      image: "/assets/newSlot/JL0090.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-063",
    },
    {
      name: "Samba",
      image: "/assets/newSlot/JL0095.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-070",
    },
    {
      name: "Neko Fortune",
      image: "/assets/newSlot/JL0101.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-071",
    },
    {
      name: "Wild Racer",
      image: "/assets/newSlot/JL0102.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-072",
    },
    {
      name: "Pirate Queen",
      image: "/assets/newSlot/JL0106.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-073",
    },
    {
      name: "Golden Joker",
      image: "/assets/newSlot/JL0103.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-074",
    },
    {
      name: "Wild Ace",
      image: "/assets/newSlot/JL0116.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-075",
    },
    {
      name: "Fortune Gems 2",
      image: "/assets/newSlot/JL0125.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-076",
    },
    {
      name: "Master Tiger",
      image: "/assets/newSlot/JL0107.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-077",
    },
    {
      name: "Cricket King 18",
      image: "/assets/newSlot/JL0126.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-078",
    },
    {
      name: "Sweet Land",
      image: "/assets/newSlot/JL0113.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-079",
    },
    {
      name: "Golden Temple",
      image: "/assets/newSlot/JL0124.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-080",
    },
    {
      name: "Elf Bingo",
      image: "/assets/newSlot/JL0123.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-081",
    },
    {
      name: "Cricket Sah 75",
      image: "/assets/newSlot/JL0131.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-082",
    },
    {
      name: "Aztec Priestess",
      image: "/assets/newSlot/JL0137.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-083",
    },
    {
      name: "Trial of Phoenix",
      image: "/assets/newSlot/JL0151.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-084",
    },
    {
      name: "Devil Fire",
      image: "/assets/newSlot/JL0138.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-085",
    },
    {
      name: "Bangla Beauty",
      image: "/assets/newSlot/JL0134.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-086",
    },
    {
      name: "Fortune Monkey",
      image: "/assets/newSlot/JL0139.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-087",
    },
    {
      name: "Dabanggg",
      image: "/assets/newSlot/JL0140.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-088",
    },
    {
      name: "Sin City",
      image: "/assets/newSlot/JL0142.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-089",
    },
    {
      name: "Night City",
      image: "/assets/newSlot/JL0144.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-090",
    },
    {
      name: "King Arthur",
      image: "/assets/newSlot/JL0145.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-091",
    },
    {
      name: "Arena Fighter",
      image: "/assets/newSlot/JL0149.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-092",
    },
    {
      name: "Charge Buffalo Ascent",
      image: "/assets/newSlot/JL0148.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-093",
    },
    {
      name: "Devil Fire 2",
      image: "/assets/newSlot/JL0150.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-094",
    },
    {
      name: "Witches Night",
      image: "/assets/newSlot/JL0147.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-095",
    },
    {
      name: "Fortune Gems 3",
      image: "/assets/newSlot/JL0156.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-096",
    },
    {
      name: "Zeus",
      image: "/assets/newSlot/JL0152.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-097",
    },
    {
      name: "Potion Wizard",
      image: "/assets/newSlot/JL0161.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-098",
    },
    {
      name: "Jackpot Joker",
      image: "/assets/newSlot/JL0153.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-100",
    },
    {
      name: "3 Coin Treasures",
      image: "/assets/newSlot/JL0154.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-101",
    },
    {
      name: "The Pig House",
      image: "/assets/newSlot/JL0165.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-103",
    },
    {
      name: "Party Star",
      image: "/assets/newSlot/JL0171.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-104",
    },
    {
      name: "Legacy of Egypt",
      image: "/assets/newSlot/JL0166.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-105",
    },
    {
      name: "3 Pot Dragons",
      image: "/assets/newSlot/JL0180.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-106",
    },
    {
      name: "Money Coming Expand Bets",
      image: "/assets/newSlot/JL0167.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-107",
    },
    {
      name: "Egypt's Glow",
      image: "/assets/newSlot/JL0174.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-108",
    },
    {
      name: "3 Lucky Piggy",
      image: "/assets/newSlot/JL0173.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-109",
    },
    {
      name: "Shōgun",
      image: "/assets/newSlot/JL0184.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-110",
    },
    {
      name: "Fruity Wheel",
      image: "/assets/newSlot/JL0178.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-111",
    },
    {
      name: "Money Pot",
      image: "/assets/newSlot/JL0182.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-112",
    },
    {
      name: "Nightfall Hunting",
      image: "/assets/newSlot/JL0187.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-113",
    },
    {
      name: "Treasure Quest",
      image: "/assets/newSlot/JL0203.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-114",
    },
    {
      name: "Lucky Jaguar",
      image: "/assets/newSlot/JL0189.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-115",
    },
    {
      name: "Golden Bank 2",
      image: "/assets/newSlot/JL0192.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-116",
    },
    {
      name: "Lucky Doggy",
      image: "/assets/newSlot/JL0179.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-117",
    },
    {
      name: "Super Ace Joker",
      image: "/assets/newSlot/JL0212.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-118",
    },
    {
      name: "Poseidon",
      image: "/assets/newSlot/JL0176.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-121",
    },
    {
      name: "Safari Mystery",
      image: "/assets/newSlot/JL0197.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-123",
    },
    {
      name: "Roma X Deluxe",
      image: "/assets/newSlot/JL0209.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-124",
    },
    {
      name: "Coin Tree",
      image: "/assets/newSlot/JL0202.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-125",
    },
    {
      name: "3 Coin Wild Horse",
      image: "/assets/newSlot/JL0206.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-126",
    },
    {
      name: "Bikini Lady",
      image: "/assets/newSlot/JL0227.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-127",
    },
    {
      name: "Fortune Coins",
      image: "/assets/newSlot/JL0211.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-129",
    },
    {
      name: "3 Charge Buffalo",
      image: "/assets/newSlot/JL0213.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-131",
    },
    {
      name: "10 Sparkling Crown",
      image: "/assets/newSlot/JL0217.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-133",
    },
    {
      name: "3 Coin Treasures 2",
      image: "/assets/newSlot/JL0193.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-134",
    },
    {
      name: "Pirate Queen 2",
      image: "/assets/newSlot/JL0221.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-135",
    },
    {
      name: "Circus Joker 4096",
      image: "/assets/newSlot/JL0232.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-136",
    },
    {
      name: "Joker Coins",
      image: "/assets/newSlot/JL0218.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-137",
    },
    {
      name: "3 LUCKY LION",
      image: "/assets/newSlot/JL0208.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-140",
    },
    {
      name: "Golden Empire 2",
      image: "/assets/newSlot/JL0228.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-143",
    },
    {
      name: "40 Sparkling Crown",
      image: "/assets/newSlot/JL0229.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-145",
    },
    {
      name: "Money Coming 2",
      image: "/assets/newSlot/JL0215.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-146",
    },
    {
      name: "Crazy777 2",
      image: "/assets/newSlot/JL0233.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "SLOT",
      casinoType: "JILI-SLOT-149",
    },
  ],
  SPRIBE: [
    {
      name: "Aviator",
      image:
        "/assets/newSlot/SPB002.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-001",
    },
    {
      name: "Goal",
      image:
        "/assets/newSlot/SPB004.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-002",
    },
    {
      name: "Dice",
      image:
        "/assets/newSlot/SPB003.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-003",
    },
    {
      name: "Plinko",
      image:
        "/assets/newSlot/SPB005.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-004",
    },
    {
      name: "Mines",
      image:
        "/assets/newSlot/SPB006.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-005",
    },
    {
      name: "Hilo",
      image:
        "/assets/newSlot/SPB007.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-006",
    },
    {
      name: "Keno",
      image:
        "/assets/newSlot/SPB008.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-007",
    },
    {
      name: "Mini Roulette",
      image:
        "/assets/newSlot/SPB009.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-008",
    },
    {
      name: "Hotline",
      image:
        "/assets/newSlot/SPB010.webp",
      platformImage:
        "/assets/platformHeader/SPB-WHITE.webp",
      platFormCode: "SPRIBE",
      gameType: "EGAME",
      casinoType: "SPRIBE-EGAME-009",
    },
  ],
  FC: [
    
    {
      name: "Super Color Game",
      image: "../assets/newSlot/fc/FC-EGAME-005.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-005",


    },
    {
      name: "TOWER",
      image: "../assets/newSlot/fc/FC-EGAME-008.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-008",


    },
    {
      name: "FA CHAI DOZER",
      image: "../assets/newSlot/fc/FC-EGAME-002.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-002",


    },
    {
      name: "CIRCUS DOZER",
      image: "../assets/newSlot/fc/FC-EGAME-003.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-003",


    },
     {
      name: "MINES",
      image: "../assets/newSlot/fc/FC-EGAME-007.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-007",


    },
     {
      name: "LIGHTNING BOMB",
      image: "../assets/newSlot/fc/FC-EGAME-004.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-004",


    },
    {
      name: "MONEY TREE DOZER",
      image: "../assets/newSlot/fc/FC-EGAME-001.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "EGAME",
      casinoType: "FC-EGAME-001",


    },
     {
      name: "CYBER GOD OF FORTUNE⁺",
      image: "../assets/newSlot/fc/FC-SLOT-055.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-055",


    },
    {
      name: "CATLA'S MONEY MACHINE",
      image: "../assets/newSlot/fc/FC-SLOT-056.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-056",


    },
    
     {
      name: "BAD RICH WOLF",
      image: "../assets/newSlot/fc/FC-SLOT-061.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-061",


    },
    {
      name: "GO GO RISE",
      image: "../assets/newSlot/fc/FC-EGAME-006.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-EGAME-006",


    },
      {
      name: "POKER WIN 2",
      image: "../assets/newSlot/fc/FC-SLOT-057.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-057",


    },
     {
      name: "SUGAR BANG BANG PLUS",
      image: "../assets/newSlot/fc/FC-SLOT-059.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-059",


    },
    {
      name: "MUSCLE FORTUNE CAT",
      image: "../assets/newSlot/fc/FC-SLOT-060.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-060",


    },
      {
      name: "SUPER ELEMENTS 2",
      image: "../assets/newSlot/fc/FC-SLOT-066.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-066",


    },
    {
      name: "OPEN VAULT",
      image: "../assets/newSlot/fc/FC-SLOT-064.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-064",


    },
    {
      name: "QUEEN OF INCA",
      image: "../assets/images/slot/fc/FC-SLOT-040.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-040",


    },
    {
      name: "DJ BOOM BOOM",
      image: "../assets/newSlot/fc/FC-SLOT-062.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-062",


    },
    {
      name: "GOLDEN PANTHER",
      image:
        "/assets/newSlot/FC0002.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-001",
    },
   
    {
      name: "THREE LITTLE PIGS",
      image:
        "/assets/newSlot/FC0003.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-002",
    },
    {
      name: "HOT POT PARTY",
      image:
        "/assets/newSlot/FC0004.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-003",
    },
    {
      name: "NIGHT MARKET",
      image:
        "/assets/newSlot/FC0005.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-004",
    },
    {
      name: "PONG PONG HU",
      image:
        "/assets/newSlot/FC0006.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-005",
    },
    {
      name: "PANDA DRAGON BOAT",
      image:
        "/assets/newSlot/FC0007.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-006",
    },
    {
      name: "CHINESE NEW YEAR",
      image:
        "/assets/newSlot/FC0008.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-007",
    },
    {
      name: "FORTUNE KOI",
      image:
        "/assets/newSlot/FC0009.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-008",
    },
    {
      name: "HAPPY DUO BAO",
      image:
        "/assets/newSlot/FC0010.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-009",
    },
    {
      name: "DA LE MEN",
      image:
        "/assets/newSlot/FC0011.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-010",
    },
    {
      name: "ANIMAL RACING",
      image:
        "/assets/newSlot/FC0012.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-011",
    },
    {
      name: "LUXURY GOLDEN PANTHER",
      image:
        "/assets/newSlot/FC0013.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-012",
    },
    {
      name: "MAGIC BEANS",
      image:
        "/assets/newSlot/FC0014.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-013",
    },
    {
      name: "COWBOYS",
      image:
        "/assets/newSlot/FC0015.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-014",
    },
    {
      name: "WAR OF THE UNIVERSE",
      image:
        "/assets/newSlot/FC0016.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-015",
    },
    {
      name: "TREASURE CRUISE",
      image:
        "/assets/newSlot/FC0017.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-016",
    },
    {
      name: "GOLD RUSH",
      image:
        "/assets/newSlot/FC0018.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-017",
    },
    {
      name: "RICH MAN",
      image:
        "/assets/newSlot/FC0019.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-018",
    },
    {
      name: "GLORY OF ROME",
      image:
        "/assets/newSlot/FC0020.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-019",
    },
    {
      name: "Robin Hood",
      image:
        "/assets/newSlot/FC0021.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-020",
    },
    {
      name: "Lucky Fortunes",
      image:
        "/assets/newSlot/FC0022.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-021",
    },
    {
      name: "CHINESE NEW YEAR 2",
      image:
        "/assets/newSlot/FC0023.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-022",
    },
    {
      name: "GRAND BLUE",
      image:
        "/assets/newSlot/FC0024.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-023",
    },
    {
      name: "TREASURE RAIDERS",
      image:
        "/assets/newSlot/FC0025.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-024",
    },
    {
      name: "SUGAR BANG BANG",
      image:
        "/assets/newSlot/FC0026.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-025",
    },
    {
      name: "CRAZY BUFFALO",
      image:
        "/assets/newSlot/FC0027.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-026",
    },
    {
      name: "MERGE MAGIC",
      image:
        "/assets/newSlot/FC0028.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-027",
    },
    {
      name: "GOLDEN GENIE",
      image:
        "/assets/newSlot/FC0029.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-028",
    },
    {
      name: "ZEUS",
      image:
        "/assets/newSlot/FC0030.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-029",
    },
    {
      name: "WIN WIN NEKO",
      image:
        "/assets/newSlot/FC0031.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-030",
    },
    {
      name: "FORTUNE EGG",
      image:
        "/assets/newSlot/FC0032.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-031",
    },
    {
      name: "NIGHT MARKET 2",
      image:
        "/assets/newSlot/FC0033.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-032",
    },
    {
      name: "SUPER ELEMENTS",
      image:
        "/assets/newSlot/FC0034.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-033",
    },
    {
      name: "LEGEND OF INCA",
      image:
        "/assets/newSlot/FC0035.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-034",
    },
    {
      name: "EGYPT BONANZA",
      image:
        "/assets/newSlot/FC0036.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-035",
    },
    {
      name: "CHILIHUAHUA",
      image:
        "/assets/newSlot/FC0037.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-036",
    },
    {
      name: "FORTUNE SHEEP",
      image:
        "/assets/newSlot/FC0038.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-037",
    },
    {
      name: "LUCKY FORTUNES 3x3",
      image:
        "/assets/newSlot/FC0039.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-038",
    },
    {
      name: "FORTUNE MONEY BOOM",
      image:
        "/assets/newSlot/FC0040.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-039",
    },
    {
      name: "FORTUNE GODDESS",
      image:
        "/assets/newSlot/FC0042.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-041",
    },
    {
      name: "ROMA GLADIATRIX",
      image:
        "/assets/newSlot/FC0043.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-042",
    },
    {
      name: "CHINESE NEW YEAR MOREWAYS",
      image:
        "/assets/newSlot/FC0059.avif",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-043",
    },
    {
      name: "POKER WIN",
      image:
        "/assets/newSlot/FC0045.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-044",
    },
    {
      name: "BOXING RICHES",
      image:
        "/assets/newSlot/FC0046.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-045",
    },
    {
      name: "SUGAR BANG BANG 2",
      image:
        "/assets/newSlot/FC0049.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-048",
    },
    {
      name: "PHOENIX FEVER",
      image:
        "/assets/newSlot/FC0051.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-050",
    },
    {
      name: "JUNGLE BANG BANG",
      image:
        "/assets/newSlot/FC0052.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-051",
    },
    {
      name: "TREASURES OF ODIN",
      image:
        "/assets/newSlot/FC0053.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-052",
    },
    {
      name: "SWORD OF KING",
      image:
        "/assets/newSlot/FC0054.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-053",
    },
    {
      name: "BUFFALO WAYS",
      image:
        "/assets/newSlot/FC0055.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "SLOT",
      casinoType: "FC-SLOT-054",
    },
  ],
  JDB: [
     {
    name: "Dragons Gate",
    image: "/assets/newSlot//JDB-SLOT-092.dragons_gate.webp?v=1767691445570",
    platformImage:"/assets/platformHeader/JDB-WHITE.webp",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-092",
  },
    {
    name: "BlossomOfWealth",
    image: "/assets/newSlot/JDB-SLOT-101.blossom_of_wealth.webp?v=1765263775132",
     platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
    platFormCode: "JDB",
    gameType: "SLOT",
    casinoType: "JDB-SLOT-101",
    
  },
    {
      name: "Llama Adventure",
      image:
        "/assets/newSlot/JDB002.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-013",
    },
    {
      name: "Formosa Bear",
      image:
        "/assets/newSlot/JDB003.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-014",
    },
    {
      name: "Open Sesame",
      image:
        "/assets/newSlot/JDB015.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-018",
    },
    {
      name: "Banana Saga",
      image:
        "/assets/newSlot/JDB016.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-019",
    },
    {
      name: "Olympian Temple",
      image:
        "/assets/newSlot/JDB018.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-020",
    },
    {
      name: "Rooster In Love",
      image:
        "/assets/newSlot/JDB070.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-026",
    },
    {
      name: "Moonlight Treasure",
      image:
        "/assets/newSlot/JDB010.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-028",
    },
    {
      name: "Billionaire",
      image:
        "/assets/newSlot/JDB045.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-031",
    },
    {
      name: "Dragon Warrior",
      image:
        "/assets/newSlot/JDB047.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-032",
    },
    {
      name: "Kingsman",
      image:
        "/assets/newSlot/JDB053.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-033",
    },
    {
      name: "Lucky Seven",
      image:
        "/assets/newSlot/JDB063.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-041",
    },
    {
      name: "Orient Animals",
      image:
        "/assets/newSlot/JDB064.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-042",
    },
    {
      name: "Triple King Kong",
      image:
        "/assets/newSlot/JDB065.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-043",
    },
    {
      name: "Napoleon",
      image:
        "/assets/newSlot/JDB013.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-048",
    },
    {
      name: "Open Sesame II",
      image:
        "/assets/newSlot/JDB036.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-051",
    },
    {
      name: "Fortune Horse",
      image:
        "/assets/newSlot/JDB038.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-053",
    },
    {
      name: "Xi Yang Yang",
      image:
        "/assets/newSlot/JDB039.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-054",
    },
    {
      name: "Birds Party",
      image:
        "/assets/newSlot/JDB066.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-066",
    },
    {
      name: "Go Lai Fu",
      image:
        "/assets/newSlot/JDB067.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-067",
    },
    {
      name: "Super Niubi",
      image:
        "/assets/newSlot/JDB069.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-070",
    },
    {
      name: "Fortune Treasure",
      image:
        "/assets/newSlot/JDB112.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-072",
    },
    {
      name: "Funky King Kong",
      image:
        "/assets/newSlot/JDB136.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-076",
    },
    {
      name: "Super Niubi Deluxe",
      image:
        "/assets/newSlot/JDB137.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-077",
    },
    {
      name: "Golden Disco",
      image:
        "/assets/newSlot/JDB140.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-084",
    },
    {
      name: "Miner Babe",
      image:
        "/assets/newSlot/JDB144.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-085",
    },
    {
      name: "Moneybags Man",
      image:
        "/assets/newSlot/JDB142.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-086",
    },
    {
      name: "Spindrift",
      image:
        "/assets/newSlot/JDB146.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-089",
    },
    {
      name: "Lucky Diamond",
      image:
        "/assets/newSlot/JDB150.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-093",
    },
    {
      name: "Kong",
      image:
        "/assets/newSlot/JDB153.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-094",
    },
    {
      name: "Wonder Elephant",
      image:
        "/assets/newSlot/JDB160.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-097",
    },
    {
      name: "Maya Gold Crazy",
      image:
        "/assets/newSlot/JDB162.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-099",
    },
    {
      name: "Prosperity Tiger",
      image:
        "/assets/newSlot/JDB170.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-100",
    },
    {
      name: "Glamorous Girl",
      image:
        "/assets/newSlot/JDB169.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-103",
    },
    {
      name: "Trump Card",
      image:
        "/assets/newSlot/JDB176.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-107",
    },
    {
      name: "Moneybags Man 2",
      image:
        "/assets/newSlot/JDB177.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-108",
    },
    {
      name: "Birds Party Deluxe",
      image:
        "/assets/newSlot/JDB180.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-109",
    },
    {
      name: "Elemental Link Fire",
      image:
        "/assets/newSlot/JDB181.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-110",
    },
    {
      name: "Elemental Link Water",
      image:
        "/assets/newSlot/JDB182.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-111",
    },
    {
      name: "Fruity Bonanza",
      image:
        "/assets/newSlot/JDB189.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-114",
    },
    {
      name: "Open Sesame Mega",
      image:
        "/assets/newSlot/JDB201.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-119",
    },
    {
      name: "Pop Pop Candy",
      image:
        "/assets/newSlot/JDB202.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-120",
    },
    {
      name: "Dragon Soar",
      image:
        "/assets/newSlot/JDB217.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-121",
    },
    {
      name: "Piggy Bank",
      image:
        "/assets/newSlot/JDB223.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-123",
    },
    {
      name: "Magic Ace",
      image:
        "/assets/newSlot/JDB221.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-124",
    },
    {
      name: "Dragon Soar - Hyper Wild",
      image:
        "/assets/newSlot/JDB222.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-125",
    },
    {
      name: "Magic Ace WILD LOCK",
      image:
        "/assets/newSlot/JDB225.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-127",
    },
    {
      name: "Fortune Jewel",
      image:
        "/assets/newSlot/JDB226.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-128",
    },
    {
      name: "Pop Pop Candy 1000",
      image:
        "/assets/newSlot/JDB229.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-129",
    },
    {
      name: "Fruity Bonanza Combo",
      image:
        "/assets/newSlot/JDB228.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-130",
    },
    {
      name: "Fishin' Fever X-Huge",
      image:
        "/assets/newSlot/JDB233.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-131",
    },
    {
      name: "Koi Trio",
      image:
        "/assets/newSlot/JDB235.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-132",
    },
    {
      name: "Olympig",
      image:
        "/assets/newSlot/JDB238.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "SLOT",
      casinoType: "JDB-SLOT-134",
    },
  ],
  RT: [
    {
      name: "Ancient Script",
      image:
        "/assets/newSlot/RT0008.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-001",
    },
    {
      name: "Arcade Bomb",
      image:
        "/assets/newSlot/RT0010.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-002",
    },
    {
      name: "Blue Diamond",
      image:
        "/assets/newSlot/RT0015.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-003",
    },
    {
      name: "Chinese Treasures",
      image:
        "/assets/newSlot/RT0020.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-004",
    },
    {
      name: "Cinderella's Ball",
      image:
        "/assets/newSlot/RT0021.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-005",
    },
    {
      name: "Crazy Genie",
      image:
        "/assets/newSlot/RT0024.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-006",
    },
    {
      name: "Devil's Number",
      image:
        "/assets/newSlot/RT0027.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-007",
    },
    {
      name: "Divine Ways",
      image:
        "/assets/newSlot/RT0030.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-008",
    },
    {
      name: "Dragon's Fire",
      image:
        "/assets/newSlot/RT0031.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-009",
    },
    {
      name: "Dragon's Luck",
      image:
        "/assets/newSlot/RT0034.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-010",
    },
    {
      name: "Dragon's Luck Power Reels",
      image:
        "/assets/newSlot/RT0037.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-011",
    },
    {
      name: "Elven Magic",
      image:
        "/assets/newSlot/RT0040.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-012",
    },
    {
      name: "Emerald Diamond",
      image:
        "/assets/newSlot/RT0041.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-013",
    },
    {
      name: "Epic Journey",
      image:
        "/assets/newSlot/RT0042.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-014",
    },
    {
      name: "Esqueleto Mariachi",
      image:
        "/assets/newSlot/RT0043.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-015",
    },
    {
      name: "Five Star",
      image:
        "/assets/newSlot/RT0044.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-016",
    },
    {
      name: "Five Star Power Reels",
      image:
        "/assets/newSlot/RT0045.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-017",
    },
    {
      name: "Flaming Fox",
      image:
        "/assets/newSlot/RT0046.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-018",
    },
    {
      name: "Fortune Charm",
      image:
        "/assets/newSlot/RT0047.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-019",
    },
    {
      name: "Fortune Fest",
      image:
        "/assets/newSlot/RT0048.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-020",
    },
    {
      name: "Fortune House",
      image:
        "/assets/newSlot/RT0049.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-021",
    },
    {
      name: "Fruit Blox",
      image:
        "/assets/newSlot/RT0050.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-022",
    },
    {
      name: "Gems Gone Wild",
      image:
        "/assets/newSlot/RT0052.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-023",
    },
    {
      name: "Gemtastic",
      image:
        "/assets/newSlot/RT0054.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-024",
    },
    {
      name: "God Of Wealth",
      image:
        "/assets/newSlot/RT0055.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-025",
    },
    {
      name: "Gold Star",
      image:
        "/assets/newSlot/RT0056.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-026",
    },
    {
      name: "Golden Lotus",
      image:
        "/assets/newSlot/RT0059.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-027",
    },
    {
      name: "Golden Offer",
      image:
        "/assets/newSlot/RT0060.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-028",
    },
    {
      name: "Grand Wheel",
      image:
        "/assets/newSlot/RT0064.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-029",
    },
    {
      name: "Imperial Palace",
      image:
        "/assets/newSlot/RT0066.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-030",
    },
    {
      name: "Jack In A Pot",
      image:
        "/assets/newSlot/RT0067.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-031",
    },
    {
      name: "Jackpot Quest",
      image:
        "/assets/newSlot/RT0068.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-032",
    },
    {
      name: "Jade Charms",
      image:
        "/assets/newSlot/RT0069.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-033",
    },
    {
      name: "Jester Spins",
      image:
        "/assets/newSlot/RT0070.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-034",
    },
    {
      name: "Jingle Bells",
      image:
        "/assets/newSlot/RT0072.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-035",
    },
    {
      name: "Laser Fruit",
      image:
        "/assets/newSlot/RT0074.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-036",
    },
    {
      name: "Lion Dance",
      image:
        "/assets/newSlot/RT0077.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-037",
    },
    {
      name: "Lucky Easter",
      image:
        "/assets/newSlot/RT0078.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-038",
    },
    {
      name: "Lucky Fortune Cat",
      image:
        "/assets/newSlot/RT0079.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-039",
    },
    {
      name: "Lucky Halloween",
      image:
        "/assets/newSlot/RT0081.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-040",
    },
    {
      name: "Lucky Valentine",
      image:
        "/assets/newSlot/RT0084.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-041",
    },
    {
      name: "Lucky Wizard",
      image:
        "/assets/newSlot/RT0085.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-042",
    },
    {
      name: "Magic Gate",
      image:
        "/assets/newSlot/RT0086.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-043",
    },
    {
      name: "Masquerade",
      image:
        "/assets/newSlot/RT0087.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-044",
    },
    {
      name: "Mayan Gods",
      image:
        "/assets/newSlot/RT0088.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-045",
    },
    {
      name: "Mega Jade",
      image:
        "/assets/newSlot/RT0090.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-046",
    },
    {
      name: "Mega Pyramid",
      image:
        "/assets/newSlot/RT0091.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-047",
    },
    {
      name: "Mega Rise",
      image:
        "/assets/newSlot/RT0092.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-048",
    },
    {
      name: "Midas Gold",
      image:
        "/assets/newSlot/RT0093.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-049",
    },
    {
      name: "Mystery Reels",
      image:
        "/assets/newSlot/RT0095.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-050",
    },
    {
      name: "Mystic Wheel",
      image:
        "/assets/newSlot/RT0098.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-052",
    },
    {
      name: "Ninja Ways",
      image:
        "/assets/newSlot/RT0099.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-053",
    },
    {
      name: "Ocean Fortune",
      image:
        "/assets/newSlot/RT0100.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-054",
    },
    {
      name: "Persian Fortune",
      image:
        "/assets/newSlot/RT0102.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-055",
    },
    {
      name: "Phoenix Fire Power Reels",
      image:
        "/assets/newSlot/RT0104.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-056",
    },
    {
      name: "Piggy Pirates",
      image:
        "/assets/newSlot/RT0105.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-057",
    },
    {
      name: "Puss'n Boots",
      image:
        "/assets/newSlot/RT0109.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-059",
    },
    {
      name: "Rainbow Jackpots",
      image:
        "/assets/newSlot/RT0111.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-060",
    },
    {
      name: "Ra's Legend",
      image:
        "/assets/newSlot/RT0110.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-061",
    },
    {
      name: "Reactor",
      image:
        "/assets/newSlot/RT0113.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-062",
    },
    {
      name: "Red Diamond",
      image:
        "/assets/newSlot/RT0114.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-063",
    },
    {
      name: "Phoenix",
      image:
        "/assets/newSlot/RT0103.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-064",
    },
    {
      name: "Reel Heist",
      image:
        "/assets/newSlot/RT0115.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-065",
    },
    {
      name: "Rocket Men",
      image:
        "/assets/newSlot/RT0122.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-066",
    },
    {
      name: "Royal Gems",
      image:
        "/assets/newSlot/RT0123.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-067",
    },
    {
      name: "Snow Wild And The 7 Features",
      image:
        "/assets/newSlot/RT0124.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-068",
    },
    {
      name: "Spin Town",
      image:
        "/assets/newSlot/RT0125.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-069",
    },
    {
      name: "Stage 888",
      image:
        "/assets/newSlot/RT0126.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-070",
    },
    {
      name: "Sumo Spins",
      image:
        "/assets/newSlot/RT0127.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-071",
    },
    {
      name: "Golden Temple",
      image:
        "/assets/newSlot/RT0061.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-072",
    },
    {
      name: "Ten Elements",
      image:
        "/assets/newSlot/RT0129.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-073",
    },
    {
      name: "The Equalizer",
      image:
        "/assets/newSlot/RT0130.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-074",
    },
    {
      name: "The Greatest Train Robbery",
      image:
        "/assets/newSlot/RT0131.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-075",
    },
    {
      name: "Thor's Lightning",
      image:
        "/assets/newSlot/RT0133.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-076",
    },
    {
      name: "Three Musketeers",
      image:
        "/assets/newSlot/RT0136.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-077",
    },
    {
      name: "Tiki Fruits",
      image:
        "/assets/newSlot/RT0137.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-078",
    },
    {
      name: "Totem Lightning",
      image:
        "/assets/newSlot/RT0138.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-079",
    },
    {
      name: "Totem Lightning Power Reels",
      image:
        "/assets/newSlot/RT0139.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-080",
    },
    {
      name: "Treasure Mine",
      image:
        "/assets/newSlot/RT0140.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-081",
    },
    {
      name: "Vicky Ventura",
      image:
        "/assets/newSlot/RT0144.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-082",
    },
    {
      name: "Wild Circus",
      image:
        "/assets/newSlot/RT0148.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-083",
    },
    {
      name: "Wild Fight",
      image:
        "/assets/newSlot/RT0150.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-084",
    },
    {
      name: "Wild Nords",
      image:
        "/assets/newSlot/RT0151.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-085",
    },
    {
      name: "Wild Spartans",
      image:
        "/assets/newSlot/RT0153.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-086",
    },
    {
      name: "Wild Wild Chest",
      image:
        "/assets/newSlot/RT0154.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-087",
    },
    {
      name: "Winter Wonders",
      image:
        "/assets/newSlot/RT0157.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-088",
    },
    {
      name: "Aztec Spins",
      image:
        "/assets/newSlot/RT0013.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-089",
    },
    {
      name: "Cash Volt",
      image:
        "/assets/newSlot/RT0019.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-090",
    },
    {
      name: "Dynamite Riches",
      image:
        "/assets/newSlot/RT0038.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-093",
    },
    {
      name: "Fruit Snap",
      image:
        "/assets/newSlot/RT0051.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-094",
    },
    {
      name: "Dice Dice Dice",
      image:
        "/assets/newSlot/RT0029.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-127",
    },
    {
      name: "Shah Mat",
      image:
        "/assets/newSlot/RT0177.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-128",
    },
    {
      name: "Cake and Ice Cream",
      image:
        "/assets/newSlot/RT0227.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-129",
    },
    {
      name: "Reel King Mega",
      image:
        "/assets/newSlot/RT0117.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-130",
    },
    {
      name: "Age Of Akkadia",
      image:
        "/assets/newSlot/RT0180.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-131",
    },
    {
      name: "Viral Spiral",
      image:
        "/assets/newSlot/RT0201.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-132",
    },
    {
      name: "Diamond Blitz",
      image:
        "/assets/newSlot/RT0028.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-133",
    },
    {
      name: "Crystal Mirror",
      image:
        "/assets/newSlot/RT0025.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-134",
    },
    {
      name: "Mystic Staxx",
      image:
        "/assets/newSlot/RT0164.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-135",
    },
    {
      name: "Hammer Gods",
      image:
        "/assets/newSlot/RT0186.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-136",
    },
    {
      name: "Peggy Sweets",
      image:
        "/assets/newSlot/RT0234.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-137",
    },
    {
      name: "Regal Streak",
      image:
        "/assets/newSlot/RT0119.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-138",
    },
    {
      name: "Tricks and Treats",
      image:
        "/assets/newSlot/RT0222.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-139",
    },
    {
      name: "Pirates' Plenty",
      image:
        "/assets/newSlot/RT0107.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-140",
    },
    {
      name: "Wings Of Ra",
      image:
        "/assets/newSlot/RT0156.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-141",
    },
    {
      name: "Bombuster",
      image:
        "/assets/newSlot/RT0016.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-143",
    },
    {
      name: "Cirque Dе La Fortune",
      image:
        "/assets/newSlot/RT0022.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-144",
    },
    {
      name: "Clash of the Beasts",
      image:
        "/assets/newSlot/RT0023.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-145",
    },
    {
      name: "Da Vinci's Mystery",
      image:
        "/assets/newSlot/RT0026.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-146",
    },
    {
      name: "Eagle Riches",
      image:
        "/assets/newSlot/RT0039.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-147",
    },
    {
      name: "Gems Gone Wild Power Reels",
      image:
        "/assets/newSlot/RT0053.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-148",
    },
    {
      name: "Golden Tsar",
      image:
        "/assets/newSlot/RT0062.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-150",
    },
    {
      name: "Hoard of Poseidon",
      image:
        "/assets/newSlot/RT0065.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-152",
    },
    {
      name: "Jewel Scarabs",
      image:
        "/assets/newSlot/RT0071.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-153",
    },
    {
      name: "Jingle Bells Power Reels",
      image:
        "/assets/newSlot/RT0073.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-154",
    },
    {
      name: "Legendary Excalibur",
      image:
        "/assets/newSlot/RT0076.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-155",
    },
    {
      name: "Lucky Fridays",
      image:
        "/assets/newSlot/RT0080.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-156",
    },
    {
      name: "Lucky Oktoberfest",
      image:
        "/assets/newSlot/RT0083.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-157",
    },
    {
      name: "Mystery Reels Power Reels",
      image:
        "/assets/newSlot/RT0097.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-158",
    },
    {
      name: "Reel Keeper",
      image:
        "/assets/newSlot/RT0116.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-160",
    },
    {
      name: "Regal Beasts",
      image:
        "/assets/newSlot/RT0118.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-161",
    },
    {
      name: "Riddle Of The Sphinx",
      image:
        "/assets/newSlot/RT0120.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-162",
    },
    {
      name: "Sylvan Spirits",
      image:
        "/assets/newSlot/RT0128.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-163",
    },
    {
      name: "The Wild Hatter",
      image:
        "/assets/newSlot/RT0132.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-164",
    },
    {
      name: "Thor's Vengeance",
      image:
        "/assets/newSlot/RT0134.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-165",
    },
    {
      name: "Trillionaire",
      image:
        "/assets/newSlot/RT0141.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-166",
    },
    {
      name: "Vault Cracker",
      image:
        "/assets/newSlot/RT0142.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-167",
    },
    {
      name: "War of Gods",
      image:
        "/assets/newSlot/RT0145.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-168",
    },
    {
      name: "Well Of Wishes",
      image:
        "/assets/newSlot/RT0146.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-169",
    },
    {
      name: "Yucatan's Mystery",
      image:
        "/assets/newSlot/RT0158.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-170",
    },
    {
      name: "Jingle Ways Megaways™",
      image:
        "/assets/newSlot/RT0191.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
    },
    {
      name: "Blazing Clusters",
      image:
        "/assets/newSlot/RT0192.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-172",
    },
    {
      name: "Hustling",
      image:
        "/assets/newSlot/RT0193.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-173",
    },
    {
      name: "Fa Fa Babies",
      image:
        "/assets/newSlot/RT0195.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-175",
    },
    {
      name: "Last Chance Saloon",
      image:
        "/assets/newSlot/RT0196.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-176",
    },
    {
      name: "Doggy Riches Megaways™",
      image:
        "/assets/newSlot/RT0197.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-177",
    },
    {
      name: "Genie Nights",
      image:
        "/assets/newSlot/RT0198.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-178",
    },
    {
      name: "Cash or Nothing",
      image:
        "/assets/newSlot/RT0202.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-179",
    },
    {
      name: "Bulls Run Wild",
      image:
        "/assets/newSlot/RT0204.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-180",
    },
    {
      name: "Mayhem",
      image:
        "/assets/newSlot/RT0205.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-181",
    },
    {
      name: "Big Cat Rescue Megaways™",
      image:
        "/assets/newSlot/RT0206.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-182",
    },
    {
      name: "Diamond Royale",
      image:
        "/assets/newSlot/RT0207.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-183",
    },
    {
      name: "Flodder",
      image:
        "/assets/newSlot/RT0208.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-184",
    },
    {
      name: "Risque Megaways™",
      image:
        "/assets/newSlot/RT0209.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-185",
    },
    {
      name: "Zaida's Fortune",
      image:
        "/assets/newSlot/RT0210.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-186",
    },
    {
      name: "Apache Way",
      image:
        "/assets/newSlot/RT0211.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-187",
    },
    {
      name: "Majestic Mysteries Power Reels™",
      image:
        "/assets/newSlot/RT0212.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-188",
    },
    {
      name: "Wild Tundra",
      image:
        "/assets/newSlot/RT0215.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-189",
    },
    {
      name: "Bass Boss",
      image:
        "/assets/newSlot/RT0217.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-190",
    },
    {
      name: "Rock'n'Lock",
      image:
        "/assets/newSlot/RT0218.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-191",
    },
    {
      name: "Gonzita's Quest",
      image:
        "/assets/newSlot/RT0219.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-192",
    },
    {
      name: "Great Gold",
      image:
        "/assets/newSlot/RT0220.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-193",
    },
    {
      name: "Mystery Reels Deluxe",
      image:
        "/assets/newSlot/RT0221.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-194",
    },
    {
      name: "Win Escalator",
      image:
        "/assets/newSlot/RT0155.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-195",
    },
    {
      name: "Lucky Little Devil",
      image:
        "/assets/newSlot/RT0082.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-196",
    },
    {
      name: "Three Kingdoms",
      image:
        "/assets/newSlot/RT0135.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-197",
    },
    {
      name: "Wild Elements",
      image:
        "/assets/newSlot/RT0149.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-198",
    },
    {
      name: "Wild O'Clock",
      image:
        "/assets/newSlot/RT0152.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-199",
    },
    {
      name: "Harle Coin",
      image:
        "/assets/newSlot/RT0162.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-200",
    },
    {
      name: "Joe Exotic",
      image:
        "/assets/newSlot/RT0163.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-201",
    },
    {
      name: "Night Roller",
      image:
        "/assets/newSlot/RT0165.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-202",
    },
    {
      name: "Primate King",
      image:
        "/assets/newSlot/RT0167.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-203",
    },
    {
      name: "Reptizillions Power Reels",
      image:
        "/assets/newSlot/RT0169.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-204",
    },
    {
      name: "Tiki Fruits Totem Frenzy",
      image:
        "/assets/newSlot/RT0170.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-205",
    },
    {
      name: "Neon Links",
      image:
        "/assets/newSlot/RT0172.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-207",
    },
    {
      name: "Wild Hot Chilli Reels",
      image:
        "/assets/newSlot/RT0173.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-208",
    },
    {
      name: "The Wisecracker Lightning",
      image:
        "/assets/newSlot/RT0174.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-209",
    },
    {
      name: "Treasure Mine Power Reels™",
      image:
        "/assets/newSlot/RT0175.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-210",
    },
    {
      name: "NFT Megaways™",
      image:
        "/assets/newSlot/RT0176.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-211",
    },
    {
      name: "Dynamite Riches MW + PowerWheel",
      image:
        "/assets/newSlot/RT0178.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-212",
    },
    {
      name: "Lion's Hoard",
      image:
        "/assets/newSlot/RT0183.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-215",
    },
    {
      name: "Fortune House Power Reels™",
      image:
        "/assets/newSlot/RT0184.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-216",
    },
    {
      name: "Beriched",
      image:
        "/assets/newSlot/RT0185.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-217",
    },
    {
      name: "Wild Expedition",
      image:
        "/assets/newSlot/RT0187.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-218",
    },
    {
      name: "Hot Hot Chilli Pot",
      image:
        "/assets/newSlot/RT0188.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-219",
    },
    {
      name: "Dracula Awakening",
      image:
        "/assets/newSlot/RT0189.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-220",
    },
    {
      name: "1942: Sky Warrior",
      image:
        "/assets/newSlot/RT0190.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-221",
    },
    {
      name: "Narcos Mexico",
      image:
        "/assets/newSlot/RT0200.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-222",
    },
    {
      name: "Robin Hood's Wild Forest",
      image:
        "/assets/newSlot/RT0214.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-223",
    },
    {
      name: "Stolen Treasures",
      image:
        "/assets/newSlot/RT0223.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-224",
    },
    {
      name: "Shadow Society",
      image:
        "/assets/newSlot/RT0224.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-225",
    },
    {
      name: "In the Rabbit Hole",
      image:
        "/assets/newSlot/RT0226.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-227",
    },
    {
      name: "Good Luck Clusterbuster™",
      image:
        "/assets/newSlot/RT0229.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-228",
    },
    {
      name: "Pinatas & Ponies",
      image:
        "/assets/newSlot/RT0230.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-229",
    },
    {
      name: "Cai Shen 168",
      image:
        "/assets/newSlot/RT0231.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-230",
    },
    {
      name: "Blood Suckers™ Megaways™",
      image:
        "/assets/newSlot/RT0232.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-231",
    },
    {
      name: "Ancient Disco",
      image:
        "/assets/newSlot/RT0233.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-232",
    },
    {
      name: "Happy Apples",
      image:
        "/assets/newSlot/RT0238.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-236",
    },
    {
      name: "Transylvanian: Night of Blood",
      image:
        "/assets/newSlot/RT0239.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-237",
    },
    {
      name: "Wrigley's World",
      image:
        "/assets/newSlot/RT0240.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-238",
    },
    {
      name: "Sheep Gone Wild",
      image:
        "/assets/newSlot/RT0241.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-239",
    },
    {
      name: "Reel Keeper Power Reels",
      image:
        "/assets/newSlot/RT0242.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-240",
    },
    {
      name: "Red Hot BBQ",
      image:
        "/assets/newSlot/RT0360.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-241",
    },
    {
      name: "Magic Powers Megaways",
      image:
        "/assets/newSlot/RT0359.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-242",
    },
    {
      name: "Knights Of Avalon",
      image:
        "/assets/newSlot/RT0353.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-243",
    },
    {
      name: "Wolfkin",
      image:
        "/assets/newSlot/RT0363.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-244",
    },
    {
      name: "Ali Baba's Luck",
      image:
        "/assets/newSlot/RT0336.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-247",
    },
    {
      name: "Christmas Morning",
      image:
        "/assets/newSlot/RT0432.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-250",
    },
    {
      name: "Christmas MULTIHOPS",
      image:
        "/assets/newSlot/RT0436.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-251",
    },
    {
      name: "Sea Boat Adventure",
      image:
        "/assets/newSlot/RT0434.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-252",
    },
    {
      name: "Astronaut",
      image:
        "/assets/newSlot/RT0463.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-253",
    },
    {
      name: "Bounty Raid 2",
      image:
        "/assets/newSlot/RT0451.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-254",
    },
    {
      name: "Case Closed",
      image:
        "/assets/newSlot/RT0449.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-255",
    },
    {
      name: "Easy Gold",
      image:
        "/assets/newSlot/RT0447.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-258",
    },
    {
      name: "Here Kitty Kitty",
      image:
        "/assets/newSlot/RT0453.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-262",
    },
    {
      name: "London Tube",
      image:
        "/assets/newSlot/RT0457.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-264",
    },
    {
      name: "Magic Tricks",
      image:
        "/assets/newSlot/RT0459.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-265",
    },
    {
      name: "Monsters Unchained",
      image:
        "/assets/newSlot/RT0455.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-266",
    },
    {
      name: "Sugar Monster",
      image:
        "/assets/newSlot/RT0366.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-267",
    },
    {
      name: "Hansel & Gretel Candyhouse",
      image:
        "/assets/newSlot/RT0368.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-270",
    },
    {
      name: "Siren's Riches",
      image:
        "/assets/newSlot/RT0371.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-271",
    },
    {
      name: "Spooky Carnival",
      image:
        "/assets/newSlot/RT0443.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-272",
    },
    {
      name: "Dragon's Mirror",
      image:
        "/assets/newSlot/RT0372.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-273",
    },
    {
      name: "Casino Spin",
      image:
        "/assets/newSlot/RT0341.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-275",
    },
    {
      name: "Cobra Queen",
      image:
        "/assets/newSlot/RT0343.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-276",
    },
    {
      name: "Cotton Gang Affair",
      image:
        "/assets/newSlot/RT0344.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-277",
    },
    {
      name: "Dream Destiny",
      image:
        "/assets/newSlot/RT0346.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-278",
    },
    {
      name: "Epic Treasure",
      image:
        "/assets/newSlot/RT0349.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-279",
    },
    {
      name: "Wanted Wildz",
      image:
        "/assets/newSlot/RT0362.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-280",
    },
    {
      name: "Sakura Masks",
      image:
        "/assets/newSlot/RT0380.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-283",
    },
    {
      name: "The Wild Kiss",
      image:
        "/assets/newSlot/RT0378.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-284",
    },
    {
      name: "Redline Rush",
      image:
        "/assets/newSlot/RT0377.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-285",
    },
    {
      name: "777 Super Strike",
      image:
        "/assets/newSlot/RT0375.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-286",
    },
    {
      name: "Clover Craze",
      image:
        "/assets/newSlot/RT0430.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-287",
    },
    {
      name: "Midnight Romance",
      image:
        "/assets/newSlot/RT0376.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-288",
    },
    {
      name: "Gold Mine Mistress",
      image:
        "/assets/newSlot/RT0392.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-289",
    },
    {
      name: "80s Spins",
      image:
        "/assets/newSlot/RT0334.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-290",
    },
    {
      name: "Ali Baba's Luck Megaways",
      image:
        "/assets/newSlot/RT0337.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-291",
    },
    {
      name: "Ali Baba's Luck Power Reels",
      image:
        "/assets/newSlot/RT0338.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-292",
    },
    {
      name: "Amazon Island Megaways",
      image:
        "/assets/newSlot/RT0339.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-293",
    },
    {
      name: "Asian Fortune",
      image:
        "/assets/newSlot/RT0340.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-294",
    },
    {
      name: "Chinese Wilds",
      image:
        "/assets/newSlot/RT0342.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-295",
    },
    {
      name: "Elephant Treasure",
      image:
        "/assets/newSlot/RT0348.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-298",
    },
    {
      name: "Fishtastic",
      image:
        "/assets/newSlot/RT0395.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-299",
    },
    {
      name: "Golden Lamps",
      image:
        "/assets/newSlot/RT0350.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-300",
    },
    {
      name: "Golden Toad",
      image:
        "/assets/newSlot/RT0351.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-301",
    },
    {
      name: "Leprechauns Magic Megaways",
      image:
        "/assets/newSlot/RT0355.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-302",
    },
    {
      name: "Leprechauns Magic Power Reels",
      image:
        "/assets/newSlot/RT0356.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-303",
    },
    {
      name: "Lucky Carnival",
      image:
        "/assets/newSlot/RT0357.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-304",
    },
    {
      name: "Serpent King",
      image:
        "/assets/newSlot/RT0481.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-348",
    },
    {
      name: "Bass Boss MegaWays™",
      image:
        "/assets/newSlot/RT0486.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-350",
    },
    {
      name: "Jackrabbit Jackpots",
      image:
        "/assets/newSlot/RT0492.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-356",
    },
    {
      name: "Farmtastic™",
      image:
        "/assets/newSlot/RT0490.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-357",
    },
    {
      name: "Gladiator Ways",
      image:
        "/assets/newSlot/RT0408.webp",
      platformImage:
        "/assets/platformHeader/RT-WHITE.webp",
      platFormCode: "RT",
      gameType: "SLOT",
      casinoType: "RT-SLOT-359",
    },
  ],

  BTG: [
    {
      name: "Apollo Pays",
      image:
        "/assets/newSlot/BTG023.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-001",
    },
    {
      name: "Castle of Terror",
      image:
        "/assets/newSlot/BTG021.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-002",
    },
    {
      name: "Rasputin Megaways",
      image:
        "/assets/newSlot/BTG022.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-003",
    },
    {
      name: "Bonanza",
      image:
        "/assets/newSlot/BTG002.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-004",
    },
    {
      name: "White Rabbit",
      image:
        "/assets/newSlot/BTG005.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-006",
    },
    {
      name: "Millionaire Megaways",
      image:
        "/assets/newSlot/BTG006.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-007",
    },
    {
      name: "Golden Catch",
      image:
        "/assets/newSlot/BTG007.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-008",
    },
    {
      name: "Danger High Voltage",
      image:
        "/assets/newSlot/BTG008.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-009",
    },
    {
      name: "Christmas Bonanza",
      image:
        "/assets/newSlot/BTG003.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-010",
    },
    {
      name: "Gifts of Fortune",
      image:
        "/assets/newSlot/BTG009.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-011",
    },
    {
      name: "The Race",
      image:
        "/assets/newSlot/BTG010.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-012",
    },
    {
      name: "Vegas Rush",
      image:
        "/assets/newSlot/BTG024.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-014",
    },
    {
      name: "Beef Lightning",
      image:
        "/assets/newSlot/BTG025.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-015",
    },
    {
      name: "Gold Megaways",
      image:
        "/assets/newSlot/BTG026.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-016",
    },
    {
      name: "Big Bad Bison",
      image:
        "/assets/newSlot/BTG081.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-017",
    },
    {
      name: "Millionaire Rush",
      image:
        "/assets/newSlot/BTG079.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-018",
    },
    {
      name: "Royal Mint",
      image:
        "/assets/newSlot/BTG038.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-020",
    },
    {
      name: "Christmas Catch",
      image:
        "/assets/newSlot/BTG036.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-021",
    },
    {
      name: "Bonanza Falls",
      image:
        "/assets/newSlot/BTG040.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-022",
    },
    {
      name: "Outlaw",
      image:
        "/assets/newSlot/BTG075.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-023",
    },
    {
      name: "Vegas Megaways",
      image:
        "/assets/newSlot/BTG077.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-024",
    },
    {
      name: "Star Clusters",
      image:
        "/assets/newSlot/BTG071.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-025",
    },
    {
      name: "Wild Portals",
      image:
        "/assets/newSlot/BTG073.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-026",
    },
    {
      name: "Max Megaways 2",
      image:
        "/assets/newSlot/BTG027.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-027",
    },
    {
      name: "Pirate Pays",
      image:
        "/assets/newSlot/BTG029.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-029",
    },
    {
      name: "Wild Flower",
      image:
        "/assets/newSlot/BTG030.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-030",
    },
    {
      name: "Pop",
      image:
        "/assets/newSlot/BTG031.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-031",
    },
    {
      name: "Kingmaker Fully Loaded",
      image:
        "/assets/newSlot/BTG047.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-032",
    },
    {
      name: "Wild Unicorns",
      image:
        "/assets/newSlot/BTG068.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-033",
    },
    {
      name: "Diamond Fruits",
      image:
        "/assets/newSlot/BTG033.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-034",
    },
    {
      name: "Donuts",
      image:
        "/assets/newSlot/BTG034.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-035",
    },
    {
      name: "Lil Devil",
      image:
        "/assets/newSlot/BTG035.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-036",
    },
    {
      name: "Opal Fruits",
      image:
        "/assets/newSlot/BTG066.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-038",
    },
    {
      name: "Sanctuary",
      image:
        "/assets/newSlot/BTG064.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-039",
    },
    {
      name: "Panda Money",
      image:
        "/assets/newSlot/BTG043.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-040",
    },
    {
      name: "Fireworks Megaways",
      image:
        "/assets/newSlot/BTG048.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-041",
    },
    {
      name: "The Final Countdown",
      image:
        "/assets/newSlot/BTG050.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-042",
    },
    {
      name: "Spicy Meatballs",
      image:
        "/assets/newSlot/BTG049.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-043",
    },
    {
      name: "Chocolates",
      image:
        "/assets/newSlot/BTG042.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-044",
    },
    {
      name: "King of Cats",
      image:
        "/assets/newSlot/BTG041.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-045",
    },
    {
      name: "More Turkey",
      image:
        "/assets/newSlot/BTG032.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-046",
    },
    {
      name: "Trigger Happy",
      image:
        "/assets/newSlot/BTG054.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-047",
    },
    {
      name: "Lucky Streak Mk2",
      image:
        "/assets/newSlot/BTG045.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-048",
    },
    {
      name: "Cyberslot Megaclusters",
      image:
        "/assets/newSlot/BTG044.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-049",
    },
    {
      name: "Fizzy Pennyslot",
      image:
        "/assets/newSlot/BTG051.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-050",
    },
    {
      name: "Holy Diver Megaways",
      image:
        "/assets/newSlot/BTG053.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-051",
    },
    {
      name: "Millionaire Mystery Box",
      image:
        "/assets/newSlot/BTG052.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-052",
    },
    {
      name: "Book of Gods",
      image:
        "/assets/newSlot/BTG055.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-053",
    },
    {
      name: "Boo",
      image:
        "/assets/newSlot/BTG056.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-054",
    },
    {
      name: "Queen of Riches",
      image:
        "/assets/newSlot/BTG057.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-055",
    },
    {
      name: "Golden Goose Megaways",
      image:
        "/assets/newSlot/BTG060.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-057",
    },
    {
      name: "Burgers",
      image:
        "/assets/newSlot/BTG083.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-058",
    },
    {
      name: "Temple Quest Spinfinity",
      image:
        "/assets/newSlot/BTG085.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-059",
    },
    {
      name: "Big Bucks Deluxe",
      image:
        "/assets/newSlot/BTG090.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-061",
    },
    {
      name: "Dragon Born",
      image:
        "/assets/newSlot/BTG059.webp",
      platformImage:
        "/assets/platformHeader/BTG-WHITE.webp",
      platFormCode: "BTG",
      gameType: "SLOT",
      casinoType: "BTG-SLOT-067",
    },
  ],
  FASTSPIN: [
    {
      name: "Royale House",
      image:
        "/assets/newSlot/FS0030.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-001",
    },
    {
      name: "Sexy Vegas",
      image:
        "/assets/newSlot/FS0041.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-002",
    },
    {
      name: "Roma",
      image:
        "/assets/newSlot/FS0032.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-003",
    },
    {
      name: "Gold Rush Cowboy",
      image:
        "/assets/newSlot/FS0008.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-004",
    },
    {
      name: "Wild Wet Win",
      image:
        "/assets/newSlot/FS0042.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-005",
    },
    {
      name: "Royal Katt",
      image:
        "/assets/newSlot/FS0031.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-006",
    },
    {
      name: "Rich Caishen",
      image:
        "/assets/newSlot/FS0029.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-007",
    },
    {
      name: "Muay Thai Fighter",
      image:
        "/assets/newSlot/FS0024.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-008",
    },
    {
      name: "Poker Ways",
      image:
        "/assets/newSlot/FS0028.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-009",
    },
    {
      name: "Triple Happiness",
      image:
        "/assets/newSlot/FS0038.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-010",
    },
    {
      name: "Lucky Fortune",
      image:
        "/assets/newSlot/FS0016.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-011",
    },
    {
      name: "Fruits Mania",
      image:
        "/assets/newSlot/FS0005.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-012",
    },
    {
      name: "Fiery Lava",
      image:
        "/assets/newSlot/FS0003.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-013",
    },
    {
      name: "Neon Fantasy",
      image:
        "/assets/newSlot/FS0025.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-016",
    },
    {
      name: "Space Conquest",
      image:
        "/assets/newSlot/FS0035.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-017",
    },
    {
      name: "Loki",
      image:
        "/assets/newSlot/FS0018.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-018",
    },
    {
      name: "Fortune Lions",
      image:
        "/assets/newSlot/FS0004.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-019",
    },
    {
      name: "Honey Trap",
      image:
        "/assets/newSlot/FS0013.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-020",
    },
    {
      name: "Oceanic Melodies",
      image:
        "/assets/newSlot/FS0027.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-021",
    },
    {
      name: "The Maya Myth",
      image:
        "/assets/newSlot/FS0022.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-022",
    },
    {
      name: "Spin and Win",
      image:
        "/assets/newSlot/FS0037.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-023",
    },
    {
      name: "Safari Blitz",
      image:
        "/assets/newSlot/FS0034.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-024",
    },
    {
      name: "Goddess Of Egypt",
      image:
        "/assets/newSlot/FS0006.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-025",
    },
    {
      name: "Heavenly Fortunes 2",
      image:
        "/assets/newSlot/FS0012.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-026",
    },
    {
      name: "Ganesha Luck",
      image:
        "/assets/newSlot/FS0007.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-027",
    },
    {
      name: "Heavenly Fortunes",
      image:
        "/assets/newSlot/FS0011.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-028",
    },
    {
      name: "Mining Bonanza",
      image:
        "/assets/newSlot/FS0019.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-029",
    },
    {
      name: "The Nutcrackers",
      image:
        "/assets/newSlot/FS0039.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-030",
    },
    {
      name: "Legend of Nian",
      image:
        "/assets/newSlot/FS0017.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-031",
    },
    {
      name: "The Great Safari",
      image:
        "/assets/newSlot/FS0009.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-032",
    },
    {
      name: "Tiki Rush",
      image:
        "/assets/newSlot/FS0040.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-033",
    },
    {
      name: "Neko Riches",
      image:
        "/assets/newSlot/FS0026.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-034",
    },
    {
      name: "Mighty Sevens",
      image:
        "/assets/newSlot/FS0023.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-035",
    },
    {
      name: "Mushroom Bandit",
      image:
        "/assets/newSlot/FS0020.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-036",
    },
    {
      name: "City of Jewels",
      image:
        "/assets/newSlot/FS0002.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-037",
    },
    {
      name: "Sweet Frenzy",
      image:
        "/assets/newSlot/FS0036.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-038",
    },
    {
      name: "Leprechaun Bonanza",
      image:
        "/assets/newSlot/FS0014.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-039",
    },
    {
      name: "Money Empire",
      image:
        "/assets/newSlot/FS0021.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-040",
    },
    {
      name: "Yeti Boom",
      image:
        "/assets/newSlot/FS0043.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-041",
    },
    {
      name: "Ranger Showdown",
      image:
        "/assets/newSlot/FS0033.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-042",
    },
    {
      name: "Money Dragon",
      image:
        "/assets/newSlot/FS0044.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-043",
    },
    {
      name: "Caribbean Riches",
      image:
        "/assets/newSlot/FS0046.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-046",
    },
    {
      name: "Mahjong Princess",
      image:
        "/assets/newSlot/FS0047.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-047",
    },
    {
      name: "Pai Gow Ways",
      image:
        "/assets/newSlot/FS0050.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-048",
    },
    {
      name: "Beasts Of Luck",
      image:
        "/assets/newSlot/FS0052.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-052",
    },
    {
      name: "Snake Treasure",
      image:
        "/assets/newSlot/FS0054.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-054",
    },
    {
      name: "Alien Smash",
      image:
        "/assets/newSlot/FS0053.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-055",
    },
    {
      name: "Wild Mafia",
      image:
        "/assets/newSlot/FS0051.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-056",
    },
    {
      name: "Blade of Fortune",
      image:
        "/assets/newSlot/FS0055.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "SLOT",
      casinoType: "FastSpin-SLOT-057",
    },
  ],
  DRAGONSOFT: [
    {
      name: "Great Lion",
      image: "/assets/newSlot/DS001.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-013",
    },
    {
      name: "777",
      image: "/assets/newSlot/DS002.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-003",
    },
    {
      name: "Wonderful Christmas",
      image: "/assets/newSlot/DS003.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-072",
    },
    {
      name: "Golf",
      image: "/assets/newSlot/DS005.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-026",
    },
    {
      name: "Pirate King",
      image: "/assets/newSlot/DS006.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-010",
    },
    {
      name: "Farm Family",
      image: "/assets/newSlot/DS007.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-051",
    },
    {
      name: "Big Diamond",
      image: "/assets/newSlot/DS008.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-053",
    },
    {
      name: "Dancing Samba",
      image: "/assets/newSlot/DS009.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-078",
    },
    {
      name: "Bounty Clash",
      image: "/assets/newSlot/DS010.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-084",
    },
    {
      name: "Fushen Coming",
      image: "/assets/newSlot/DS014.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-037",
    },
    {
      name: "Coin Cat",
      image: "/assets/newSlot/DS015.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-001",
    },
    {
      name: "Diamond Mogul",
      image: "/assets/newSlot/DS016.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-011",
    },
    {
      name: "T-Rex",
      image: "/assets/newSlot/DS017.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-031",
    },
    {
      name: "Jin Houye",
      image: "/assets/newSlot/DS018.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-036",
    },
    {
      name: "Phoenix",
      image: "/assets/newSlot/DS019.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-002",
    },
    {
      name: "Over Drangon's Gate",
      image: "/assets/newSlot/DS020.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-012",
    },
    {
      name: "Rich Lion",
      image: "/assets/newSlot/DS021.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-018",
    },
    {
      name: "Midas Touch",
      image: "/assets/newSlot/DS022.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-033",
    },
    {
      name: "Fortune Twins",
      image: "/assets/newSlot/DS023.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-077",
    },
    {
      name: "Wolf Legend",
      image: "/assets/newSlot/DS025.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-024",
    },
    {
      name: "Zeus",
      image: "/assets/newSlot/DS026.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-028",
    },
    {
      name: "Neko Treasures",
      image: "/assets/newSlot/DS027.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-089",
    },
    {
      name: "Maya King",
      image: "/assets/newSlot/DS029.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-009",
    },
    {
      name: "Buffalo Burst",
      image: "/assets/newSlot/DS030.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-065",
    },
    {
      name: "Grand Sheriff",
      image: "/assets/newSlot/DS031.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-068",
    },
    {
      name: "Volcanic Legend",
      image: "/assets/newSlot/DS032.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-086",
    },
    {
      name: "Zhen Long Ju Bao",
      image: "/assets/newSlot/DS033.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-083",
    },
    {
      name: "Get High",
      image: "/assets/newSlot/DS034.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-022",
    },
    {
      name: "Tiger Lord",
      image: "/assets/newSlot/DS035.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-027",
    },
    {
      name: "Immortal Heroes",
      image: "/assets/newSlot/DS036.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-045",
    },
    {
      name: "Chicken Dinner",
      image: "/assets/newSlot/DS037.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-050",
    },
    {
      name: "Egypt Dynasty",
      image: "/assets/newSlot/DS038.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-055",
    },
    {
      name: "Candy Dynasty",
      image: "/assets/newSlot/DS040.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-017",
    },
    {
      name: "Booming Gems",
      image: "/assets/newSlot/DS041.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-042",
    },
    {
      name: "Ultra Treasure",
      image: "/assets/newSlot/DS045.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-014",
    },
    {
      name: "Rich Dragon",
      image: "/assets/newSlot/DS046.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-035",
    },
    {
      name: "Bust Treasury",
      image: "/assets/newSlot/DS047.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-020",
    },
    {
      name: "Zhao Yun",
      image: "/assets/newSlot/DS048.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-040",
    },
    {
      name: "Mahjong Win",
      image: "/assets/newSlot/DS049.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-075",
    },
    {
      name: "Golf2",
      image: "/assets/newSlot/DS050.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-073",
    },
    {
      name: "5 God Beast",
      image: "/assets/newSlot/DS052.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-021",
    },
    {
      name: "Coin Rat",
      image: "/assets/newSlot/DS053.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-046",
    },
    {
      name: "King's Sword",
      image: "/assets/newSlot/DS054.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-070",
    },
    {
      name: "Overlord & Concubine",
      image: "/assets/newSlot/DS055.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-069",
    },
    {
      name: "Monkey King",
      image: "/assets/newSlot/DS056.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-019",
    },
    {
      name: "Lu Ling Qi",
      image: "/assets/newSlot/DS057.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-041",
    },
    {
      name: "Many Beauties",
      image: "/assets/newSlot/DS058.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-043",
    },
    {
      name: "Get Money",
      image: "/assets/newSlot/DS059.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-004",
    },
    {
      name: "Bakufu Shogun",
      image: "/assets/newSlot/DS060.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-062",
    },
    {
      name: "Midas Hand",
      image: "/assets/newSlot/DS061.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-079",
    },
    {
      name: "Lucky Bunny",
      image: "/assets/newSlot/DS062.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-085",
    },
    {
      name: "Doggy Wealth",
      image: "/assets/newSlot/DS064.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-007",
    },
    {
      name: "Ore Power",
      image: "/assets/newSlot/DS065.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-047",
    },
    {
      name: "Icy Bar",
      image: "/assets/newSlot/DS066.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-048",
    },
    {
      name: "Roman",
      image: "/assets/newSlot/DS067.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-052",
    },
    {
      name: "Rich Ox",
      image: "/assets/newSlot/DS068.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-059",
    },
    {
      name: "Dracula",
      image: "/assets/newSlot/DS071.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-008",
    },
    {
      name: "Super Hoo Hey How",
      image: "/assets/newSlot/DS072.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-076",
    },
    {
      name: "Diamond 7",
      image: "/assets/newSlot/DS074.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-060",
    },
    {
      name: "Party Night",
      image: "/assets/newSlot/DS075.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-071",
    },
    {
      name: "Odin Territory",
      image: "/assets/newSlot/DS076.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-082",
    },
    {
      name: "Crystal Fruits",
      image: "/assets/newSlot/DS077.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-025",
    },
    {
      name: "Greatest Circus",
      image: "/assets/newSlot/DS078.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-032",
    },
    {
      name: "Dragon's Treasure",
      image: "/assets/newSlot/DS079.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-056",
    },
    {
      name: "Dragonburst",
      image: "/assets/newSlot/DS080.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-064",
    },
    {
      name: "Much Richer",
      image: "/assets/newSlot/DS081.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-081",
    },
    {
      name: "Caishen Coming",
      image: "/assets/newSlot/DS083.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-016",
    },
    {
      name: "Arab",
      image: "/assets/newSlot/DS084.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-023",
    },
    {
      name: "Fire Ball Blaze Phoenix",
      image: "/assets/newSlot/DS085.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-080",
    },
    {
      name: "Egypt Oracle",
      image: "/assets/newSlot/DS087.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-015",
    },
    {
      name: "Fruits Bar",
      image: "/assets/newSlot/DS088.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-034",
    },
    {
      name: "Worldie",
      image: "/assets/newSlot/DS089.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-067",
    },
    {
      name: "Triple Monkey",
      image: "/assets/newSlot/DS091.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-039",
    },
    {
      name: "Muay Thai",
      image: "/assets/newSlot/DS092.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-054",
    },
    {
      name: "You Will Win",
      image: "/assets/newSlot/DS093.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-057",
    },
    {
      name: "Roll in Money",
      image: "/assets/newSlot/DS094.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-066",
    },
    {
      name: "Pandaria",
      image: "/assets/newSlot/DS099.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-038",
    },
    {
      name: "Red Dragon’s Treasure",
      image: "/assets/newSlot/DS101.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-087",
    },
    {
      name: "Rich Now",
      image: "/assets/newSlot/DS106.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-005",
    },
    {
      name: "Chef Lady",
      image: "/assets/newSlot/DS107.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-006",
    },
    {
      name: "Bengal Tiger",
      image: "/assets/newSlot/DS108.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-063",
    },
    {
      name: "Halloween Win",
      image: "/assets/newSlot/DS109.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-074",
    },
    {
      name: "More Beauties",
      image: "/assets/newSlot/DS111.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-044",
    },
    {
      name: "Bonus Cat",
      image: "/assets/newSlot/DS112.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-061",
    },
    {
      name: "Mahjong Win 2",
      image: "/assets/newSlot/DS113.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-088",
    },
    {
      name: "Golden Eye",
      image: "/assets/newSlot/DS114.webp",
      platformImage: "/assets/platformHeader/dragoon.webp",
      platFormCode: "DRAGOONSOFT",
      gameType: "SLOT",
      casinoType: "DRAGOONSOFT-SLOT-049",
    },
  ],

  ILOVEU: [
    {
      name: "Jungle",
      image: "/assets/newSlot/ILU01.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-001",
    },
    {
      name: "Crazy Monkey",
      image: "/assets/newSlot/ILU02.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-002",
    },
    {
      name: "Qin",
      image: "/assets/newSlot/ILU03.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-003",
    },
    {
      name: "Ocean",
      image: "/assets/newSlot/ILU04.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-004",
    },
    {
      name: "Pyramid",
      image: "/assets/newSlot/ILU05.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-005",
    },
    {
      name: "Pirate Ship",
      image: "/assets/newSlot/ILU06.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-006",
    },
    {
      name: "Sango",
      image: "/assets/newSlot/ILU07.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-008",
    },
    {
      name: "Christmas",
      image: "/assets/newSlot/ILU08.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-009",
    },
    {
      name: "Aladdin",
      image: "/assets/newSlot/ILU09.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-010",
    },
    {
      name: "White Snake",
      image: "/assets/newSlot/ILU10.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-011",
    },
    {
      name: "Thai Paradise",
      image: "/assets/newSlot/ILU11.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-012",
    },
    {
      name: "Sparta",
      image: "/assets/newSlot/ILU13.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-014",
    },
    {
      name: "God Of Fortune",
      image: "/assets/newSlot/ILU14.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-015",
    },
    {
      name: "Safari Heat",
      image: "/assets/newSlot/ILU15.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-016",
    },
    {
      name: "Panther Moon",
      image: "/assets/newSlot/ILU16.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-017",
    },
    {
      name: "Great Blue",
      image: "/assets/newSlot/ILU17.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-018",
    },
    {
      name: "Beans Talk",
      image: "/assets/newSlot/ILU18.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-020",
    },
    {
      name: "Money Bang Bang",
      image: "/assets/newSlot/ILU19.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-021",
    },
    {
      name: "Dolphin Reef",
      image: "/assets/newSlot/ILU20.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-022",
    },
    {
      name: "Three Kingdoms",
      image: "/assets/newSlot/ILU21.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-023",
    },
    {
      name: "A Night Out",
      image: "/assets/newSlot/ILU22.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-024",
    },
    {
      name: "Golden Lotus",
      image: "/assets/newSlot/ILU23.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-025",
    },
    {
      name: "Penguin Vacation",
      image: "/assets/newSlot/ILU24.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-026",
    },
    {
      name: "Highway Kings JP",
      image: "/assets/newSlot/ILU25.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-027",
    },
    {
      name: "Robin Hood",
      image: "/assets/newSlot/ILU26.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-028",
    },
    {
      name: "Monkey King slot",
      image: "/assets/newSlot/ILU27.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-029",
    },
    {
      name: "God Of Wealth2",
      image: "/assets/newSlot/ILU28.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-030",
    },
    {
      name: "Fortune Panda",
      image: "/assets/newSlot/ILU29.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-031",
    },
    {
      name: "Hercules",
      image: "/assets/newSlot/ILU30.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-032",
    },
    {
      name: "Queen",
      image: "/assets/newSlot/ILU31.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-033",
    },
    {
      name: "African Wildilfe",
      image: "/assets/newSlot/ILU32.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-034",
    },
    {
      name: "Laura",
      image: "/assets/newSlot/ILU33.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-035",
    },
    {
      name: "Seasons Greetings",
      image: "/assets/newSlot/ILU34.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-036",
    },
    {
      name: "Fortune God",
      image: "/assets/newSlot/ILU36.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-039",
    },
    {
      name: "Dragon Fortune",
      image: "/assets/newSlot/ILU37.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-040",
    },
    {
      name: "Beer Party",
      image: "/assets/newSlot/ILU38.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-041",
    },
    {
      name: "Legend Of Nezha",
      image: "/assets/newSlot/ILU39.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-042",
    },
    {
      name: "Fortune Fuwa",
      image: "/assets/newSlot/ILU40.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-043",
    },
    {
      name: "Fortune Tiger",
      image: "/assets/newSlot/ILU41.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-044",
    },
    {
      name: "Master Ninja",
      image: "/assets/newSlot/ILU43.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-063",
    },
    {
      name: "Ocean Quest",
      image: "/assets/newSlot/ILU44.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-060",
    },
    {
      name: "Gold Train",
      image: "/assets/newSlot/ILU45.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-059",
    },
    {
      name: "Storm Estate",
      image: "/assets/newSlot/ILU46.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-050",
    },
    {
      name: "Assassin",
      image: "/assets/newSlot/ILU47.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-049",
    },
    {
      name: "Queen Of Egypt",
      image: "/assets/newSlot/ILU48.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-045",
    },
    {
      name: "Might Of Zeus",
      image: "/assets/newSlot/ILU50.webp",
      platformImage: "/assets/platformHeader/iloveu.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-046",
    },
  ],
  NETENT: [
    {
      name: "Fruit Shop Frenzy",
      image: "/assets/newSlot/NE001.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-200",
    },
    {
      name: "Blood Suckers",
      image: "/assets/newSlot/NE003.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-042",
    },
    {
      name: "Blood Suckers™",
      image: "/assets/newSlot/NE004.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-046",
    },
    {
      name: "Butterfly Staxx 2™",
      image: "/assets/newSlot/NE005.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-070",
    },
    {
      name: "Butterfly Staxx™",
      image: "/assets/newSlot/NE006.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-047",
    },
    {
      name: "Cash Noire™",
      image: "/assets/newSlot/NE007.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-095",
    },
    {
      name: "Cash-o-Matic™",
      image: "/assets/newSlot/NE008.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-092",
    },
    {
      name: "Casino Hold'em",
      image: "/assets/newSlot/NE009.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-088",
    },
    {
      name: "Codex of Fortune™",
      image: "/assets/newSlot/NE010.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-056",
    },
    {
      name: "French Roulette",
      image: "/assets/newSlot/NE011.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-066",
    },
    {
      name: "Funk Master™",
      image: "/assets/newSlot/NE012.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-126",
    },
    {
      name: "Creature from the Black Lagoon™",
      image: "/assets/newSlot/NE013.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-083",
    },
    {
      name: "Dark King: Forbidden Riches™",
      image: "/assets/newSlot/NE014.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-004",
    },
    {
      name: "Dazzle Me™ Megaways™",
      image: "/assets/newSlot/NE015.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-076",
    },
    {
      name: "Dazzle Me™",
      image: "/assets/newSlot/NE016.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-024",
    },
    {
      name: "Dead or Alive 2™",
      image: "/assets/newSlot/NE017.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-019",
    },
    {
      name: "Dead or Alive 2™ Feature Buy",
      image: "/assets/newSlot/NE018.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-005",
    },
    {
      name: "Dead or Alive™",
      image: "/assets/newSlot/NE019.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-026",
    },
    {
      name: "Disco Danny™",
      image: "/assets/newSlot/NE020.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-096",
    },
    {
      name: "Divine Fortune™ Megaways™",
      image: "/assets/newSlot/NE021.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-014",
    },
    {
      name: "Double Stacks™",
      image: "/assets/newSlot/NE022.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-077",
    },
    {
      name: "Gem Crush™",
      image: "/assets/newSlot/NE024.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-201",
    },
    {
      name: "Dracula™",
      image: "/assets/newSlot/NE025.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-002",
    },
    {
      name: "Drive: Multiplier Mayhem™",
      image: "/assets/newSlot/NE026.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-067",
    },
    {
      name: "Fruit Shop Christmas Edition™",
      image: "/assets/newSlot/NE027.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-048",
    },
    {
      name: "Ghost Pirates™",
      image: "/assets/newSlot/NE028.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-141",
    },
    {
      name: "Fruit Shop™ Megaways™",
      image: "/assets/newSlot/NE029.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-040",
    },
    {
      name: "Go Bananas!",
      image: "/assets/newSlot/NE030.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-163",
    },
    {
      name: "Fruit Shop™",
      image: "/assets/newSlot/NE031.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-013",
    },
    {
      name: "Golden Grimoire™",
      image: "/assets/newSlot/NE032.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-124",
    },
    {
      name: "Fruit Spin™",
      image: "/assets/newSlot/NE033.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-062",
    },
    {
      name: "Good Old 7's",
      image: "/assets/newSlot/NE034.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-194",
    },
    {
      name: "Gods Of Gold: InfiniReels™",
      image: "/assets/newSlot/NE035.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-084",
    },
    {
      name: "Happy Riches™",
      image: "/assets/newSlot/NE036.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-152",
    },
    {
      name: "Gonzo’s Gold™",
      image: "/assets/newSlot/NE037.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-119",
    },
    {
      name: "Hook's Heroes",
      image: "/assets/newSlot/NE038.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-164",
    },
    {
      name: "Gonzo's Quest™",
      image: "/assets/newSlot/NE039.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-009",
    },
    {
      name: "Jack and the Beanstalk Remastered",
      image: "/assets/newSlot/NE040.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-180",
    },
    {
      name: "East Sea Dragon King™",
      image: "/assets/newSlot/NE041.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-154",
    },
    {
      name: "Gordon Ramsay Hell’s Kitchen",
      image: "/assets/newSlot/NE042.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-039",
    },
    {
      name: "Jack Hammer™ 3: Diamond Affair",
      image: "/assets/newSlot/NE043.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-188",
    },
    {
      name: "Gorilla Kingdom™",
      image: "/assets/newSlot/NE044.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-053",
    },
    {
      name: "Jelly Belly Megaways",
      image: "/assets/newSlot/NE045.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-183",
    },
    {
      name: "Grand Spinn™",
      image: "/assets/newSlot/NE046.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-094",
    },
    {
      name: "Jingle Bells Bonanza™",
      image: "/assets/newSlot/NE047.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-202",
    },
    {
      name: "King of 3 Kingdoms™",
      image: "/assets/newSlot/NE049.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-142",
    },
    {
      name: "Halloween Jack™",
      image: "/assets/newSlot/NE050.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-093",
    },
    {
      name: "Let It Burn",
      image: "/assets/newSlot/NE051.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-134",
    },
    {
      name: "Hansel and Gretel™",
      image: "/assets/newSlot/NE052.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-087",
    },
    {
      name: "Lights, Camera, Cash!™",
      image: "/assets/newSlot/NE053.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-203",
    },
    {
      name: "Hotline 2™",
      image: "/assets/newSlot/NE054.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-051",
    },
    {
      name: "Long Pao™",
      image: "/assets/newSlot/NE055.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-140",
    },
    {
      name: "Hotline™",
      image: "/assets/newSlot/NE056.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-044",
    },
    {
      name: "Lost Relics 2",
      image: "/assets/newSlot/NE057.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-204",
    },
    {
      name: "Irish Pot Luck™",
      image: "/assets/newSlot/NE058.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-050",
    },
    {
      name: "Lucky Angler: A Snowy Catch",
      image: "/assets/newSlot/NE059.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-168",
    },
    {
      name: "Jack and the Beanstalk™",
      image: "/assets/newSlot/NE060.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-035",
    },
    {
      name: "Magic lab",
      image: "/assets/newSlot/NE061.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-193",
    },
    {
      name: "Elements: The Awakening™",
      image: "/assets/newSlot/NE062.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-054",
    },
    {
      name: "Elk Hunter™",
      image: "/assets/newSlot/NE063.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-185",
    },
    {
      name: "Jack Hammer 2™",
      image: "/assets/newSlot/NE064.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-060",
    },
    {
      name: "Magic Portals",
      image: "/assets/newSlot/NE065.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-135",
    },
    {
      name: "Jack Hammer™",
      image: "/assets/newSlot/NE066.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-023",
    },
    {
      name: "Milkshake™ XXXtreme",
      image: "/assets/newSlot/NE067.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-133",
    },
    {
      name: "Moonshine Riches",
      image: "/assets/newSlot/NE069.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-170",
    },
    {
      name: "Jacks or Better Double Up™",
      image: "/assets/newSlot/NE070.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-099",
    },
    {
      name: "Jimi Hendrix Online Slot™",
      image: "/assets/newSlot/NE072.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-025",
    },
    {
      name: "Pirate From the East",
      image: "/assets/newSlot/NE073.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-172",
    },
    {
      name: "Jingle Spin™",
      image: "/assets/newSlot/NE074.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-031",
    },
    {
      name: "Pirates Party",
      image: "/assets/newSlot/NE075.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-182",
    },
    {
      name: "Joker Pro™",
      image: "/assets/newSlot/NE076.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-082",
    },
    {
      name: "Rage",
      image: "/assets/newSlot/NE077.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-189",
    },
    {
      name: "Jumanji",
      image: "/assets/newSlot/NE078.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-034",
    },
    {
      name: "Reel Rush 2",
      image: "/assets/newSlot/NE079.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-123",
    },
    {
      name: "Jungle Spirit: Call of the Wild™",
      image: "/assets/newSlot/NE080.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-007",
    },
    {
      name: "Robin Hood: Shifting Riches™",
      image: "/assets/newSlot/NE081.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-145",
    },
    {
      name: "King of Slots™",
      image: "/assets/newSlot/NE082.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-102",
    },
    {
      name: "Roulette Touch",
      image: "/assets/newSlot/NE083.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-122",
    },
    {
      name: "European Roulette",
      image: "/assets/newSlot/NE084.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-064",
    },
    {
      name: "Mirror Mirror™",
      image: "/assets/newSlot/NE085.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-091",
    },
    {
      name: "Knight Rider™",
      image: "/assets/newSlot/NE086.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-121",
    },
    {
      name: "Santa vs Rudolf™",
      image: "/assets/newSlot/NE087.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-151",
    },
    {
      name: "Koi Princess™",
      image: "/assets/newSlot/NE088.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-075",
    },
    {
      name: "Space Wars™",
      image: "/assets/newSlot/NE089.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-015",
    },
    {
      name: "Lights™",
      image: "/assets/newSlot/NE090.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-107",
    },
    {
      name: "Sparks",
      image: "/assets/newSlot/NE091.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-167",
    },
    {
      name: "Lost Relics™",
      image: "/assets/newSlot/NE092.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-080",
    },
    {
      name: "Spellcast",
      image: "/assets/newSlot/NE093.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-138",
    },
    {
      name: "Magic Maid Cafe™",
      image: "/assets/newSlot/NE094.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-108",
    },
    {
      name: "Spinsane™",
      image: "/assets/newSlot/NE095.webp",
      platformImage: "/assets/platformHeader/netent.webp",
    },
    {
      name: "Stickers™",
      image: "/assets/newSlot/NE097.webp",
      platformImage: "/assets/platformHeader/netent.webp",
    },
    {
      name: "Strolling Staxx: Cubic Fruits™",
      image: "/assets/newSlot/NE099.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-158",
    },
    {
      name: "Motörhead Video Slot™",
      image: "/assets/newSlot/NE100.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-022",
    },
    {
      name: "Mythic Maiden™",
      image: "/assets/newSlot/NE102.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-089",
    },
    {
      name: "Swipe & Roll",
      image: "/assets/newSlot/NE103.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-165",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-165",
    },
    {
      name: "Narcos™",
      image: "/assets/newSlot/NE104.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-037",
    },
    {
      name: "Taco Fury XXXtreme",
      image: "/assets/newSlot/NE105.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-174",
    },
    {
      name: "Excalibur™",
      image: "/assets/newSlot/NE106.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-100",
    },
    {
      name: "Finn and The Candy Spin",
      image: "/assets/newSlot/NE107.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-186",
    },
    {
      name: "Neon Staxx™",
      image: "/assets/newSlot/NE108.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-103",
    },
    {
      name: "Temple of Nudges",
      image: "/assets/newSlot/NE109.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-130",
    },
    {
      name: "Ocean's Treasure™",
      image: "/assets/newSlot/NE110.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-098",
    },
    {
      name: "The Wish Master™",
      image: "/assets/newSlot/NE111.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-147",
    },
    {
      name: "Ozzy Osbourne Video Slots™",
      image: "/assets/newSlot/NE112.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-028",
      platformImage: "/assets/platformHeader/netent.webp",
    },
    {
      name: "The Wish Master™ Megaways™",
      image: "/assets/newSlot/NE113.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-176",
    },
    {
      name: "Parthenon: Quest for Immortality™",
      image: "/assets/newSlot/NE114.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-006",
    },
    {
      name: "Theme Park Tickets of Fortune",
      image: "/assets/newSlot/NE115.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-160",
    },
    {
      name: "Piggy Riches™",
      image: "/assets/newSlot/NE116.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-033",
    },
    {
      name: "Thrill to Grill™",
      image: "/assets/newSlot/NE117.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-181",
    },
    {
      name: "Pyramid: Quest for Immortality™",
      image: "/assets/newSlot/NE118.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-030",
    },
    {
      name: "Twin Happiness™",
      image: "/assets/newSlot/NE119.webp",
      platformImage: "/assets/platformHeader/netent.webp",
    },
    {
      name: "Rage of the Seas™",
      image: "/assets/newSlot/NE120.webp",
      platformImage: "/assets/platformHeader/netent.webp",
    },
    {
      name: "Twin Spin Deluxe",
      image: "/assets/newSlot/NE121.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-136",
    },
    {
      name: "Reef Raider™",
      image: "/assets/newSlot/NE122.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-079",
    },
    {
      name: "Twin Spin XXXtreme",
      image: "/assets/newSlot/NE123.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-175",
    },
    {
      name: "Reel Rush™",
      image: "/assets/newSlot/NE124.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-001",
    },
    {
      name: "Who's the Bride™",
      image: "/assets/newSlot/NE125.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-143",
    },
    {
      name: "Reel Steal™",
      image: "/assets/newSlot/NE126.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-120",
    },
    {
      name: "Wild-O-Tron 3000™",
      image: "/assets/newSlot/NE127.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-157",
    },
    {
      name: "Red Riding Hood™",
      image: "/assets/newSlot/NE128.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-071",
    },
    {
      name: "Space Wars Megaways XXXtreme",
      image: "/assets/newSlot/NE221.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-211",
    },
    {
      name: "Babylon Riches",
      image: "/assets/newSlot/NE222.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-212",
    },
    {
      name: "Ticket To Wild",
      image: "/assets/newSlot/NE223.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-213",
    },
    {
      name: "Casino Night",
      image: "/assets/newSlot/NE224.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-214",
    },
    {
      name: "Mermaids™",
      image: "/assets/newSlot/NE225.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-215",
    },
    {
      name: "Rabid Randy",
      image: "/assets/newSlot/NE226.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-216",
    },
    {
      name: "Ms Robin Hood™",
      image: "/assets/newSlot/NE227.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-217",
    },
    {
      name: "Mine Blown™",
      image: "/assets/newSlot/NE228.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-218",
    },
    {
      name: "Mummy™ MegaWays™",
      image: "/assets/newSlot/NE229.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-219",
    },
    {
      name: "Starburst Galaxy",
      image: "/assets/newSlot/NE230.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-220",
    },
    {
      name: "Cornelius Milk Hunter Megaways™",
      image: "/assets/newSlot/NE231.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-221",
    },
    {
      name: "Dragons Playground™",
      image: "/assets/newSlot/NE232.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-222",
    },
    {
      name: "Twister",
      image: "/assets/newSlot/NE233.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-223",
    },
    {
      name: "Dazzle Me™ Christmas",
      image: "/assets/newSlot/NE234.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-224",
    },
    {
      name: "Wild Mining XXXtreme",
      image: "/assets/newSlot/NE235.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-225",
    },
    {
      name: "Finn and the Dragon Tales",
      image: "/assets/newSlot/NE236.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-226",
    },
    {
      name: "Golden Egg Invaders",
      image: "/assets/newSlot/NE237.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-227",
    },
    {
      name: "Jack Hammer™ 4: Chasing the Dragon",
      image: "/assets/newSlot/NE238.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-228",
    },
    {
      name: "Reel Rush XXXtreme",
      image: "/assets/newSlot/NE239.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-229",
    },
    {
      name: "Divine Fortune Black",
      image: "/assets/newSlot/NE240.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-230",
    },
    {
      name: "Piggy Riches™ 3: Hog Heaven",
      image: "/assets/newSlot/NE241.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-231",
    },
    {
      name: "Dead West",
      image: "/assets/newSlot/NE242.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-232",
    },
    {
      name: "Gonzo's Quest 2",
      image: "/assets/newSlot/NE243.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-233",
    },
    {
      name: "Rabid Randy Dark Trails",
      image: "/assets/newSlot/NE244.webp",
      platformImage: "/assets/platformHeader/netent.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-234",
    },
  ],
  NLC: [
    {
      name: "Barbarian Fury",
      image: "/assets/newSlot/NLC001.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-039",
    },
    {
      name: "Benji Killed in Vegas",
      image: "/assets/newSlot/NLC002.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-064",
    },
    {
      name: "Blood & Shadow",
      image: "/assets/newSlot/NLC003.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-065",
    },
    {
      name: "Bonus Bunnies",
      image: "/assets/newSlot/NLC004.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-020",
    },
    {
      name: "Book Of Shadows",
      image: "/assets/newSlot/NLC005.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-016",
    },
    {
      name: "Bounty Hunters xNudge",
      image: "/assets/newSlot/NLC006.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-070",
    },
    {
      name: "Brick Snake 2000",
      image: "/assets/newSlot/NLC007.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-075",
    },
    {
      name: "Buffalo Hunter",
      image: "/assets/newSlot/NLC008.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-033",
    },
    {
      name: "Casino Win Spin",
      image: "/assets/newSlot/NLC009.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-058",
    },
    {
      name: "Coins of Fortune",
      image: "/assets/newSlot/NLC010.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-056",
    },
    {
      name: "Das xBoot",
      image: "/assets/newSlot/NLC011.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-001",
    },
    {
      name: "D Day",
      image: "/assets/newSlot/NLC012.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-076",
    },
    {
      name: "Dead Canary",
      image: "/assets/newSlot/NLC013.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-009",
    },
    {
      name: "Deadwood xNudge",
      image: "/assets/newSlot/NLC014.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-010",
    },
    {
      name: "Devil's Crossroad",
      image: "/assets/newSlot/NLC015.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-077",
    },
    {
      name: "Disturbed",
      image: "/assets/newSlot/NLC016.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-067",
    },
    {
      name: "DJ Psycho",
      image: "/assets/newSlot/NLC017.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-071",
    },
    {
      name: "Dragon Tribe",
      image: "/assets/newSlot/NLC018.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-041",
    },
    {
      name: "Dungeon Quest",
      image: "/assets/newSlot/NLC019.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-054",
    },
    {
      name: "East Coast Vs West Coast",
      image: "/assets/newSlot/NLC020.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-029",
    },
    {
      name: "El Paso Gunfight xNudge",
      image: "/assets/newSlot/NLC021.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-027",
    },
    {
      name: "Evil Goblins xBomb",
      image: "/assets/newSlot/NLC022.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-011",
    },
    {
      name: "Fire In The Hole 2",
      image: "/assets/newSlot/NLC023.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-078",
    },
    {
      name: "Fire In The Hole xBomb",
      image: "/assets/newSlot/NLC024.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-008",
    },
    {
      name: "Folsom Prison",
      image: "/assets/newSlot/NLC025.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-007",
    },
    {
      name: "Fruits",
      image: "/assets/newSlot/NLC026.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-052",
    },
    {
      name: "Gaelic Gold",
      image: "/assets/newSlot/NLC027.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-038",
    },
    {
      name: "Gluttony",
      image: "/assets/newSlot/NLC028.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-069",
    },
    {
      name: "Golden Genie And The Walking Wilds",
      image: "/assets/newSlot/NLC029.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-035",
    },
    {
      name: "Harlequin Carnival",
      image: "/assets/newSlot/NLC030.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-037",
    },
    {
      name: "Hot 4 Cash",
      image: "/assets/newSlot/NLC031.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-045",
    },
    {
      name: "Hot Nudge",
      image: "/assets/newSlot/NLC032.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-055",
    },
    {
      name: "Ice Ice Yeti",
      image: "/assets/newSlot/NLC033.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-053",
    },
    {
      name: "Immortal Fruits",
      image: "/assets/newSlot/NLC034.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-034",
    },
    {
      name: "Infectious 5 xWays",
      image: "/assets/newSlot/NLC035.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-014",
    },
    {
      name: "Jingle Balls",
      image: "/assets/newSlot/NLC036.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-079",
    },
    {
      name: "Karen Maneater",
      image: "/assets/newSlot/NLC037.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-024",
    },
    {
      name: "Kiss My Chainsaw",
      image: "/assets/newSlot/NLC038.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-066",
    },
    {
      name: "Land Of The Free",
      image: "/assets/newSlot/NLC041.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-080",
    },
    {
      name: "Little Bighorn",
      image: "/assets/newSlot/NLC043.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-021",
    },
    {
      name: "Manhattan Goes Wild",
      image: "/assets/newSlot/NLC044.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-043",
    },
    {
      name: "Mayan Magic Wildfire",
      image: "/assets/newSlot/NLC045.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-048",
    },
    {
      name: "Mental",
      image: "/assets/newSlot/NLC046.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-002",
    },
    {
      name: "Milky Ways",
      image: "/assets/newSlot/NLC047.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-036",
    },
    {
      name: "Misery Mining",
      image: "/assets/newSlot/NLC048.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-015",
    },
    {
      name: "Monkey's Gold xPays",
      image: "/assets/newSlot/NLC049.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-032",
    },
    {
      name: "Nine To Five",
      image: "/assets/newSlot/NLC050.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-083",
    },
    {
      name: "Owls",
      image: "/assets/newSlot/NLC052.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-051",
    },
    {
      name: "Pearl Harbor",
      image: "/assets/newSlot/NLC053.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-018",
    },
    {
      name: "Pixies vs Pirates",
      image: "/assets/newSlot/NLC054.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-044",
    },
    {
      name: "Poison Eve",
      image: "/assets/newSlot/NLC055.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-040",
    },
    {
      name: "Possessed",
      image: "/assets/newSlot/NLC056.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-081",
    },
    {
      name: "Punk Rocker",
      image: "/assets/newSlot/NLC057.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-012",
    },
    {
      name: "Punk Toilet",
      image: "/assets/newSlot/NLC058.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-003",
    },
    {
      name: "Remember Gulag",
      image: "/assets/newSlot/NLC059.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-017",
    },
    {
      name: "Roadkill",
      image: "/assets/newSlot/NLC060.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-084",
    },
    {
      name: "Road Rage",
      image: "/assets/newSlot/NLC061.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-019",
    },
    {
      name: "Rock Bottom",
      image: "/assets/newSlot/NLC062.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-062",
    },
    {
      name: "San Quentin xWays",
      image: "/assets/newSlot/NLC063.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-030",
    },
    {
      name: "Serial",
      image: "/assets/newSlot/NLC064.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-004",
    },
    {
      name: "Deadwood R.I.P",
      image: "/assets/newSlot/NLC095.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-091",
    },
    {
      name: "Apocalypse Super xNudge®",
      image: "/assets/newSlot/NLC096.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-092",
    },
    {
      name: "Outsourced",
      image: "/assets/newSlot/NLC097.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-093",
    },
    {
      name: "Stockholm Syndrome",
      image: "/assets/newSlot/NLC098.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-094",
    },
    {
      name: "Skate or Die",
      image: "/assets/newSlot/NLC099.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-095",
    },
    {
      name: "San Quentin 2: Death Row",
      image: "/assets/newSlot/NLC100.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-096",
    },
    {
      name: "Brute Force",
      image: "/assets/newSlot/NLC101.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-097",
    },
    {
      name: "Munchies",
      image: "/assets/newSlot/NLC102.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-099",
    },
    {
      name: "Blood & Shadow 2",
      image: "/assets/newSlot/NLC103.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-100",
    },
    {
      name: "Outsourced Payday",
      image: "/assets/newSlot/NLC104.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-101",
    },
    {
      name: "Tanked",
      image: "/assets/newSlot/NLC105.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-102",
    },
    {
      name: "Duck Hunters",
      image: "/assets/newSlot/NLC106.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-103",
    },
    {
      name: "Tombstone Slaughter",
      image: "/assets/newSlot/NLC107.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-104",
    },
    {
      name: "xWays Hoarder 2",
      image: "/assets/newSlot/NLC108.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-105",
    },
    {
      name: "Dead, Dead, or Deader",
      image: "/assets/newSlot/NLC109.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-106",
    },
    {
      name: "Mental 2",
      image: "/assets/newSlot/NLC110.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-107",
    },
    {
      name: "Home of the Brave",
      image: "/assets/newSlot/NLC111.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-108",
    },
    {
      name: "Blood Diamond",
      image: "/assets/newSlot/NLC112.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-109",
    },
    {
      name: "Highway to Hell",
      image: "/assets/newSlot/NLC113.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-110",
    },
    {
      name: "Kill Em All",
      image: "/assets/newSlot/NLC114.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-111",
    },
    {
      name: "Flight Mode",
      image: "/assets/newSlot/NLC115.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-112",
    },
    {
      name: "Fire in the Hole 3",
      image: "/assets/newSlot/NLC116.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-113",
    },
    {
      name: "Brute Force: Alien Onslaught",
      image: "/assets/newSlot/NLC117.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-114",
    },
    {
      name: "Tsar Wars",
      image: "/assets/newSlot/NLC118.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-115",
    },
    {
      name: "Seamen",
      image: "/assets/newSlot/NLC119.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-116",
    },
    {
      name: "Gator Hunters",
      image: "/assets/newSlot/NLC120.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-117",
    },
    {
      name: "Dead Men Walking",
      image: "/assets/newSlot/NLC121.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-118",
    },
    {
      name: "Breakout",
      image: "/assets/newSlot/NLC122.webp",
      platformImage: "/assets/platformHeader/nlc.webp",
      platFormCode: "NLC",
      gameType: "SLOT",
      casinoType: "NLC-SLOT-119",
    },
  ],
  PLAY8: [
    {
      name: "A Night Out",
      image: "/assets/newSlot/P801.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-015",
    },
    {
      name: "Big Prosperity",
      image: "/assets/newSlot/P802.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-023",
    },
    {
      name: "Big Shot",
      image: "/assets/newSlot/P803.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-013",
    },
    {
      name: "Captain Treasure",
      image: "/assets/newSlot/P804.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-012",
    },
    {
      name: "Cherry Love",
      image: "/assets/newSlot/P805.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-010",
    },
    {
      name: "Dolphin Reef",
      image: "/assets/newSlot/P806.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-006",
    },
    {
      name: "Dragon Gold",
      image: "/assets/newSlot/P807.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-022",
    },
    {
      name: "Emperor Gate",
      image: "/assets/newSlot/P808.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-017",
    },
    {
      name: "Fortune",
      image: "/assets/newSlot/P809.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-021",
    },
    {
      name: "Golden Slut",
      image: "/assets/newSlot/P810.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-025",
    },
    {
      name: "Great Blue",
      image: "/assets/newSlot/P811.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-003",
    },
    {
      name: "Highroad Kings JP",
      image: "/assets/newSlot/P812.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-007",
    },
    {
      name: "Ice Land",
      image: "/assets/newSlot/P813.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-018",
    },
    {
      name: "Jin Qian Wa",
      image: "/assets/newSlot/P814.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-004",
    },
    {
      name: "Ocean King",
      image: "/assets/newSlot/P815.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "FH",
      casinoType: "P8-FISH-001",
    },
    {
      name: "CrazyMonkey",
      image: "/assets/newSlot/P816.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-029",
    },
    {
      name: "Jungle",
      image: "/assets/newSlot/P817.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-030",
    },
    {
      name: "Ocean",
      image: "/assets/newSlot/P818.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-031",
    },
    {
      name: "Pyramid",
      image: "/assets/newSlot/P819.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-032",
    },
    {
      name: "SangoWarlord",
      image: "/assets/newSlot/P821.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-034",
    },
    {
      name: "Pan Jin Lian",
      image: "/assets/newSlot/P822.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-005",
    },
    {
      name: "Panther Moon",
      image: "/assets/newSlot/P823.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-001",
    },
    {
      name: "Safari Heat",
      image: "/assets/newSlot/P825.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-002",
    },
    {
      name: "Sea Captain",
      image: "/assets/newSlot/P826.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-014",
    },
    {
      name: "Silent Samurai",
      image: "/assets/newSlot/P827.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-009",
    },
    {
      name: "Super Lucky Cat",
      image: "/assets/newSlot/P828.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-027",
    },
    {
      name: "Tally Ho",
      image: "/assets/newSlot/P829.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-020",
    },
    {
      name: "Thai Paradise",
      image: "/assets/newSlot/P830.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-011",
    },
    {
      name: "The Discovery",
      image: "/assets/newSlot/P831.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-008",
    },
    {
      name: "T-Rex",
      image: "/assets/newSlot/P832.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-019",
    },
    {
      name: "Triple Twister",
      image: "/assets/newSlot/P833.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-016",
    },
    {
      name: "White King",
      image: "/assets/newSlot/P834.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-024",
    },
    {
      name: "Wong Choy",
      image: "/assets/newSlot/P835.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-028",
    },
    {
      name: "Rich Mouse",
      image: "/assets/newSlot/P836.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-026",
    },
    {
      name: "Qin",
      image: "/assets/newSlot/P837.webp",
      platformImage: "/assets/platformHeader/play8.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-033",
    },
  ],
  PT: [
    {
      name: "20 Stars Ablaze",
      image: "/assets/newSlot/PT006.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-450",
    },
    {
      name: "A Night Out",
      image: "/assets/newSlot/PT013.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-059",
    },
    {
      name: "Absolutely Mammoth",
      image: "/assets/newSlot/PT015.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-155",
    },
    {
      name: "Adventures Beyond Wonderland Magical Maze",
      image: "/assets/newSlot/PT017.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-426",
    },
    {
      name: "Age of Egypt",
      image: "/assets/newSlot/PT022.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-113",
    },
    {
      name: "Alohawaii: Cash Collect™",
      image: "/assets/newSlot/PT061.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-330",
    },
    {
      name: "Anaconda Uncoiled",
      image: "/assets/newSlot/PT064.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-103",
    },
    {
      name: "Anaconda Wild II",
      image: "/assets/newSlot/PT066.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-179",
    },
    {
      name: "Anaconda Wild",
      image: "/assets/newSlot/PT068.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-120",
    },
    {
      name: "Archer",
      image: "/assets/newSlot/PT074.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-073",
    },
    {
      name: "Arowanas Luck",
      image: "/assets/newSlot/PT076.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-002",
    },
    {
      name: "Asian Fantasy",
      image: "/assets/newSlot/PT078.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-043",
    },
    {
      name: "Atlantis Cash Collect",
      image: "/assets/newSlot/PT079.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-097",
    },
    {
      name: "Atlantis Queen",
      image: "/assets/newSlot/PT080.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-069",
    },
    {
      name: "Azteca: Cash Collect",
      image: "/assets/newSlot/PT087.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-324",
    },
    {
      name: "Azticons Chaos Clusters",
      image: "/assets/newSlot/PT088.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-428",
    },
    {
      name: "Bai Shi",
      image: "/assets/newSlot/PT091.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-122",
    },
    {
      name: "Beastwood",
      image: "/assets/newSlot/PT095.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-431",
    },
    {
      name: "Bee Frenzy",
      image: "/assets/newSlot/PT097.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-182",
    },
    {
      name: "Bermuda Triangle",
      image: "/assets/newSlot/PT099.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-119",
    },
    {
      name: "Better Wilds",
      image: "/assets/newSlot/PT102.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-196",
    },
    {
      name: "Betty Bonkers",
      image: "/assets/newSlot/PT103.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-429",
    },
    {
      name: "Big Bad Wolf",
      image: "/assets/newSlot/PT107.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-248",
    },
    {
      name: "Big Bad Wolf Megaways",
      image: "/assets/newSlot/PT105.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-255",
    },
    {
      name: "Blackbeard’s Hoard Cash Sacks",
      image: "/assets/newSlot/PT110.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-468",
    },
    {
      name: "Blazing Bells",
      image: "/assets/newSlot/PT117.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-199",
    },
    {
      name: "Blue Wizard: Cash Collect & Link",
      image: "/assets/newSlot/PT120.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-425",
    },
    {
      name: "Bonus Bears",
      image: "/assets/newSlot/PT122.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-018",
    },
    {
      name: "Book of Kings",
      image: "/assets/newSlot/PT129.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-202",
    },
    {
      name: "Breach the Vault",
      image: "/assets/newSlot/PT135.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-354",
    },
    {
      name: "Breakout Bob",
      image: "/assets/newSlot/PT136.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-170",
    },
    {
      name: "Bubblegum Burst",
      image: "/assets/newSlot/PT139.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-449",
    },
    {
      name: "Buffalo Blitz",
      image: "/assets/newSlot/PT147.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-003",
    },
    {
      name: "Buffalo Blitz Cash Collect",
      image: "/assets/newSlot/PT143.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-436",
    },
    {
      name: "Buffalo Blitz II",
      image: "/assets/newSlot/PT144.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-017",
    },
    {
      name: "Caishen Ways",
      image: "/assets/newSlot/PT154.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-189",
    },
    {
      name: "Candy Roll™",
      image: "/assets/newSlot/PT156.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-351",
    },
    {
      name: "Cascading Cave",
      image: "/assets/newSlot/PT160.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-228",
    },
    {
      name: "Cash IT",
      image: "/assets/newSlot/PT166.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-260",
    },
    {
      name: "Cash Truck Begins",
      image: "/assets/newSlot/PT172.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-444",
    },
    {
      name: "Cash Truck",
      image: "/assets/newSlot/PT174.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-249",
    },
    {
      name: "Cat Queen",
      image: "/assets/newSlot/PT179.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-058",
    },
    {
      name: "Chaoji 888",
      image: "/assets/newSlot/PT182.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-023",
    },
    {
      name: "Chili Eruption Thundershots",
      image: "/assets/newSlot/PT184.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-100",
    },
    {
      name: "Chilli Xtreme",
      image: "/assets/newSlot/PT186.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-104",
    },
    {
      name: "Chinese Kitchen",
      image: "/assets/newSlot/PT187.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-060",
    },
    {
      name: "Circuit Shock",
      image: "/assets/newSlot/PT190.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-352",
    },
    {
      name: "Crazy 7",
      image: "/assets/newSlot/PT195.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-124",
    },
    {
      name: "Curse of Anubis",
      image: "/assets/newSlot/PT201.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-150",
    },
    {
      name: "Desert Treasure",
      image: "/assets/newSlot/PT204.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-066",
    },
    {
      name: "Devil Wilds",
      image: "/assets/newSlot/PT206.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-262",
    },
    {
      name: "Diamond Match Deluxe",
      image: "/assets/newSlot/PT213.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-360",
    },
    {
      name: "Diamond Match",
      image: "/assets/newSlot/PT214.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-267",
    },
    {
      name: "Diamond Rise",
      image: "/assets/newSlot/PT215.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-088",
    },
    {
      name: "Divine 9",
      image: "/assets/newSlot/PT217.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-332",
    },
    {
      name: "Dolphin Reef",
      image: "/assets/newSlot/PT221.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PLAY8",
      gameType: "SLOT",
      casinoType: "P8-SLOT-006",
    },
    {
      name: "Dragon Bond",
      image: "/assets/newSlot/PT225.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-205",
    },
    {
      name: "Dragon Champions",
      image: "/assets/newSlot/PT226.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-136",
    },
    {
      name: "Dragon Chi",
      image: "/assets/newSlot/PT228.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-191",
    },
    {
      name: "Dragon Shrine",
      image: "/assets/newSlot/PT231.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-253",
    },
    {
      name: "Dragon Spark",
      image: "/assets/newSlot/PT232.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-195",
    },
    {
      name: "Drop for Top",
      image: "/assets/newSlot/PT235.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-417",
    },
    {
      name: "Easter Surprise",
      image: "/assets/newSlot/PT239.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-067",
    },
    {
      name: "Eastern Emeralds Megaways",
      image: "/assets/newSlot/PT240.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-251",
    },
    {
      name: "Eastern Emeralds",
      image: "/assets/newSlot/PT241.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-252",
    },
    {
      name: "Egyptian Emeralds",
      image: "/assets/newSlot/PT243.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-204",
    },
    {
      name: "El Ranchero Cash Collect Diamond Path",
      image: "/assets/newSlot/PT244.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-415",
    },
    {
      name: "Elephant Riches™",
      image: "/assets/newSlot/PT245.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-349",
    },
    {
      name: "Epic Ape",
      image: "/assets/newSlot/PT253.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-021",
    },
    {
      name: "Eye of Anubis",
      image: "/assets/newSlot/PT262.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-162",
    },
    {
      name: "Fat Choy Choy Sun",
      image: "/assets/newSlot/PT267.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-053",
    },
    {
      name: "Fei Long Zai Tian",
      image: "/assets/newSlot/PT270.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-027",
    },
    {
      name: "Feng Kuang Ma Jiang",
      image: "/assets/newSlot/PT271.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-020",
    },
    {
      name: "Feng Shui Flip",
      image: "/assets/newSlot/PT272.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-348",
    },
    {
      name: "FIRE 4: Cash Collect Quattro",
      image: "/assets/newSlot/PT273.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-245",
    },
    {
      name: "Fire Blaze: Blue Wizard Megaways",
      image: "/assets/newSlot/PT275.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-094",
    },
    {
      name: "Fire Blaze: Fire Fighter",
      image: "/assets/newSlot/PT279.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-232",
    },
    {
      name: "Fire Blaze Golden: Amazing Factory",
      image: "/assets/newSlot/PT280.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-181",
    },
    {
      name: "Fire Blaze Golden: Buccaneer Bells",
      image: "/assets/newSlot/PT281.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-165",
    },
    {
      name: "Fire Blaze: Green Wizard",
      image: "/assets/newSlot/PT283.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-336",
    },
    {
      name: "Fire Blaze Quattro: Celtic Charm",
      image: "/assets/newSlot/PT287.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-074",
    },
    {
      name: "Fire Blaze: Red Wizard",
      image: "/assets/newSlot/PT288.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-167",
    },
    {
      name: "Fire Blaze: River Empress",
      image: "/assets/newSlot/PT289.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-168",
    },
    {
      name: "Fire Blaze: Sisters Gift",
      image: "/assets/newSlot/PT291.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-169",
    },
    {
      name: "Fire Blaze: Sky Queen Megaways™",
      image: "/assets/newSlot/PT292.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
    },
    {
      name: "Fire Blaze: Toltec Blocks",
      image: "/assets/newSlot/PT294.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-264",
    },
    {
      name: "Fire Blaze Golden: Tundra Wolf",
      image: "/assets/newSlot/PT296.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-157",
    },
    {
      name: "Fishin' Bonanza",
      image: "/assets/newSlot/PT299.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-089",
    },
    {
      name: "Flip Royale",
      image: "/assets/newSlot/PT302.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-448",
    },
    {
      name: "Fluffy Favourites: Cash Collect",
      image: "/assets/newSlot/PT303.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-410",
    },
    {
      name: "Football Rules",
      image: "/assets/newSlot/PT309.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-082",
    },
    {
      name: "Football! Cash Collect",
      image: "/assets/newSlot/PT312.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-238",
    },
    {
      name: "Fortune Day",
      image: "/assets/newSlot/PT315.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-046",
    },
    {
      name: "Fortune Lions",
      image: "/assets/newSlot/PT317.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-044",
    },
    {
      name: "Frog's Gift",
      image: "/assets/newSlot/PT322.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-187",
    },
    {
      name: "Full Moon: White King",
      image: "/assets/newSlot/PT328.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-359",
    },
    {
      name: "Full Moon: White Panda",
      image: "/assets/newSlot/PT330.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-160",
    },
    {
      name: "Funky Monkey",
      image: "/assets/newSlot/PT334.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-010",
    },
    {
      name: "Gaelic Luck",
      image: "/assets/newSlot/PT335.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-142",
    },
    {
      name: "Geisha Story",
      image: "/assets/newSlot/PT340.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-061",
    },
    {
      name: "Gem Heat",
      image: "/assets/newSlot/PT341.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-128",
    },
    {
      name: "Gem Queen",
      image: "/assets/newSlot/PT342.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-019",
    },
    {
      name: "Giga Match Bunny",
      image: "/assets/newSlot/PT347.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-430",
    },
    {
      name: "Giga Match Egypt",
      image: "/assets/newSlot/PT348.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-447",
    },
    {
      name: "Giga Match Gems",
      image: "/assets/newSlot/PT350.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-459",
    },
    {
      name: "Giga Match Moolah",
      image: "/assets/newSlot/PT351.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-466",
    },
    {
      name: "Glorious Guardians",
      image: "/assets/newSlot/PT355.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-098",
    },
    {
      name: "Go High Safari",
      image: "/assets/newSlot/PT364.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-465",
    },
    {
      name: "Gold hit & link: J.P. Bacon & Co",
      image: "/assets/newSlot/PT366.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-271",
    },
    {
      name: "Gold Hit & Link: Tiger Jones",
      image: "/assets/newSlot/PT367.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-357",
    },
    {
      name: "Gold Hit: Dragon Bonanza",
      image: "/assets/newSlot/PT368.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-327",
    },
    {
      name: "Gold Hit: O'Reilly's Riches",
      image: "/assets/newSlot/PT372.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-076",
    },
    {
      name: "Gold Hit: Shrine of Anubis",
      image: "/assets/newSlot/PT373.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-259",
    },
    {
      name: "Gold Pile: New Years Gold",
      image: "/assets/newSlot/PT375.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-185",
    },
    {
      name: "Gold Pile: Orangutan",
      image: "/assets/newSlot/PT376.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-166",
    },
    {
      name: "Gold Pile: Tigers Pride",
      image: "/assets/newSlot/PT377.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-173",
    },
    {
      name: "Gold Pile: Toltec Treasure",
      image: "/assets/newSlot/PT378.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-183",
    },
    {
      name: "Gold Trio: Leprechaun's Luck BF",
      image: "/assets/newSlot/PT382.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-416",
    },
    {
      name: "Gold Trio: Lil Demon",
      image: "/assets/newSlot/PT383.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-442",
    },
    {
      name: "Jane Jones In Book Of King 2",
      image: "/assets/newSlot/PT474.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-172",
    },
    {
      name: "Jin Qian Wa",
      image: "/assets/newSlot/PT478.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-013",
    },
    {
      name: "Joker Rush: Cash collect",
      image: "/assets/newSlot/PT483.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-269",
    },
    {
      name: "Joker Rush",
      image: "/assets/newSlot/PT485.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-108",
    },
    {
      name: "Joker Spin & Roll",
      image: "/assets/newSlot/PT486.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-443",
    },
    {
      name: "Jungle Giants",
      image: "/assets/newSlot/PT489.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-131",
    },
    {
      name: "Jurassic Island 2",
      image: "/assets/newSlot/PT490.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-096",
    },
    {
      name: "Jurassic Island",
      image: "/assets/newSlot/PT491.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-086",
    },
    {
      name: "Ka Ching Boom",
      image: "/assets/newSlot/PT492.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-469",
    },
    {
      name: "Koi Harmony",
      image: "/assets/newSlot/PT509.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-106",
    },
    {
      name: "Legacy of the Wilds 2",
      image: "/assets/newSlot/PT514.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-188",
    },
    {
      name: "Legacy of the Wild",
      image: "/assets/newSlot/PT515.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-072",
    },
    {
      name: "Leprechaun's Luck - Cash Collect TM Megaways TM",
      image: "/assets/newSlot/PT518.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-320",
    },
    {
      name: "Leprechaun's Luck: Cash Collect",
      image: "/assets/newSlot/PT519.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-090",
    },
    {
      name: "Lie Yan Zuan Shi",
      image: "/assets/newSlot/PT521.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-031",
    },
    {
      name: "Lights of Luck",
      image: "/assets/newSlot/PT522.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-408",
    },
    {
      name: "Lil Demo Double Heat",
      image: "/assets/newSlot/PT524.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-438",
    },
    {
      name: "Lil Demon: Mega Cash Collect",
      image: "/assets/newSlot/PT525.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-361",
    },
    {
      name: "Lil Sphinx",
      image: "/assets/newSlot/PT526.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-413",
    },
    {
      name: "Lock & Hit: Red Knight",
      image: "/assets/newSlot/PT528.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-333",
    },
    {
      name: "Lockdown Loot",
      image: "/assets/newSlot/PT529.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-325",
    },
    {
      name: "Long Long Long",
      image: "/assets/newSlot/PT533.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-005",
    },
    {
      name: "Lotto Madness",
      image: "/assets/newSlot/PT535.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-068",
    },
    {
      name: "Lovefool",
      image: "/assets/newSlot/PT536.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-176",
    },
    {
      name: "Lucky Bass: Mega Cash Collect",
      image: "/assets/newSlot/PT538.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-358",
    },
    {
      name: "Lucky Emeralds",
      image: "/assets/newSlot/PT539.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-216",
    },
    {
      name: "Luminous Life",
      image: "/assets/newSlot/PT542.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-115",
    },
    {
      name: "Macabra Linx",
      image: "/assets/newSlot/PT548.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-318",
    },
    {
      name: "Mad Hit Diamonds",
      image: "/assets/newSlot/PT551.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-424",
    },
    {
      name: "Mad Hit Gorillatron",
      image: "/assets/newSlot/PT553.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-458",
    },
    {
      name: "Mad Hit Jokester",
      image: "/assets/newSlot/PT555.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-456",
    },
    {
      name: "Magical Stacks",
      image: "/assets/newSlot/PT561.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-078",
    },
    {
      name: "Mayan Blocks",
      image: "/assets/newSlot/PT564.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-102",
    },
    {
      name: "Mega Fire Blaze: Big Circus!",
      image: "/assets/newSlot/PT568.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-092",
    },
    {
      name: "Mega Fire Blaze: Dwarves and Goblins™",
      image: "/assets/newSlot/PT569.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-343",
    },
    {
      name: "Mega Fire Blaze: Emperor of Rome",
      image: "/assets/newSlot/PT570.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-244",
    },
    {
      name: "Mega Fire Blaze: Khonsu God of Moon",
      image: "/assets/newSlot/PT198.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-153",
    },
    {
      name: "Mega Fire Blaze Lucky Bass",
      image: "/assets/newSlot/PT574.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-439",
    },
    {
      name: "Mega Fire Blaze: Piggies and the Bank™",
      image: "/assets/newSlot/PT576.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-328",
    },
    {
      name: "Mega Fire Blaze: Wild Pistolero",
      image: "/assets/newSlot/PT579.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-091",
    },
    {
      name: "Midnight Wilds",
      image: "/assets/newSlot/PT581.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-203",
    },
    {
      name: "Mighty Hat: Lamp of Gold",
      image: "/assets/newSlot/PT583.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-105",
    },
    {
      name: "Mine & Melt",
      image: "/assets/newSlot/PT586.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-455",
    },
    {
      name: "Miss Fortune",
      image: "/assets/newSlot/PT589.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-065",
    },
    {
      name: "Monkey and Rat",
      image: "/assets/newSlot/PT590.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-152",
    },
    {
      name: "Monster Multipliers",
      image: "/assets/newSlot/PT592.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-110",
    },
    {
      name: "Mr. Cashback",
      image: "/assets/newSlot/PT594.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-063",
    },
    {
      name: "Mystic Mines",
      image: "/assets/newSlot/PT597.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-461",
    },
    {
      name: "Neptune's Kingdom",
      image: "/assets/newSlot/PT598.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-137",
    },
    {
      name: "Ocean Frenzy",
      image: "/assets/newSlot/PT606.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-423",
    },
    {
      name: "Oink Oink Oink Pharaohs",
      image: "/assets/newSlot/PT607.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-440",
    },
    {
      name: "Oink Oink Oink",
      image: "/assets/newSlot/PT608.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-319",
    },
    {
      name: "Ox Riches",
      image: "/assets/newSlot/PT609.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-037",
    },
    {
      name: "Panda Luck",
      image: "/assets/newSlot/PT611.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-197",
    },
    {
      name: "Panther Moon: Bonus Lines™",
      image: "/assets/newSlot/PT612.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-344",
    },
    {
      name: "Panther Moon",
      image: "/assets/newSlot/PT613.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-041",
    },
    {
      name: "Panther Pays",
      image: "/assets/newSlot/PT615.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-230",
    },
    {
      name: "Penguin Vacation",
      image: "/assets/newSlot/PT618.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-121",
    },
    {
      name: "Pharaoh's Secrets",
      image: "/assets/newSlot/PT621.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-126",
    },
    {
      name: "Pigeons from Space",
      image: "/assets/newSlot/PT626.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-240",
    },
    {
      name: "Scatter Monsters",
      image: "/assets/newSlot/PT702.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-463",
    },
    {
      name: "Secrets of the Amazon",
      image: "/assets/newSlot/PT705.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-054",
    },
    {
      name: "Shields of Lambda",
      image: "/assets/newSlot/PT714.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-441",
    },
    {
      name: "Si Xiang",
      image: "/assets/newSlot/PT716.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-040",
    },
    {
      name: "Silent Samurai",
      image: "/assets/newSlot/PT718.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-138",
    },
    {
      name: "Silver Bullet Bandit: Cash Collect",
      image: "/assets/newSlot/PT720.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-107",
    },
    {
      name: "Silver Bullet",
      image: "/assets/newSlot/PT721.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-135",
    },
    {
      name: "Sinbad's Golden Voyage",
      image: "/assets/newSlot/PT723.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-081",
    },
    {
      name: "Sorcerer's Guild of Magic",
      image: "/assets/newSlot/PT729.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-154",
    },
    {
      name: "Spinions Game Day",
      image: "/assets/newSlot/PT735.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-462",
    },
    {
      name: "Stallion Strike",
      image: "/assets/newSlot/PT738.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-200",
    },
    {
      name: "Stampede Rush Trident",
      image: "/assets/newSlot/PT740.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-427",
    },
    {
      name: "Sticky Bandits Thunder Rail",
      image: "/assets/newSlot/PT746.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-434",
    },
    {
      name: "Streak of Luck: Double Dice",
      image: "/assets/newSlot/PT752.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-411",
    },
    {
      name: "Sweet n' Juicy",
      image: "/assets/newSlot/PT761.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-356",
    },
    {
      name: "Ten Ton Ways Stampede",
      image: "/assets/newSlot/PT767.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-445",
    },
    {
      name: "Thai Paradise",
      image: "/assets/newSlot/PT768.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-071",
    },
    {
      name: "The Racaroon",
      image: "/assets/newSlot/PT775.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-454",
    },
    {
      name: "The Riches of Don Quixote",
      image: "/assets/newSlot/PT776.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-052",
    },
    {
      name: "Tiger Claw",
      image: "/assets/newSlot/PT779.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-117",
    },
    {
      name: "Tiger Stacks",
      image: "/assets/newSlot/PT780.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-208",
    },
    {
      name: "Tip Top Totems",
      image: "/assets/newSlot/PT787.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-212",
    },
    {
      name: "Toad's Gift",
      image: "/assets/newSlot/PT789.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-177",
    },
    {
      name: "Toucan Mania",
      image: "/assets/newSlot/PT791.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-467",
    },
    {
      name: "Treasures of the Lamps",
      image: "/assets/newSlot/PT793.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-114",
    },
    {
      name: "Tree Wishes",
      image: "/assets/newSlot/PT794.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-407",
    },
    {
      name: "Triple Monkey",
      image: "/assets/newSlot/PT799.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-001",
    },
    {
      name: "Triple Stop: Mermaids Find",
      image: "/assets/newSlot/PT801.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-243",
    },
    {
      name: "True Love",
      image: "/assets/newSlot/PT802.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-139",
    },
    {
      name: "Ugga Bugga",
      image: "/assets/newSlot/PT804.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-015",
    },
    {
      name: "Vacation Station Deluxe",
      image: "/assets/newSlot/PT805.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-024",
    },
    {
      name: "Vacation Station",
      image: "/assets/newSlot/PT806.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-118",
    },
    {
      name: "Veils of Venice",
      image: "/assets/newSlot/PT813.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-321",
    },
    {
      name: "Ways of the Phoenix",
      image: "/assets/newSlot/PT825.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-116",
    },
    {
      name: "Wheels of Flame",
      image: "/assets/newSlot/PT827.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-242",
    },
    {
      name: "White King II",
      image: "/assets/newSlot/PT828.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-125",
    },
    {
      name: "White King",
      image: "/assets/newSlot/PT829.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-055",
    },
    {
      name: "Wild Lava Scratch",
      image: "/assets/newSlot/PT836.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-246",
    },
    {
      name: "Wild Lava",
      image: "/assets/newSlot/PT837.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-184",
    },
    {
      name: "Wild Linx",
      image: "/assets/newSlot/PT839.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-159",
    },
    {
      name: "Wild Roll",
      image: "/assets/newSlot/PT841.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-419",
    },
    {
      name: "Wild West Wilds",
      image: "/assets/newSlot/PT844.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-201",
    },
    {
      name: "Wins of Fortune",
      image: "/assets/newSlot/PT845.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-250",
    },
    {
      name: "Witches: Cash Collect",
      image: "/assets/newSlot/PT846.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-337",
    },
    {
      name: "Wizzy Trix",
      image: "/assets/newSlot/PT848.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-457",
    },
    {
      name: "Wolves! Cash Collect & Link™",
      image: "/assets/newSlot/PT850.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-350",
    },
    {
      name: "Wu Long",
      image: "/assets/newSlot/PT852.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-123",
    },
    {
      name: "Wushu Punch",
      image: "/assets/newSlot/PT854.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-233",
    },
    {
      name: "Xtreme Fire Blaze Roulette",
      image: "/assets/newSlot/PT855.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-353",
    },
    {
      name: "Yu Tu Jin Cai: Cash Collect",
      image: "/assets/newSlot/PT857.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-237",
    },
    {
      name: "Yun Cong Long",
      image: "/assets/newSlot/PT858.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-028",
    },
    {
      name: "Zhao Cai Jin Bao 2",
      image: "/assets/newSlot/PT861.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-180",
    },
    {
      name: "Zhao Cai Jin Bao",
      image: "/assets/newSlot/PT863.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-012",
    },
    {
      name: "Zhao Cai Tong Zi",
      image: "/assets/newSlot/PT864.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-014",
    },
    {
      name: "Zodiac Charms",
      image: "/assets/newSlot/PT865.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-164",
    },
    {
      name: "Sky Queen",
      image: "/assets/newSlot/PT966.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-007",
    },
    {
      name: "Blue Wizard",
      image: "/assets/newSlot/PT967.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-008",
    },
    {
      name: "Eternal Lady",
      image: "/assets/newSlot/PT968.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-025",
    },
    {
      name: "Golden Macaque",
      image: "/assets/newSlot/PT969.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-026",
    },
    {
      name: "Jinfu Long",
      image: "/assets/newSlot/PT970.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-029",
    },
    {
      name: "Jinns Moon",
      image: "/assets/newSlot/PT971.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-033",
    },
    {
      name: "Tiger, Turtle, Dragon, Phoenix",
      image: "/assets/newSlot/PT972.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-034",
    },
    {
      name: "Santa Surprise",
      image: "/assets/newSlot/PT973.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-056",
    },
    {
      name: "Fortunes of the Fox",
      image: "/assets/newSlot/PT974.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-062",
    },
    {
      name: "Heroes Arrow™",
      image: "/assets/newSlot/PT975.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-095",
    },
    {
      name: "Ishtar",
      image: "/assets/newSlot/PT976.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-156",
    },
    {
      name: "Pearls Pearls Pearls",
      image: "/assets/newSlot/PT978.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-178",
    },
    {
      name: "Legacy of the Tiger",
      image: "/assets/newSlot/PT979.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-193",
    },
    {
      name: "Legend of Hydra",
      image: "/assets/newSlot/PT980.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-194",
    },
    {
      name: "Adventure Trail",
      image: "/assets/newSlot/PT981.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-198",
    },
    {
      name: "Jinfu Xingyun",
      image: "/assets/newSlot/PT983.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-207",
    },
    {
      name: "Tsai Shen's Gift",
      image: "/assets/newSlot/PT984.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-210",
    },
    {
      name: "Pharaoh's Daughter",
      image: "/assets/newSlot/PT985.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-213",
    },
    {
      name: "Starmada Exiles",
      image: "/assets/newSlot/PT986.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-227",
    },
    {
      name: "Silent Samurai: Mega Cash Collect™",
      image: "/assets/newSlot/PT988.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-270",
    },
    {
      name: "Dragons Hall: Thundershots",
      image: "/assets/newSlot/PT977.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PT",
      gameType: "SLOT",
      casinoType: "PT-SLOT-158",
    },
  ],
  SMARTSOFT: [
    {
      name: "JetX",
      image: "/assets/newSlot/SS01.webp",
      platformImage: "/assets/platformHeader/smartsoft.webp",
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-001",
    },
    {
      name: "Balloon",
      image: "/assets/newSlot/SS02.webp",
      platformImage: "/assets/platformHeader/smartsoft.webp",
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-002",
    },
    {
      name: "FootballX",
      image: "/assets/newSlot/SS03.webp",
      platformImage: "/assets/platformHeader/smartsoft.webp",
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-003",
    },
    {
      name: "PlinkoX",
      image: "/assets/newSlot/SS04.webp",
      platformImage: "/assets/platformHeader/smartsoft.webp",
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-004",
    },
    {
      name: "MineIsland",
      image: "/assets/newSlot/SS05.webp",
      platformImage: "/assets/platformHeader/smartsoft.webp",
      platFormCode: "SMARTSOFT",
      gameType: "EGAME",
      casinoType: "SMARTSOFT-EGAME-005",
    },
  ],
  YL: [
    {
      name: "Shark Hunter",
      image: "/assets/newSlot/YL01.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-002",
    },
    {
      name: "Aviator",
      image: "/assets/newSlot/YL03.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-026",
    },
    {
      name: "Crash",
      image: "/assets/newSlot/YL04.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-016",
    },
    {
      name: "HILO",
      image: "/assets/newSlot/YL06.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-024",
    },
    {
      name: "MahjongWays",
      image: "/assets/newSlot/YL07.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-027",
    },
    {
      name: "KittyGold",
      image: "/assets/newSlot/YL08.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-019",
    },
    {
      name: "Mines",
      image: "/assets/newSlot/YL09.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-013",
    },
    {
      name: "Gems Miner",
      image: "/assets/newSlot/YL10.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-020",
    },
    {
      name: "Dice",
      image: "/assets/newSlot/YL11.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-017",
    },
    {
      name: "Plinko",
      image: "/assets/newSlot/YL12.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-018",
    },
    {
      name: "Thai HILO",
      image: "/assets/newSlot/YL13.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-024",
    },
    {
      name: "Tower",
      image: "/assets/newSlot/YL14.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-014",
    },
    {
      name: "Tower2",
      image: "/assets/newSlot/YL15.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-023",
    },
    {
      name: "Video Poker",
      image: "/assets/newSlot/YL16.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-025",
    },
    {
      name: "Wheel",
      image: "/assets/newSlot/YL17.webp",
      platformImage: "/assets/platformHeader/yellow.webp",
      platFormCode: "YL",
      gameType: "EGAME",
      casinoType: "YL-EGAME-021",
    },
  ],

  YESBINGO:[
  // -------------------SLOT YESBINGO STARt-----------------
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-022.webp",
    name: "Royal Ace",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-022",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-001.webp",
    name: "FortuneTreasure",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-001",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-020.webp",
    name: "Rolling Fortune",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-020",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-026.webp",
    name: "Golden Aztec Mega",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-026",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-019.webp",
    name: "Golden Aztec",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-019",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-011.webp",
    name: "Rolling 7",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-011",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-003.webp",
    name: "DragoNova",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-003",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-002.webp",
    name: "MoneyHorse",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-002",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-018.webp",
    name: "Boom Boom Marmot",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-018",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-021.webp",
    name: "Mermaid Slingo",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-021",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-008.webp",
    name: "MagicLamp",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-008",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-023.webp",
    name: "MagicLampLink",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-023",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-010.webp",
    name: "LuckyStar",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-010",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-009.webp",
    name: "Gladiator",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-009",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-013.webp",
    name: "Fancy Egypt",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-013",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-007.webp",
    name: "FaFaDragon",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-007",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-014.webp",
    name: "FortuneCat",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-014",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-017.webp",
    name: "King Arthur Gold",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-017",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-006.webp",
    name: "Power Mask",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-006",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-012.webp",
    name: "Thor Fortune",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-012",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-027.webp",
    name: "Sugar Crush",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-027",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-015.webp",
    name: "CasinoFantasy",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-015",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-029.webp",
    name: "Crazy Money",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-029",
  },

  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-028.webp",
    name: "Diva Ace",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-028",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-024.webp",
    name: "GladiatorLink",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-024",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-030.webp",
    name: "Lucky Meow",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-030",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-004.webp",
    name: "PowerFortune",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-004",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-005.webp",
    name: "PowerLion",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-005",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-031.webp",
    name: "Royal Hunter",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-031",
  },
  {
    image: "../assets/images/slot/yesbingo/YesBingo-SLOT-025.webp",
    name: "Super Egypt",
    category: "slot",
    type: "YESBINGO",
    pplatFormCode: "YESBINGO",
    gameType: "SLOT",
    casinoType: "YesBingo-SLOT-025",
  }],
  HACKSAW: [
    {
      name: "Sleepy Grandpa",
      image: "/assets/newSlot/HS001.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-143",
    },
    {
      name: "Pickle Bandits",
      image: "/assets/newSlot/HS002.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-152",
    },
    {
      name: "Cash Scratch",
      image: "/assets/newSlot/HS003.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-042",
    },
    {
      name: "LOVE is all you need",
      image: "/assets/newSlot/HS004.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-043",
    },
    {
      name: "Eggstra Cash",
      image: "/assets/newSlot/HS005.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-044",
    },
    {
      name: "Chaos Crew Scratch",
      image: "/assets/newSlot/HS006.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-045",
    },
    {
      name: "Football Scratch",
      image: "/assets/newSlot/HS007.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-046",
    },
    {
      name: "The Perfect Scratch",
      image: "/assets/newSlot/HS008.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-047",
    },
    {
      name: "Spooky Scary Scratchy",
      image: "/assets/newSlot/HS009.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-048",
    },
    {
      name: "Snow Scratcher",
      image: "/assets/newSlot/HS010.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-049",
    },
    {
      name: "Tiger Scratch",
      image: "/assets/newSlot/HS011.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-050",
    },
    {
      name: "Summer Scratch",
      image: "/assets/newSlot/HS012.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-052",
    },
    {
      name: "Commander of Tridents",
      image: "/assets/newSlot/HS013.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-142",
    },
    {
      name: "Stack 'em Scratch",
      image: "/assets/newSlot/HS014.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-051",
    },
    {
      name: "OmNom",
      image: "/assets/newSlot/HS015.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-054",
    },
    {
      name: "Miami Multiplier",
      image: "/assets/newSlot/HS016.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-055",
    },
    {
      name: "Cubes",
      image: "/assets/newSlot/HS017.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-056",
    },
    {
      name: "Cash Compass",
      image: "/assets/newSlot/HS018.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-057",
    },
    {
      name: "The Respinners",
      image: "/assets/newSlot/HS019.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-058",
    },
    {
      name: "Chaos Crew",
      image: "/assets/newSlot/HS020.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-059",
    },
    {
      name: "Mystery Motel",
      image: "/assets/newSlot/HS021.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-060",
    },
    {
      name: "Let It Snow",
      image: "/assets/newSlot/HS022.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-061",
    },
    {
      name: "Cubes 2",
      image: "/assets/newSlot/HS023.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-062",
    },
    {
      name: "Blademaster",
      image: "/assets/newSlot/HS024.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-153",
    },
    {
      name: "Aztec Twist",
      image: "/assets/newSlot/HS025.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-063",
    },
    {
      name: "Frutz",
      image: "/assets/newSlot/HS026.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-064",
    },
    {
      name: "Stack 'Em",
      image: "/assets/newSlot/HS027.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-065",
    },
    {
      name: "Hop'n'Pop",
      image: "/assets/newSlot/HS028.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-066",
    },
    {
      name: "Xpander",
      image: "/assets/newSlot/HS029.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-067",
    },
    {
      name: "Toshi Video Club",
      image: "/assets/newSlot/HS030.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-068",
    },
    {
      name: "Rocket Reels",
      image: "/assets/newSlot/HS031.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-069",
    },
    {
      name: "Wanted Dead or a Wild",
      image: "/assets/newSlot/HS032.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-070",
    },
    {
      name: "Cash Quest",
      image: "/assets/newSlot/HS033.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-071",
    },
    {
      name: "Tasty Treats",
      image: "/assets/newSlot/HS034.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-072",
    },
    {
      name: "The Cursed King",
      image: "/assets/newSlot/HS035.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-154",
    },
    {
      name: "Joker Bombs",
      image: "/assets/newSlot/HS036.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-073",
    },
    {
      name: "King Carrot",
      image: "/assets/newSlot/HS037.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-074",
    },
    {
      name: "Harvest Wilds",
      image: "/assets/newSlot/HS038.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-075",
    },
    {
      name: "The Bowery Boys",
      image: "/assets/newSlot/HS039.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-076",
    },
    {
      name: "Double Rainbow",
      image: "/assets/newSlot/HS040.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-077",
    },
    {
      name: "Warrior Ways",
      image: "/assets/newSlot/HS041.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-078",
    },
    {
      name: "Gladiator Legends",
      image: "/assets/newSlot/HS042.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-079",
    },
    {
      name: "Hand of Anubis",
      image: "/assets/newSlot/HS043.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-080",
    },
    {
      name: "ITERO",
      image: "/assets/newSlot/HS044.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-081",
    },
    {
      name: "Buffalo Stack'n'Sync",
      image: "/assets/newSlot/HS045.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-082",
    },
    {
      name: "Wild Dojo Strike",
      image: "/assets/newSlot/HS046.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-155",
    },
    {
      name: "Outlaws Inc.",
      image: "/assets/newSlot/HS047.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-083",
    },
    {
      name: "Born Wild",
      image: "/assets/newSlot/HS048.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-084",
    },
    {
      name: "Dork Unit",
      image: "/assets/newSlot/HS049.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-085",
    },
    {
      name: "Fruit Duel",
      image: "/assets/newSlot/HS050.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-086",
    },
    {
      name: "Mines",
      image: "/assets/newSlot/HS051.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-001",
    },
    {
      name: "Coins",
      image: "/assets/newSlot/HS052.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-002",
    },
    {
      name: "Boxes",
      image: "/assets/newSlot/HS053.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-003",
    },
    {
      name: "Time Spinners",
      image: "/assets/newSlot/HS054.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-087",
    },
    {
      name: "Forest Fortune",
      image: "/assets/newSlot/HS055.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-088",
    },
    {
      name: "Alpha Eagle",
      image: "/assets/newSlot/HS056.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-089",
    },
    {
      name: "Shadow Strike",
      image: "/assets/newSlot/HS057.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-156",
    },
    {
      name: "Undead Fortune",
      image: "/assets/newSlot/HS058.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-090",
    },
    {
      name: "Break Bones",
      image: "/assets/newSlot/HS059.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-091",
    },
    {
      name: "Pug Life",
      image: "/assets/newSlot/HS060.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-092",
    },
    {
      name: "Book of Time",
      image: "/assets/newSlot/HS061.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-093",
    },
    {
      name: "Gronk's Gems",
      image: "/assets/newSlot/HS062.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-094",
    },
    {
      name: "Rotten",
      image: "/assets/newSlot/HS063.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-095",
    },
    {
      name: "RIP City",
      image: "/assets/newSlot/HS064.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-096",
    },
    {
      name: "Frank's Farm",
      image: "/assets/newSlot/HS065.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-097",
    },
    {
      name: "Bloodthirst",
      image: "/assets/newSlot/HS066.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-098",
    },
    {
      name: "Magic Piggy",
      image: "/assets/newSlot/HS067.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-099",
    },
    {
      name: "Pirate Bonanza",
      image: "/assets/newSlot/HS068.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-157",
    },
    {
      name: "Keep 'em Cool",
      image: "/assets/newSlot/HS069.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-100",
    },
    {
      name: "Stormforged",
      image: "/assets/newSlot/HS070.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-101",
    },
    {
      name: "Fear the Dark",
      image: "/assets/newSlot/HS071.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-102",
    },
    {
      name: "Cursed Seas",
      image: "/assets/newSlot/HS072.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-103",
    },
    {
      name: "Mayan Stackways",
      image: "/assets/newSlot/HS073.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-104",
    },
    {
      name: "Temple of Torment",
      image: "/assets/newSlot/HS074.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-105",
    },
    {
      name: "Mighty Masks",
      image: "/assets/newSlot/HS075.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-106",
    },
    {
      name: "Plinko",
      image: "/assets/newSlot/HS076.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-004",
    },
    {
      name: "Beast Below",
      image: "/assets/newSlot/HS077.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-107",
    },
    {
      name: "Hi-Lo",
      image: "/assets/newSlot/HS078.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-005",
    },
    {
      name: "Le Pharaoh",
      image: "/assets/newSlot/HS079.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-158",
    },
    {
      name: "Vending Machine",
      image: "/assets/newSlot/HS080.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-108",
    },
    {
      name: "Drop'em",
      image: "/assets/newSlot/HS081.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-109",
    },
    {
      name: "Lines",
      image: "/assets/newSlot/HS082.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-006",
    },
    {
      name: "Ronin Stackways",
      image: "/assets/newSlot/HS083.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-110",
    },
    {
      name: "Le Bandit",
      image: "/assets/newSlot/HS084.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-111",
    },
    {
      name: "Densho",
      image: "/assets/newSlot/HS085.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-112",
    },
    {
      name: "Wheel",
      image: "/assets/newSlot/HS086.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-007",
    },
    {
      name: "Blocks",
      image: "/assets/newSlot/HS087.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "EGAME",
      casinoType: "HACKSAW-EGAME-008",
    },
    {
      name: "Chaos Crew 2",
      image: "/assets/newSlot/HS088.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-113",
    },
    {
      name: "Benny The Beer",
      image: "/assets/newSlot/HS089.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-114",
    },
    {
      name: "Cloud Princess",
      image: "/assets/newSlot/HS090.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-159",
    },
    {
      name: "Lucky Scratch",
      image: "/assets/newSlot/HS182.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-013",
    },
    {
      name: "Dream Car Urban",
      image: "/assets/newSlot/HS183.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-014",
    },
    {
      name: "Dream Car SUV",
      image: "/assets/newSlot/HS184.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-015",
    },
    {
      name: "Dream Car Speed",
      image: "/assets/newSlot/HS185.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-016",
    },
    {
      name: "Gold Rush",
      image: "/assets/newSlot/HS186.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-017",
    },
    {
      name: "Ruby Rush",
      image: "/assets/newSlot/HS187.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-018",
    },
    {
      name: "Diamond Rush",
      image: "/assets/newSlot/HS188.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-019",
    },
    {
      name: "Lucky Shot",
      image: "/assets/newSlot/HS189.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-020",
    },
    {
      name: "Lucky Numbers x8",
      image: "/assets/newSlot/HS190.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-021",
    },
    {
      name: "Junkyard Kings",
      image: "/assets/newSlot/HS191.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-150",
    },
    {
      name: "Lucky Numbers x12",
      image: "/assets/newSlot/HS192.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-022",
    },
    {
      name: "Lucky Numbers x16",
      image: "/assets/newSlot/HS193.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-023",
    },
    {
      name: "Lucky Numbers x20",
      image: "/assets/newSlot/HS194.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-024",
    },
    {
      name: "It's bananas!",
      image: "/assets/newSlot/HS195.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-025",
    },
    {
      name: "Cash Vault I",
      image: "/assets/newSlot/HS196.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-026",
    },
    {
      name: "Cash Vault II",
      image: "/assets/newSlot/HS197.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-027",
    },
    {
      name: "Cut the Grass",
      image: "/assets/newSlot/HS198.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-028",
    },
    {
      name: "Shave the Beard",
      image: "/assets/newSlot/HS199.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-029",
    },
    {
      name: "Scratch’em",
      image: "/assets/newSlot/HS200.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-030",
    },
    {
      name: "Double Salary - 1 Year",
      image: "/assets/newSlot/HS201.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-031",
    },
    {
      name: "Holy Heist",
      image: "/assets/newSlot/HS202.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-151",
    },
    {
      name: "Koi Cash",
      image: "/assets/newSlot/HS203.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-032",
    },
    {
      name: "Break the Ice",
      image: "/assets/newSlot/HS204.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-033",
    },
    {
      name: "Gold Coins",
      image: "/assets/newSlot/HS205.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-034",
    },
    {
      name: "Frogs scratch",
      image: "/assets/newSlot/HS206.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-035",
    },
    {
      name: "Shave the Sheep",
      image: "/assets/newSlot/HS207.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-036",
    },
    {
      name: "Rat Riches",
      image: "/assets/newSlot/HS208.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-037",
    },
    {
      name: "Balloons",
      image: "/assets/newSlot/HS209.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-038",
    },
    {
      name: "Crazy Donuts",
      image: "/assets/newSlot/HS210.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-039",
    },
    {
      name: "Go Panda",
      image: "/assets/newSlot/HS211.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-040",
    },
    {
      name: "Cash Pool",
      image: "/assets/newSlot/HS212.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-041",
    },
    {
      name: "Stick'em",
      image: "/assets/newSlot/HS213.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-053",
    },
    {
      name: "Grinning Harvest",
      image: "/assets/newSlot/HS214.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-199",
    },
    {
      name: "Le Cowboy",
      image: "/assets/newSlot/HS215.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-200",
    },
    {
      name: "Spear of Athena",
      image: "/assets/newSlot/HS216.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-201",
    },
    {
      name: "Miss Candy's Sweet Escape",
      image: "/assets/newSlot/HS217.webp",
      platformImage: "/assets/platformHeader/hacksaw.webp",
      platFormCode: "HACKSAW",
      gameType: "SLOT",
      casinoType: "HACKSAW-SLOT-202",
    },
  ],
  JOKER: [
    {
      name: "A Night Out",
      image: "/assets/newSlot/JK001.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-001",

      platFormCode: "JOKER",
    },
    {
      name: "Aladdin",
      image: "/assets/newSlot/JK002.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-002",

      platFormCode: "JOKER",
    },
    {
      name: "Alice",
      image: "/assets/newSlot/JK003.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-003",

      platFormCode: "JOKER",
    },
    {
      name: "Alice In Wonderland",
      image: "/assets/newSlot/JK004.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-004",
    },
    {
      name: "Ancient Artifact",
      image: "/assets/newSlot/JK005.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-005",
    },
    {
      name: "Ancient Egypt",
      image: "/assets/newSlot/JK006.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-006",
    },
    {
      name: "Ancient Rome Deluxe",
      image: "/assets/newSlot/JK007.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-007",
    },
    {
      name: "Archer",
      image: "/assets/newSlot/JK008.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-008",
    },
    {
      name: "Arctic Treasure",
      image: "/assets/newSlot/JK009.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-009",
    },
    {
      name: "Aztec Temple",
      image: "/assets/newSlot/JK010.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-010",
    },
    {
      name: "Azteca",
      image: "/assets/newSlot/JK011.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-011",
    },
    {
      name: "Bagua",
      image: "/assets/newSlot/JK012.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-012",
    },
    {
      name: "Bagua 2",
      image: "/assets/newSlot/JK013.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-013",
    },
    {
      name: "Bali",
      image: "/assets/newSlot/JK014.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-014",
    },
    {
      name: "Beach Life",
      image: "/assets/newSlot/JK015.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-015",
    },
    {
      name: "Beanstalk",
      image: "/assets/newSlot/JK016.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-016",
    },
    {
      name: "Big Game Safari",
      image: "/assets/newSlot/JK017.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-017",
    },
    {
      name: "Black Beard Legacy",
      image: "/assets/newSlot/JK018.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-018",
    },
    {
      name: "Black Knight",
      image: "/assets/newSlot/JK019.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-213",
    },
    {
      name: "Bonus Bear",
      image: "/assets/newSlot/JK020.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-019",
    },
    {
      name: "Book Of Ra Deluxe",
      image: "/assets/newSlot/JK021.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-021",
    },
    {
      name: "Book Of Ra",
      image: "/assets/newSlot/JK022.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-020",
    },
    {
      name: "Bounty Hunter",
      image: "/assets/newSlot/JK023.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-022",
    },
    {
      name: "Buccaneer Deluxe",
      image: "/assets/newSlot/JK024.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-023",
    },
    {
      name: "Bull Street",
      image: "/assets/newSlot/JK025.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-205",
    },
    {
      name: "Burning Pearl",
      image: "/assets/newSlot/JK026.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-024",
    },
    {
      name: "Bushido Blade",
      image: "/assets/newSlot/JK027.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-025",
    },
    {
      name: "Caishen Riches",
      image: "/assets/newSlot/JK028.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-026",
    },
    {
      name: "Captain's Treasure",
      image: "/assets/newSlot/JK030.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-027",
    },
    {
      name: "Captains Treasure Pro",
      image: "/assets/newSlot/JK031.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-028",
    },
    {
      name: "Captains Treasure Progressive",
      image: "/assets/newSlot/JK032.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-029",
    },
    {
      name: "Carnaval Do Rio",
      image: "/assets/newSlot/JK033.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-214",
    },
    {
      name: "Chilli Hunter Bandidos",
      image: "/assets/newSlot/JK034.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-228",
    },
    {
      name: "Chilli Hunter",
      image: "/assets/newSlot/JK035.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-030",
    },
    {
      name: "China",
      image: "/assets/newSlot/JK036.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-031",
    },
    {
      name: "Chinese Boss",
      image: "/assets/newSlot/JK037.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-032",
    },
    {
      name: "Chocolate Shop",
      image: "/assets/newSlot/JK038.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-212",
    },
    {
      name: "Christmas Eve",
      image: "/assets/newSlot/JK040.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-209",
    },
    {
      name: "Cluster Mania",
      image: "/assets/newSlot/JK041.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-033",
    },
    {
      name: "Columbus",
      image: "/assets/newSlot/JK042.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-034",
    },
    {
      name: "Critter Mania Deluxe",
      image: "/assets/newSlot/JK043.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-035",
    },
    {
      name: "Cryptomania",
      image: "/assets/newSlot/JK044.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-036",
    },
    {
      name: "Cursed Deluxe",
      image: "/assets/newSlot/JK045.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-037",
    },
    {
      name: "Cyber Race",
      image: "/assets/newSlot/JK046.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-038",
    },
    {
      name: "Dia De Los Muertos Deluxe",
      image: "/assets/newSlot/JK048.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-039",
    },
    {
      name: "Dolphin Reef",
      image: "/assets/newSlot/JK049.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-040",
      platFormCode: "JOKER",
    },
    {
      name: "Dolphin Treasure",
      image: "/assets/newSlot/JK050.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-041",
    },
    {
      name: "Dolphins Pearl Deluxe",
      image: "/assets/newSlot/JK051.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-042",
    },
    {
      name: "Dragon Of The Eastern Sea",
      image: "/assets/newSlot/JK052.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-043",
    },
    {
      name: "Dragon Phoenix",
      image: "/assets/newSlot/JK053.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-044",
    },
    {
      name: "Dragon Power Flame",
      image: "/assets/newSlot/JK054.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-045",
    },
    {
      name: "Dragon's Realm",
      image: "/assets/newSlot/JK055.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-046",
    },
    {
      name: "Dragon Ball",
      image: "/assets/newSlot/JK056.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-231",
    },
    {
      name: "Dynamite Reels",
      image: "/assets/newSlot/JK058.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-047",
    },
    {
      name: "Egypt Queen",
      image: "/assets/newSlot/JK059.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-048",
    },
    {
      name: "Empress Regnant",
      image: "/assets/newSlot/JK060.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-049",
    },
    {
      name: "Enchanted Forest",
      image: "/assets/newSlot/JK061.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-050",
    },
    {
      name: "Enter The KTV",
      image: "/assets/newSlot/JK062.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-051",
    },
    {
      name: "Fabulous Eights",
      image: "/assets/newSlot/JK063.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-052",
    },
    {
      name: "Fat Choy Choy Sun",
      image: "/assets/newSlot/JK065.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-053",
    },
    {
      name: "Fei Long Zai Tian",
      image: "/assets/newSlot/JK066.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-054",
    },
    {
      name: "Feng Huang",
      image: "/assets/newSlot/JK067.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-055",
    },
    {
      name: "Fifty Dragons",
      image: "/assets/newSlot/JK068.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-056",
    },
    {
      name: "Fifty Lions",
      image: "/assets/newSlot/JK069.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-057",
    },
    {
      name: "Fire Master Hold And Win",
      image: "/assets/newSlot/JK070.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-232",
    },
    {
      name: "Fire Reel",
      image: "/assets/newSlot/JK071.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-058",
    },
    {
      name: "Fire Reign",
      image: "/assets/newSlot/JK072.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-059",
    },
    {
      name: "Fire Temple",
      image: "/assets/newSlot/JK073.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-219",
    },
    {
      name: "Five Tiger Generals",
      image: "/assets/newSlot/JK076.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-060",
    },
    {
      name: "Flames Of Fortune",
      image: "/assets/newSlot/JK077.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-061",
    },
    {
      name: "Football Rules",
      image: "/assets/newSlot/JK078.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-062",
    },
    {
      name: "Forest Treasure",
      image: "/assets/newSlot/JK079.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-063",
    },
    {
      name: "Fortune Crown 25",
      image: "/assets/newSlot/JK080.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-225",
    },
    {
      name: "Fortune Crown",
      image: "/assets/newSlot/JK081.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-218",
    },
    {
      name: "Fortune Festival",
      image: "/assets/newSlot/JK082.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-064",
    },
    {
      name: "Fortune Crown Gold Gift",
      image: "/assets/newSlot/JK083.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-230",
    },
    {
      name: "Four Dragons",
      image: "/assets/newSlot/JK084.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-065",
    },
    {
      name: "Four Tigers",
      image: "/assets/newSlot/JK085.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-066",
    },
    {
      name: "Fruit Paradise",
      image: "/assets/newSlot/JK086.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-067",
    },
    {
      name: "Gates Of Wealth",
      image: "/assets/newSlot/JK087.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-201",
    },
    {
      name: "Geisha",
      image: "/assets/newSlot/JK088.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-068",
      platFormCode: "JOKER",
    },
    {
      name: "Genie 2",
      image: "/assets/newSlot/JK089.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-070",
    },
    {
      name: "Genie",
      image: "/assets/newSlot/JK090.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-069",
    },
    {
      name: "Gold Trail",
      image: "/assets/newSlot/JK091.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-071",
    },
    {
      name: "Golden Dragon",
      image: "/assets/newSlot/JK092.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-072",
    },
    {
      name: "Golden Island",
      image: "/assets/newSlot/JK093.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-073",
    },
    {
      name: "Golden Monkey King",
      image: "/assets/newSlot/JK094.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-074",
    },
    {
      name: "Golden Rooster",
      image: "/assets/newSlot/JK095.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-075",
    },
    {
      name: "Golden Sea",
      image: "/assets/newSlot/JK096.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-203",
    },
    {
      name: "Great Blue",
      image: "/assets/newSlot/JK097.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-076",
      platFormCode: "JOKER",
    },
    {
      name: "Happy Buddha",
      image: "/assets/newSlot/JK098.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-077",
    },
    {
      name: "Happy Party",
      image: "/assets/newSlot/JK100.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-078",
    },
    {
      name: "Haunted House",
      image: "/assets/newSlot/JK101.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-079",
    },
    {
      name: "Hawaii Vacay",
      image: "/assets/newSlot/JK102.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-210",
    },
    {
      name: "Heist Deluxe",
      image: "/assets/newSlot/JK103.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-080",
    },
    {
      name: "Hercules",
      image: "/assets/newSlot/JK104.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-081",
      platFormCode: "JOKER",
    },
    {
      name: "Highway Kings",
      image: "/assets/newSlot/JK105.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-082",
    },
    {
      name: "HighwayKings JP",
      image: "/assets/newSlot/JK106.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-083",
    },
    {
      name: "Horus Eye",
      image: "/assets/newSlot/JK107.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-084",
    },
    {
      name: "Hot Fruits",
      image: "/assets/newSlot/JK108.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-085",
    },
    {
      name: "Hot Wheels",
      image: "/assets/newSlot/JK109.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-207",
    },
    {
      name: "Huang Fei Hong",
      image: "/assets/newSlot/JK110.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-200",
    },
    {
      name: "Huga",
      image: "/assets/newSlot/JK111.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-086",
      platFormCode: "JOKER",
    },
    {
      name: "Immortals",
      image: "/assets/newSlot/JK112.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-087",
    },
    {
      name: "Inca",
      image: "/assets/newSlot/JK113.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-222",
    },
    {
      name: "Jiang Shi Night",
      image: "/assets/newSlot/JK114.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-237",
    },
    {
      name: "Jin Fu Xing Yun",
      image: "/assets/newSlot/JK115.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-088",
    },
    {
      name: "Joker Madness",
      image: "/assets/newSlot/JK116.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-089",
    },
    {
      name: "Journey To The West",
      image: "/assets/newSlot/JK117.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-090",
    },
    {
      name: "Jungle Island",
      image: "/assets/newSlot/JK118.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-091",
    },
    {
      name: "Just Jewels Deluxe",
      image: "/assets/newSlot/JK119.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-092",
    },
    {
      name: "Kraken Hunter",
      image: "/assets/newSlot/JK121.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-187",
    },
    {
      name: "Lady Hawk",
      image: "/assets/newSlot/JK122.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-093",
    },
    {
      name: "League Of Legends",
      image: "/assets/newSlot/JK123.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-094",
    },
    {
      name: "Legend Of Persia",
      image: "/assets/newSlot/JK124.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-216",
    },
    {
      name: "Leprechaun",
      image: "/assets/newSlot/JK125.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-188",
    },
    {
      name: "Lightning God",
      image: "/assets/newSlot/JK126.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-095",
    },
    {
      name: "Lion Of The East",
      image: "/assets/newSlot/JK127.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-191",
    },
    {
      name: "Lions Dance",
      image: "/assets/newSlot/JK128.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-096",
    },
    {
      name: "Lord Of The Ocean",
      image: "/assets/newSlot/JK129.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-097",
    },
    {
      name: "Savage Frontier",
      image: "/assets/newSlot/JK194.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-224",
    },
    {
      name: "Scheherazade",
      image: "/assets/newSlot/JK195.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-147",
    },
    {
      name: "Seven Seas",
      image: "/assets/newSlot/JK196.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-226",
    },
    {
      name: "Shaolin",
      image: "/assets/newSlot/JK197.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-148",
    },
    {
      name: "Silver Bullet",
      image: "/assets/newSlot/JK198.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-149",
    },
    {
      name: "Silver Hand",
      image: "/assets/newSlot/JK199.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-199",
    },
    {
      name: "SilverBullet Progressive",
      image: "/assets/newSlot/JK200.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-150",
    },
    {
      name: "Sizzling Hot",
      image: "/assets/newSlot/JK201.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-151",
    },
    {
      name: "Snake Of Fortune",
      image: "/assets/newSlot/JK202.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-211",
    },
    {
      name: "Sour Candy",
      image: "/assets/newSlot/JK204.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-195",
    },
    {
      name: "Sparta",
      image: "/assets/newSlot/JK205.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-152",

      platFormCode: "JOKER",
    },
    {
      name: "Steamboat Ride Hold And Win",
      image: "/assets/newSlot/JK206.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-227",
    },
    {
      name: "Streets Of Chicago",
      image: "/assets/newSlot/JK207.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-153",
    },
    {
      name: "Super Fortune Crown",
      image: "/assets/newSlot/JK208.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-236",
    },
    {
      name: "Super Seven Seas",
      image: "/assets/newSlot/JK209.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-233",
    },
    {
      name: "Super Stars",
      image: "/assets/newSlot/JK210.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-154",
    },
    {
      name: "Super Wild Watermelon",
      image: "/assets/newSlot/JK211.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-223",
    },
    {
      name: "Supreme Caishen",
      image: "/assets/newSlot/JK212.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-155",
    },
    {
      name: "Sweet Tooth",
      image: "/assets/newSlot/JK213.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-190",
    },
    {
      name: "Sweetie Crush",
      image: "/assets/newSlot/JK214.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-198",
    },
    {
      name: "Tai Shang Lao Jun",
      image: "/assets/newSlot/JK215.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-156",
    },
    {
      name: "Thai Paradise",
      image: "/assets/newSlot/JK217.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-158",

      platFormCode: "JOKER",
    },
    {
      name: "The 4 Invention",
      image: "/assets/newSlot/JK218.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-159",
    },
    {
      name: "The Legend Of White Snake",
      image: "/assets/newSlot/JK219.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-160",
    },
    {
      name: "Third Prince's Journey",
      image: "/assets/newSlot/JK220.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-161",
    },
    {
      name: "Three Kingdoms 2",
      image: "/assets/newSlot/JK221.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-162",
    },
    {
      name: "Three Kingdoms Quest",
      image: "/assets/newSlot/JK222.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-163",
    },
    {
      name: "Thug Life",
      image: "/assets/newSlot/JK223.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-164",
    },
    {
      name: "Thunder God",
      image: "/assets/newSlot/JK224.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-165",

      platFormCode: "JOKER",
    },
    {
      name: "Tigers Lair",
      image: "/assets/newSlot/JK225.webp",
      platformImage: "/assets/platformHeader/joker.webp",
      platFormCode: "JOKER",
      gameType: "SLOT",
      casinoType: "JOKER-SLOT-166",
    },
  ],
  LADYLUCK: [
    {
      name: "Lucky Heaven",
      image: "/assets/newSlot/LL01.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-003",
    },
    {
      name: "Orango Tango",
      image: "/assets/newSlot/LL03.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-004",
    },
    {
      name: "Quartz SiO2",
      image: "/assets/newSlot/LL04.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-006",
    },
    {
      name: "SpinJoy Society Megaways",
      image: "/assets/newSlot/LL06.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-009",
    },
    {
      name: "Total Summer Bliss",
      image: "/assets/newSlot/LL07.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-010",
    },
    {
      name: "Valhöll Wild Hammers",
      image: "/assets/newSlot/LL08.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-011",
    },
    {
      name: "Valley of the Muses",
      image: "/assets/newSlot/LL09.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-012",
    },
    {
      name: "Weight of the Gun",
      image: "/assets/newSlot/LL10.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-013",
    },
    {
      name: "Cuddles Royal",
      image: "/assets/newSlot/LL11.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-002",
    },
    {
      name: "Cherry Supreme",
      image: "/assets/newSlot/LL12.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-001",
    },
    {
      name: "Spinjoy Society",
      image: "/assets/newSlot/LL13.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-008",
    },
    {
      name: "The treasures of Tizoc",
      image: "/assets/newSlot/LL14.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-016",
    },
    {
      name: "Lucky Mr Wild",
      image: "/assets/newSlot/LL15.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-018",
    },
    {
      name: "Mr. Alchemister",
      image: "/assets/newSlot/LL16.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-019",
    },
    {
      name: "Madame Clues",
      image: "/assets/newSlot/LL17.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-020",
    },
    {
      name: "Astro Anna",
      image: "/assets/newSlot/LL18.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-015",
    },
    {
      name: "Popeye",
      image: "/assets/newSlot/LL19.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-005",
    },
    {
      name: "Ruler of Egypt",
      image: "/assets/newSlot/LL05.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-007",
    },
    {
      name: "Xmas at the Cabin",
      image: "/assets/newSlot/LL02.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-014",
    },
    {
      name: "Valhöll Hall of the Slain",
      image: "/assets/newSlot/LL23.webp",
      platformImage: "/assets/platformHeader/ladyluck.webp",
      platFormCode: "LADYLUCK",
      gameType: "SLOT",
      casinoType: "LADYLUCK-SLOT-017",
    },
  ],
  CG: [
    {
      name: "Aladdin",
      image: "/assets/newSlot/CG001.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-077",
    },
    {
      name: "Aladdin2",
      image: "/assets/newSlot/CG002.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-087",
    },
    {
      name: "Alice",
      image: "/assets/newSlot/CG003.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-068",
    },
    {
      name: "Angry Birds",
      image: "/assets/newSlot/CG004.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-018",
    },
    {
      name: "Arcadia",
      image: "/assets/newSlot/CG005.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-023",
    },
    {
      name: "Artificial Girl",
      image: "/assets/newSlot/CG006.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-064",
    },
    {
      name: "As The Gods Will",
      image: "/assets/newSlot/CG007.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-026",
    },
    {
      name: "Astronaut",
      image: "/assets/newSlot/CG008.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-019",
    },
    {
      name: "WarShip Girls",
      image: "/assets/newSlot/CG009.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-058",
    },
    {
      name: "Black Sheep",
      image: "/assets/newSlot/CG010.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-053",
    },
    {
      name: "Richman",
      image: "/assets/newSlot/CG011.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-001",
    },
    {
      name: "Richman Crash",
      image: "/assets/newSlot/CG012.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-016",
    },
    {
      name: "Rich Runner",
      image: "/assets/newSlot/CG013.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-004",
    },
    {
      name: "RoosterFightingClub",
      image: "/assets/newSlot/CG014.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-023",
    },
    {
      name: "Rugby World Cup",
      image: "/assets/newSlot/CG015.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-088",
    },
    {
      name: "Seven Lucky God",
      image: "/assets/newSlot/CG016.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-050",
    },
    {
      name: "Dragon Game Poker",
      image: "/assets/newSlot/CG017.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-003",
    },
    {
      name: "Six Lions",
      image: "/assets/newSlot/CG018.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-052",
    },
    {
      name: "Special Chef",
      image: "/assets/newSlot/CG020.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-035",
    },
    {
      name: "Street Fighter 6",
      image: "/assets/newSlot/CG022.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-022",
    },
    {
      name: "Street Fighter V",
      image: "/assets/newSlot/CG023.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-009",
    },
    {
      name: "Sun Quest",
      image: "/assets/newSlot/CG024.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-044",
    },
    {
      name: "Taiko Master",
      image: "/assets/newSlot/CG025.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-055",
    },
    {
      name: "Tai Wang Si Shen",
      image: "/assets/newSlot/CG026.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-005",
    },
    {
      name: "Tarzan",
      image: "/assets/newSlot/CG027.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-029",
    },
    {
      name: "TEKKEN7",
      image: "/assets/newSlot/CG028.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-025",
    },
    {
      name: "Travel Frog",
      image: "/assets/newSlot/CG029.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-061",
    },
    {
      name: "777",
      image: "/assets/newSlot/CG030.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-021",
    },
    {
      name: "Tropical Island",
      image: "/assets/newSlot/CG031.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-076",
    },
    {
      name: "PUBG",
      image: "/assets/newSlot/CG032.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-091",
    },
    {
      name: "BreakAway",
      image: "/assets/newSlot/CG033.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-006",
    },
    {
      name: "True Zhao Cai Jin Bao",
      image: "/assets/newSlot/CG034.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-047",
    },
    {
      name: "Zhao Cai Jin Bao",
      image: "/assets/newSlot/CG041.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-039",
    },
    {
      name: "Pikachu Volleyball",
      image: "/assets/newSlot/CG035.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-011",
    },
    {
      name: "City Of Poli",
      image: "/assets/newSlot/CG036.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-024",
    },
    {
      name: "War Hammer 40K",
      image: "/assets/newSlot/CG037.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-060",
    },
    {
      name: "2024Weightlifting",
      image: "/assets/newSlot/CG039.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-032",
    },
    {
      name: "Wu Lu Cai Shen",
      image: "/assets/newSlot/CG040.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-036",
    },
    {
      name: "Zhao Cai Tong Zi",
      image: "/assets/newSlot/CG042.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-038",
    },
    {
      name: "Bean Stalk",
      image: "/assets/newSlot/CG043.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-082",
    },
    {
      name: "Zombie Hunter",
      image: "/assets/newSlot/CG044.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-063",
    },
    {
      name: "Benz BMW",
      image: "/assets/newSlot/CG045.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-007",
    },
    {
      name: "Bingo Baccarat",
      image: "/assets/newSlot/CG046.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-024",
    },
    {
      name: "Speed Racing",
      image: "/assets/newSlot/CG047.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-032",
    },
    {
      name: "Captain Tsubasa",
      image: "/assets/newSlot/CG048.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-013",
    },
    {
      name: "Chaoji 8",
      image: "/assets/newSlot/CG049.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-022",
    },
    {
      name: "Chinese New Year",
      image: "/assets/newSlot/CG050.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-083",
    },
    {
      name: "Amazing Circus",
      image: "/assets/newSlot/CG051.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-004",
    },
    {
      name: "CrossyRoad Crash",
      image: "/assets/newSlot/CG052.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-017",
    },
    {
      name: "Crossy Road",
      image: "/assets/newSlot/CG053.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-062",
    },
    {
      name: "2024CyclingTrack",
      image: "/assets/newSlot/CG054.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-028",
    },
    {
      name: "Deuces Wild",
      image: "/assets/newSlot/CG055.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-002",
    },
    {
      name: "Diamond Slot",
      image: "/assets/newSlot/CG056.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-030",
    },
    {
      name: "DragonBallXV2",
      image: "/assets/newSlot/CG057.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-033",
    },
    {
      name: "Dragon Skies",
      image: "/assets/newSlot/CG058.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-025",
    },
    {
      name: "5Treasures",
      image: "/assets/newSlot/CG059.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-007",
    },
    {
      name: "88Fortunes",
      image: "/assets/newSlot/CG060.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-008",
    },
    {
      name: "DancingDrum",
      image: "/assets/newSlot/CG061.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-010",
    },
    {
      name: "DiamondEternity",
      image: "/assets/newSlot/CG062.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-009",
    },
    {
      name: "FlowerOfRiches",
      image: "/assets/newSlot/CG063.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-011",
    },
    {
      name: "Lost in Egypt",
      image: "/assets/newSlot/CG064.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-079",
    },
    {
      name: "Scarab",
      image: "/assets/newSlot/CG065.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-089",
    },
    {
      name: "Electro Rebel",
      image: "/assets/newSlot/CG066.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-095",
    },
    {
      name: "Evil Cat",
      image: "/assets/newSlot/CG067.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-094",
    },
    {
      name: "Fa Fa Fa",
      image: "/assets/newSlot/CG068.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-020",
    },
    {
      name: "Falling Sakura",
      image: "/assets/newSlot/CG069.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-065",
    },
    {
      name: "50 Lions",
      image: "/assets/newSlot/CG070.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-031",
    },
    {
      name: "Fishing Expert",
      image: "/assets/newSlot/CG071.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-037",
    },
    {
      name: "Fish Party",
      image: "/assets/newSlot/CG072.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-041",
    },
    {
      name: "Wu Zi Ci Mile",
      image: "/assets/newSlot/CG073.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-051",
    },
    {
      name: "5 Dragons",
      image: "/assets/newSlot/CG074.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-045",
    },
    {
      name: "5 Dealers",
      image: "/assets/newSlot/CG075.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-049",
    },
    {
      name: "Good Fortune",
      image: "/assets/newSlot/CG077.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-092",
    },
    {
      name: "Fox Spirit",
      image: "/assets/newSlot/CG078.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-081",
    },
    {
      name: "Funky Monkey",
      image: "/assets/newSlot/CG079.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-018",
    },
    {
      name: "Geisha",
      image: "/assets/newSlot/CG080.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-075",
    },
    {
      name: "Great Blue",
      image: "/assets/newSlot/CG081.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-090",
    },
    {
      name: "Halloween",
      image: "/assets/newSlot/CG082.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-003",
    },
    {
      name: "Halloween Party",
      image: "/assets/newSlot/CG083.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-096",
    },
    {
      name: "2024Hockey2024",
      image: "/assets/newSlot/CG084.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-029",
    },
    {
      name: "Horizon",
      image: "/assets/newSlot/CG085.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-084",
    },
    {
      name: "Hungry Hungry Shark",
      image: "/assets/newSlot/CG086.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-027",
    },
    {
      name: "Ice Storm",
      image: "/assets/newSlot/CG087.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-085",
    },
    {
      name: "JOJO",
      image: "/assets/newSlot/CG088.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-020",
    },
    {
      name: "Blooming Riches",
      image: "/assets/newSlot/CG089.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-016",
    },
    {
      name: "Eternal Diamond",
      image: "/assets/newSlot/CG090.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-014",
    },
    {
      name: "Fountain Of Wealth",
      image: "/assets/newSlot/CG091.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-015",
    },
    {
      name: "Golden Tale",
      image: "/assets/newSlot/CG092.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-013",
    },
    {
      name: "Rhythm Of Fortune",
      image: "/assets/newSlot/CG093.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-017",
    },
    {
      name: "Jump Force",
      image: "/assets/newSlot/CG094.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-021",
    },
    {
      name: "Bright & Abyss",
      image: "/assets/newSlot/CG126.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-067",
    },
    {
      name: "Plinko",
      image: "/assets/newSlot/CG127.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-010",
    },
    {
      name: "Jo ma ji",
      image: "/assets/newSlot/CG128.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-028",
    },
    {
      name: "POPMART",
      image: "/assets/newSlot/CG129.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-093",
    },
    {
      name: "Platinum",
      image: "/assets/newSlot/CG130.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-012",
    },
    {
      name: "2024Volleyball",
      image: "/assets/newSlot/CG035.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "EGAME",
      casinoType: "CG-EGAME-031",
    },
    {
      name: "Slam Dunk",
      image: "/assets/newSlot/CG131.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-098",
    },
    {
      name: "Cricket Star ITP",
      image: "/assets/newSlot/CG133.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-100",
    },
    {
      name: "Basketball Star ITP",
      image: "/assets/newSlot/CG134.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-101",
    },
    {
      name: "Treasure Frog",
      image: "/assets/newSlot/CG135.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-102",
    },
    {
      name: "TrialByViking",
      image: "/assets/newSlot/CG136.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-103",
    },
    {
      name: "BAKI",
      image: "/assets/newSlot/CG137.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-104",
    },
    {
      name: "Kimba",
      image: "/assets/newSlot/CG138.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-105",
    },
    {
      name: "Dragon Black Gold",
      image: "/assets/newSlot/CG139.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-106",
    },
    {
      name: "EPICAPE",
      image: "/assets/newSlot/CG140.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-107",
    },
    {
      name: "Kleo Patra",
      image: "/assets/newSlot/CG141.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-108",
    },
    {
      name: "Atocha Treasure",
      image: "/assets/newSlot/CG142.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-109",
    },
    {
      name: "Case Closed",
      image: "/assets/newSlot/CG143.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-110",
    },
    {
      name: "TreasureIsland",
      image: "/assets/newSlot/CG144.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-111",
    },
    {
      name: "Gold Musa I",
      image: "/assets/newSlot/CG145.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-112",
    },
    {
      name: "Chinese Halloween",
      image: "/assets/newSlot/CG146.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-113",
    },
    {
      name: "Gold Meow Sushi Legend",
      image: "/assets/newSlot/CG147.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-114",
    },
    {
      name: "The Wizard of OZ",
      image: "/assets/newSlot/CG148.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-115",
    },
    {
      name: "Mystic Witch",
      image: "/assets/newSlot/CG149.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-116",
    },
    {
      name: "Gold Aynu",
      image: "/assets/newSlot/CG150.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-117",
    },
    {
      name: "Pharaoh Resort Hotel",
      image: "/assets/newSlot/CG151.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-118",
    },
    {
      name: "DJ Remix",
      image: "/assets/newSlot/CG152.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-119",
    },
    {
      name: "Triple Monkey",
      image: "/assets/newSlot/CG153.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-120",
    },
    {
      name: "Mystic Nine",
      image: "/assets/newSlot/CG154.webp",
      platformImage: "/assets/platformHeader/cg.webp",
      platFormCode: "CG",
      gameType: "SLOT",
      casinoType: "CG-SLOT-121",
    },
  ],
  KM: [
    {
      name: "Sugar Blast",
      image: "/assets/newSlot/KM01.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-001",
    },
    {
      name: "Gems of Valhalla",
      image: "/assets/newSlot/KM02.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-002",
    },
    {
      name: "Sugar Blast Frenzy",
      image: "/assets/newSlot/KM03.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-003",
    },
    {
      name: "Cleopatra's Treasure",
      image: "/assets/newSlot/KM04.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-004",
    },
    {
      name: "Rooster Blitz",
      image: "/assets/newSlot/KM05.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-005",
    },
    {
      name: "Gold Mine",
      image: "/assets/newSlot/KM06.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-006",
    },
    {
      name: "ALMIGHTY GREEK",
      image: "/assets/newSlot/KM07.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-007",
    },
    {
      name: "WARRIORS TEMPLE",
      image: "/assets/newSlot/KM08.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-008",
    },
    {
      name: "LEPPY LOOT",
      image: "/assets/newSlot/KM09.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-009",
    },
    {
      name: "GOLD RUSH BONANZA",
      image: "/assets/newSlot/KM10.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-010",
    },
    {
      name: "PIGGY HEIST",
      image: "/assets/newSlot/KM11.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-011",
    },
    {
      name: "MERLIN'S SAGA",
      image: "/assets/newSlot/KM12.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-012",
    },
    {
      name: "LONDON MYSTERY",
      image: "/assets/newSlot/KM13.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-013",
    },
    {
      name: "HORUS GLORY",
      image: "/assets/newSlot/KM14.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-014",
    },
    {
      name: "PIRATE'S TREASURE",
      image: "/assets/newSlot/KM15.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-015",
    },
    {
      name: "Hippo Splash",
      image: "/assets/newSlot/KM16.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-016",
    },
    {
      name: "Cupid Archery",
      image: "/assets/newSlot/KM17.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-017",
    },
    {
      name: "ROME GLADIATOR",
      image: "/assets/newSlot/KM18.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-018",
    },
    {
      name: "Hunk Cai Shen",
      image: "/assets/newSlot/KM19.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-019",
    },
    {
      name: "Dear Senpai",
      image: "/assets/newSlot/KM20.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-020",
    },
    {
      name: "Salsa Fury",
      image: "/assets/newSlot/KM21.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-021",
    },
    {
      name: "Aztec Fortune",
      image: "/assets/newSlot/KM22.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-022",
    },
    {
      name: "Treasures of Olympus 1000",
      image: "/assets/newSlot/KM23.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-023",
    },
    {
      name: "Bunny VIP Night",
      image: "/assets/newSlot/KM24.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-024",
    },
    {
      name: "Cleopatra’s Fortune Ways",
      image: "/assets/newSlot/KM25.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-025",
    },
    {
      name: "Mahjong Dragon Ways",
      image: "/assets/newSlot/KM26.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-026",
    },
    {
      name: "Mahjong Beauty",
      image: "/assets/newSlot/KM27.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-027",
    },
    {
      name: "Lucky Cat Gala",
      image: "/assets/newSlot/KM28.webp",
      platformImage: "/assets/platformHeader/km-logo.webp",
      platFormCode: "KINGMAKER",
      gameType: "SLOT",
      casinoType: "KM-SLOT-028",
    },
  ],
  SPADE: [
    {
      name: "5FortuneDragons",
      image: "/assets/newSlot/SG01.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-039",
    },
    {
      name: "5FortuneSA",
      image: "/assets/newSlot/SG04.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-030",
    },
    {
      name: "888",
      image: "/assets/newSlot/SG05.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-069",
    },
    {
      name: "BabyCaiShen",
      image: "/assets/newSlot/SG07.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-031",
    },
    {
      name: "BigProsperitySA",
      image: "/assets/newSlot/SG08.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-021",
    },
    {
      name: "BookofMyth",
      image: "/assets/newSlot/SG10.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-077",
    },
    {
      name: "BrothersKingdom",
      image: "/assets/newSlot/SG11.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-084",
    },
    {
      name: "CaiShen888",
      image: "/assets/newSlot/SG12.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-037",
    },
    {
      name: "Caishen Deluxe Maxways",
      image: "/assets/newSlot/SG13.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-121",
    },
    {
      name: "Caishen",
      image: "/assets/newSlot/SG14.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-109",
    },
    {
      name: "Candy Candy",
      image: "/assets/newSlot/SG15.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-101",
    },
    {
      name: "Candy Pop 2",
      image: "/assets/newSlot/SG16.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-123",
    },
    {
      name: "Candy Pop",
      image: "/assets/newSlot/SG17.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-001",
    },
    {
      name: "Captain Golds Fortune",
      image: "/assets/newSlot/SG18.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-114",
    },
    {
      name: "Christmas Miracles",
      image: "/assets/newSlot/SG19.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-119",
    },
    {
      name: "Clash of the Giants",
      image: "/assets/newSlot/SG20.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-139",
    },
    {
      name: "CrazyBomber",
      image: "/assets/newSlot/SG21.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-078",
    },
    {
      name: "DaFuXiaoFu",
      image: "/assets/newSlot/SG22.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-055",
    },
    {
      name: "DoubleFlame",
      image: "/assets/newSlot/SG24.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-076",
    },
    {
      name: "DoubleFortunes",
      image: "/assets/newSlot/SG25.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-038",
    },
    {
      name: "DragonGoldSA",
      image: "/assets/newSlot/SG27.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-019",
    },
    {
      name: "Fafafa",
      image: "/assets/newSlot/SG31.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-045",
    },
    {
      name: "FaFaFa2",
      image: "/assets/newSlot/SG32.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-003",
    },
    {
      name: "Farmland Frenzy Maxways",
      image: "/assets/newSlot/SG33.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-122",
    },
    {
      name: "Fiery Sevens Exclusive",
      image: "/assets/newSlot/SG34.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-106",
    },
    {
      name: "FierySevens",
      image: "/assets/newSlot/SG35.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-079",
    },
    {
      name: "FirstLove",
      image: "/assets/newSlot/SG36.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-008",
    },
    {
      name: "Fruits Mania",
      image: "/assets/newSlot/SG37.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-112",
    },
    {
      name: "Galaxy Guardian",
      image: "/assets/newSlot/SG38.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-142",
    },
    {
      name: "Gemstone Rush",
      image: "/assets/newSlot/SG39.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-126",
    },
    {
      name: "Gold Panther Maxways",
      image: "/assets/newSlot/SG40.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-111",
    },
    {
      name: "GoldenChicken",
      image: "/assets/newSlot/SG41.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-018",
    },
    {
      name: "GoldenLotusSE",
      image: "/assets/newSlot/SG42.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-032",
    },
    {
      name: "GoldenMonkey",
      image: "/assets/newSlot/SG43.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-009",
    },
    {
      name: "GoldenWhale",
      image: "/assets/newSlot/SG44.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-058",
    },
    {
      name: "GreatStarsSA",
      image: "/assets/newSlot/SG45.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-022",
    },
    {
      name: "Halloween Vacation",
      image: "/assets/newSlot/SG47.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-117",
    },
    {
      name: "HeroesGame",
      image: "/assets/newSlot/SG49.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-068",
    },
    {
      name: "HighwayFortune",
      image: "/assets/newSlot/SG50.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-049",
    },
    {
      name: "HoYeahMonkey",
      image: "/assets/newSlot/SG51.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-017",
    },
    {
      name: "Hugon Quest",
      image: "/assets/newSlot/SG52.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-089",
    },
    {
      name: "IcelandSA",
      image: "/assets/newSlot/SG53.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-023",
    },
    {
      name: "Joker's Treasure Exclusive",
      image: "/assets/newSlot/SG54.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-108",
    },
    {
      name: "JokersTreasure",
      image: "/assets/newSlot/SG55.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-075",
    },
    {
      name: "Journey to the Wild",
      image: "/assets/newSlot/SG56.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-113",
    },
    {
      name: "JungleKing",
      image: "/assets/newSlot/SG57.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-012",
    },
    {
      name: "KingPharaoh",
      image: "/assets/newSlot/SG58.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-034",
    },
    {
      name: "Legacy Of Kong Maxways",
      image: "/assets/newSlot/SG59.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-116",
    },
    {
      name: "Love Idol",
      image: "/assets/newSlot/SG61.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-093",
    },
    {
      name: "LuckyFengShui",
      image: "/assets/newSlot/SG63.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-046",
    },
    {
      name: "Lucky Koi Exclusive",
      image: "/assets/newSlot/SG64.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-107",
    },
    {
      name: "LuckyKoi",
      image: "/assets/newSlot/SG65.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-041",
    },
    {
      name: "Magic Kitty",
      image: "/assets/newSlot/SG66.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-091",
    },
    {
      name: "MagicalLamp",
      image: "/assets/newSlot/SG67.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-080",
    },
    {
      name: "Mega7",
      image: "/assets/newSlot/SG69.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-074",
    },
    {
      name: "Moji Mania",
      image: "/assets/newSlot/SG70.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-127",
    },
    {
      name: "MrChuTycoon",
      image: "/assets/newSlot/SG72.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-083",
    },
    {
      name: "Muay Thai Fighter",
      image: "/assets/newSlot/SG73.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-097",
    },
    {
      name: "Poker Ways",
      image: "/assets/newSlot/SG76.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-095",
    },
    {
      name: "PrincessWang",
      image: "/assets/newSlot/SG77.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-005",
    },
    {
      name: "ProsperityGods",
      image: "/assets/newSlot/SG78.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-085",
    },
    {
      name: "Rabbit Riches",
      image: "/assets/newSlot/SG79.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-120",
    },
    {
      name: "Rich Caishen",
      image: "/assets/newSlot/SG80.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-096",
    },
    {
      name: "Rise Of Werewolves",
      image: "/assets/newSlot/SG81.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-087",
    },
    {
      name: "Roma",
      image: "/assets/newSlot/SG82.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-102",
    },
    {
      name: "Royal Katt",
      image: "/assets/newSlot/SG83.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-098",
    },
    {
      name: "Royale House",
      image: "/assets/newSlot/SG84.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-105",
    },
    {
      name: "Royale Vegas",
      image: "/assets/newSlot/SG85.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-140",
    },
    {
      name: "Sexy Vegas",
      image: "/assets/newSlot/SG86.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-103",
    },
    {
      name: "Space Conquest",
      image: "/assets/newSlot/SG87.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-110",
    },
    {
      name: "Sugar Bonanza",
      image: "/assets/newSlot/SG88.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-092",
    },
    {
      name: "Sugar Party",
      image: "/assets/newSlot/SG89.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-115",
    },
    {
      name: "SweetBakery",
      image: "/assets/newSlot/SG91.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-072",
    },
    {
      name: "ThreeLuckyStars",
      image: "/assets/newSlot/SG92.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-073",
    },
    {
      name: "Tiger Dance",
      image: "/assets/newSlot/SG93.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-104",
    },
    {
      name: "TigerWarrior",
      image: "/assets/newSlot/SG94.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-014",
    },
    {
      name: "TriplePanda",
      image: "/assets/newSlot/SG95.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-081",
    },
    {
      name: "WowProsperity",
      image: "/assets/newSlot/SG97.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-006",
    },
    {
      name: "Space Crasher",
      image: "/assets/newSlot/SG99.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "EGAME",
      casinoType: "SG-EGAME-003",
    },
    {
      name: "Fishing God",
      image: "/assets/newSlot/SG100.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-001",
    },
    {
      name: "Alien Hunter",
      image: "/assets/newSlot/SG102.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-003",
    },
    {
      name: "Zombie Party",
      image: "/assets/newSlot/SG103.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-004",
    },
    {
      name: "Fishing Legend",
      image: "/assets/newSlot/SG104.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-005",
    },
    {
      name: "ZEUS",
      image: "/assets/newSlot/SG106.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-016",
    },
    {
      name: "LuckyMeow",
      image: "/assets/newSlot/SG107.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-060",
    },
    {
      name: "DancingFever",
      image: "/assets/newSlot/SG108.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-070",
    },
    {
      name: "MoneyMouse",
      image: "/assets/newSlot/SG109.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-071",
    },
    {
      name: "GoldPanther",
      image: "/assets/newSlot/SG111.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-082",
    },
    {
      name: "Mayan Gems",
      image: "/assets/newSlot/SG112.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-086",
    },
    {
      name: "Wild Wet Win",
      image: "/assets/newSlot/SG113.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-099",
    },
    {
      name: "Gold Rush Cowboy",
      image: "/assets/newSlot/SG114.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-100",
    },
    {
      name: "Hammer of Thunder",
      image: "/assets/newSlot/SG116.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-124",
    },
    {
      name: "Dragon Wish",
      image: "/assets/newSlot/SG117.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-141",
    },
    {
      name: "Brothers Kingdom 2",
      image: "/assets/newSlot/SG118.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-143",
    },
    {
      name: "Secrets of Anubis",
      image: "/assets/newSlot/SG119.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-144",
    },
    {
      name: "Alchemy Quest Level Up",
      image: "/assets/newSlot/SG120.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-145",
    },
    {
      name: "Fury Max Lucky Road",
      image: "/assets/newSlot/SG121.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-146",
    },
    {
      name: "Lucky Twin Sea",
      image: "/assets/newSlot/SG122.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-147",
    },
    {
      name: "Gold West",
      image: "/assets/newSlot/SG123.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-148",
    },
    {
      name: "Happy Neko",
      image: "/assets/newSlot/SG124.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-149",
    },
    {
      name: "Fruit Ninja Fury",
      image: "/assets/newSlot/SG125.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-150",
    },
    {
      name: "Santa Wild Drop",
      image: "/assets/newSlot/SG126.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-151",
    },
    {
      name: "Lucky Snake Wheel",
      image: "/assets/newSlot/SG127.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-152",
    },
    {
      name: "Fiery Sevens Hot 5",
      image: "/assets/newSlot/SG128.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-153",
    },
    {
      name: "Fiery Sevens Hot 20",
      image: "/assets/newSlot/SG129.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-154",
    },
    {
      name: "Fiery Sevens Hot 50",
      image: "/assets/newSlot/SG130.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-155",
    },
    {
      name: "Fiery Sevens Hot 100",
      image: "/assets/newSlot/SG131.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-156",
    },
    {
      name: "Mahjong Riches",
      image: "/assets/newSlot/SG132.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-157",
    },
    {
      name: "Golden Pixiu",
      image: "/assets/newSlot/SG133.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-158",
    },
    {
      name: "Juicy Market",
      image: "/assets/newSlot/SG134.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-159",
    },
    {
      name: "Legacy of Ramakien",
      image: "/assets/newSlot/SG135.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-160",
    },
    {
      name: "Mister Cashmore",
      image: "/assets/newSlot/SG137.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-162",
    },
    {
      name: "Hallo Win Party",
      image: "/assets/newSlot/SG138.webp",
      platformImage: "/assets/platformHeader/spade.webp",
      platFormCode: "SPADE",
      gameType: "SLOT",
      casinoType: "SG-SLOT-163",
    },
  ],
};

export const Poker = {
  JILI: [
    {
      name: "Domino Go",
      image:
        "/assets/poker/JL0216.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-073",
    },
    {
      name: "Ultimate Texas Hold'em",
      image:
        "/assets/poker/JL0188.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-061",
    },
    {
      name: "Pool Rummy",
      image:
        "/assets/poker/JL0141.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-048",
    },
    {
      name: "Mini Flush",
      image:
        "/assets/poker/JL0135.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-042",
    },
    {
      name: "Blackjack Lucky Ladies",
      image:
        "/assets/poker/JL0133.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-046",
    },
    {
      name: "Blackjack",
      image:
        "/assets/poker/JL0129.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-044",
    },
    {
      name: "Pusoy Go",
      image:
        "/assets/poker/JL0120.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-038",
    },
    {
      name: "Ludo Quick",
      image:
        "/assets/poker/JL0092.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-021",
    },
    {
      name: "Tongits Go",
      image:
        "/assets/poker/JL0091.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-025",
    },
    {
      name: "Teen Patti 20-20",
      image:
        "/assets/poker/JL0082.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JDB",
      gameType: "TABLE",
      casinoType: "JDB-TABLE-007",
    },
    {
      name: "Callbreak Quick",
      image:
        "/assets/poker/JL0081.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-013",
    },
    {
      name: "Teen Patti Joker",
      image:
        "/assets/poker/JL0080.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
    },
    {
      name: "Callbreak",
      image:
        "/assets/poker/JL0079.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-009",
    },
    {
      name: "Rummy",
      image:
        "/assets/poker/JL0078.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-004",
    },
    {
      name: "Andar Bahar",
      image:
        "/assets/poker/JL0077.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-003",
    },
    {
      name: "AK47",
      image:
        "/assets/poker/JL0076.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-002",
    },
    {
      name: "Teen Patti",
      image:
        "/assets/poker/JL0075.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-001",
    },
  ],
  KM: [
    {
      name: "Teen Patti Blitz",
      image:
        "/assets/poker/KM0091.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-085",
    },
    {
      name: "Jogo De Bozo",
      image:
        "/assets/poker/KM0088.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp", platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-080",
    },
    {
      name: "Egyptian Mines",
      image:
        "/assets/poker/KM0087.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-081",
    },
    {
      name: "Bicho",
      image:
        "/assets/poker/KM0086.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-082",
    },
    {
      name: "Speedy Andar Bahar",
      image:
        "/assets/poker/KM0083.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-084",
    },
    {
      name: "Burmese 6 Animals",
      image:
        "/assets/poker/KM0081.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-083",
    },
    {
      name: "Ladder Game",
      image:
        "/assets/poker/KM0079.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-079",
    },
    {
      name: "Dice Duet",
      image:
        "/assets/poker/KM0072.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-078",
    },
    {
      name: "Iron Dome",
      image:
        "/assets/poker/KM0071.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-075",
    },
    {
      name: "Toon Crash",
      image:
        "/assets/poker/KM0070.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-076",
    },
    {
      name: "Video Poker",
      image:
        "/assets/poker/KM0068.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-050",
    },
    {
      name: "Interstellar Run",
      image:
        "/assets/poker/KM0057.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-070",
    },
    {
      name: "Tongits",
      image:
        "/assets/poker/KM0052.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-063",
    },
    {
      name: "Km Virtual Animal Race",
      image:
        "/assets/poker/KM0051.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-062",
    },
    {
      name: "Ludo",
      image:
        "/assets/poker/KM0050.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-060",
    },
    {
      name: "Km Virtual Treadmill Racing",
      image:
        "/assets/poker/KM0049.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-058",
    },
    {
      name: "Km Virtual Hound Racing",
      image:
        "/assets/poker/KM0047.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Km Marble Knockout",
      image:
        "/assets/poker/KM0046.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Km Power Ball",
      image:
        "/assets/poker/KM0045.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-051",
    },
    {
      name: "Color Game",
      image:
        "/assets/poker/KM0044.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-023",
    },
    {
      name: "Bola Tangkas",
      image:
        "/assets/poker/KM0043.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Km Virtual Horse Racing",
      image:
        "/assets/poker/KM0042.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "5 Card Poker",
      image:
        "/assets/poker/KM0041.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-049",
    },
    {
      name: "Heist",
      image:
        "/assets/poker/KM0040.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-047",
    },
    {
      name: "Monkey King Roulette",
      image:
        "/assets/poker/KM0039.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-045",
    },
    {
      name: "Teen Patti",
      image:
        "/assets/poker/KM0038.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-001",
    },
    {
      name: "Dota Hi-Lo",
      image:
        "/assets/poker/KM0037.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-044",
    },
    {
      name: "Minesweeper",
      image:
        "/assets/poker/KM0036.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-042",
    },
    {
      name: "Bonus Dice",
      image:
        "/assets/poker/KM0035.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-043",
    },
    {
      name: "Cash Rocket",
      image:
        "/assets/poker/KM0034.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-041",
    },
    {
      name: "Plinko",
      image:
        "/assets/poker/KM0033.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-041",
    },
    {
      name: "32 Cards",
      image:
        "/assets/poker/KM0032.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-039",
    },
    {
      name: "Blackjack",
      image:
        "/assets/poker/KM0031.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-044",
    },
    {
      name: "Cards Hi Lo",
      image:
        "/assets/poker/KM0030.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-037",
    },
    {
      name: "Coin Toss",
      image:
        "/assets/poker/KM0029.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-036",
    },
    {
      name: "Pai Kang",
      image:
        "/assets/poker/KM0028.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-033",
    },
    {
      name: "Km Pok Deng",
      image:
        "/assets/poker/KM0027.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-034",
    },
    {
      name: "Bola Golek",
      image:
        "/assets/poker/KM0026.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-035",
    },
    {
      name: "Baccarat",
      image:
        "/assets/poker/KM0025.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-014",
    },
    {
      name: "Andar Bahar",
      image:
        "/assets/poker/KM0024.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-003",
    },
    {
      name: "Jhandi Munda",
      image:
        "/assets/poker/KM0023.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-056",
    },
    {
      name: "7 Up 7 Down",
      image:
        "/assets/poker/KM0021.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-028",
    },
    {
      name: "European Roulette",
      image:
        "/assets/poker/KM0020.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "NETENT",
      gameType: "SLOT",
      casinoType: "NETENT-SLOT-064",
    },
    {
      name: "Bai Buu",
      image:
        "/assets/poker/KM0019.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-029",
    },
    {
      name: "Fruit Roulette",
      image:
        "/assets/poker/KM0016.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "KINGMAKER",
      gameType: "TABLE",
      casinoType: "KM-TABLE-025",
    },
    {
      name: "Triple Chance",
      image:
        "/assets/poker/KM0015.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Fan Tan Classic",
      image:
        "/assets/poker/KM0014.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Xoc Dia Lightning",
      image:
        "/assets/poker/KM0013.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Thai Fish Prawn Crab",
      image:
        "/assets/poker/KM0012.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-011",
    },
    {
      name: "Poker Roulette",
      image:
        "/assets/poker/KM0011.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Max Keno",
      image:
        "/assets/poker/KM0010.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Tai Xiu",
      image:
        "/assets/poker/KM0009.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-009",
    },
    {
      name: "Sic Bo",
      image:
        "/assets/poker/KM0008.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "JILI",
      gameType: "TABLE",
      casinoType: "JILI-TABLE-017",
    },
    {
      name: "Vietnam Fish Prawn Crab",
      image:
        "/assets/poker/KM0007.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Dragon Tiger 2",
      image:
        "/assets/poker/KM0005.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
      platFormCode: "MAC88",
      gameType: "LIVE",
      casinoType: "MAC88-LIVE-054",
    },
    {
      name: "Belangkai 2",
      image:
        "/assets/poker/KM0004.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Fish Prawn Crab 2",
      image:
        "/assets/poker/KM0003.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
    {
      name: "Thai Hi Lo 2",
      image:
        "/assets/poker/KM0002.webp",
      platformImage:
        "/assets/platformHeader/KM-WHITE.webp",
    },
  ],
};
export const LiveCasino = {
  EVOULUTION: [
    {
      name: "Roulette",
      image: "/assets/liveCasino/EG4178.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-001",
    },
    {
      name: "Blackjack A",
      image: "/assets/liveCasino/EG4135.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-002",
    },
    {
      name: "Craps",
      image: "/assets/liveCasino/EG4145.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-003",
    },
    {
      name: "Dragon Tiger",
      image: "/assets/liveCasino/EG4152.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-004",
    },
    {
      name: "Super Sic Bo",
      image: "/assets/liveCasino/EG4189.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-005",
    },
    {
      name: "Crazy Time",
      image: "/assets/liveCasino/EG4147.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-006",
    },
    {
      name: "Instant Roulette",
      image: "/assets/liveCasino/EG4166.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-008",
    },
    {
      name: "Triple Card Poker",
      image: "/assets/liveCasino/EG4496.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-009",
    },
    {
      name: "Mega Ball",
      image: "/assets/liveCasino/EG4171.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-010",
    },
    {
      name: "Lightning Dice",
      image: "/assets/liveCasino/EG4169.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-011",
    },
    {
      name: "Infinite Blackjack",
      image: "/assets/liveCasino/EG4164.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-012",
    },
    {
      name: "Crazy Coin Flip",
      image: "/assets/liveCasino/EG4146.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-014",
    },
    {
      name: "Casino Hold'em",
      image: "/assets/liveCasino/EG4144.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-015",
    },
    {
      name: "Power Blackjack",
      image: "/assets/liveCasino/EG4177.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-016",
    },
    {
      name: "American Roulette",
      image: "/assets/liveCasino/EG4127.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-020",
    },
    {
      name: "2 Hand Casino Hold'em",
      image: "/assets/liveCasino/EG4126.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-021",
    },
    {
      name: "Caribbean Stud Poker",
      image: "/assets/liveCasino/EG4142.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-024",
    },
    {
      name: "Deal or No Deal",
      image: "/assets/liveCasino/EG4516.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-025",
    },
    {
      name: "Teen Patti",
      image: "/assets/liveCasino/EG4190.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-026",
    },
    {
      name: "Texas Hold'em Bonus Poker",
      image: "/assets/liveCasino/EG4191.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-027",
    },
    {
      name: "Extreme Texas Hold'em",
      image: "/assets/liveCasino/EG4418.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-032",
    },
    {
      name: "Dream Catcher",
      image: "/assets/liveCasino/EG4153.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-035",
    },
    {
      name: "Baccarat Squeeze",
      image: "/assets/liveCasino/EG4134.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-036",
    },
    {
      name: "Infinite Free Bet Blackjack",
      image: "/assets/liveCasino/EG4165.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-037",
    },
    {
      name: "No Commission Baccarat",
      image: "/assets/liveCasino/EG4174.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-038",
    },
    {
      name: "Blackjack VIP B",
      image: "/assets/liveCasino/EG4220.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-039",
    },
    {
      name: "Lightning Roulette",
      image: "/assets/liveCasino/EG4170.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-040",
    },
    {
      name: "Baccarat Control Squeeze",
      image: "/assets/liveCasino/EG4133.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-041",
    },
    {
      name: "Blackjack Party",
      image: "/assets/liveCasino/EG4138.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-042",
    },
    {
      name: "Double Ball Roulette",
      image: "/assets/liveCasino/EG4151.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-043",
    },
    {
      name: "Football Studio Dice",
      image: "/assets/liveCasino/EG4160.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-044",
    },
    {
      name: "Football Studio",
      image: "/assets/liveCasino/EG4159.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-045",
    },
    {
      name: "Emperor Sic Bo",
      image: "/assets/liveCasino/EG4324.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-047",
    },
    {
      name: "Blackjack VIP U",
      image: "/assets/liveCasino/EG4237.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-049",
    },
    {
      name: "Blackjack VIP 1",
      image: "/assets/liveCasino/EG4141.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-050",
    },
    {
      name: "Blackjack Silver E",
      image: "/assets/liveCasino/EG4216.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-051",
    },
    {
      name: "Blackjack VIP 25",
      image: "/assets/liveCasino/EG4259.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-052",
    },
    {
      name: "Blackjack Silver B",
      image: "/assets/liveCasino/EG4213.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-053",
    },
    {
      name: "Blackjack VIP 12",
      image: "/assets/liveCasino/EG4248.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-054",
    },
    {
      name: "Blackjack VIP 15",
      image: "/assets/liveCasino/EG4251.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-055",
    },
    {
      name: "Blackjack Silver C",
      image: "/assets/liveCasino/EG4214.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-056",
    },
    {
      name: "Blackjack VIP X",
      image: "/assets/liveCasino/EG4358.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-057",
    },
    {
      name: "Blackjack VIP Alpha",
      image: "/assets/liveCasino/EG4262.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-058",
    },
    {
      name: "Blackjack VIP D",
      image: "/assets/liveCasino/EG4222.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-059",
    },
    {
      name: "Blackjack VIP Gamma",
      image: "/assets/liveCasino/EG4264.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-060",
    },
    {
      name: "Blackjack VIP G",
      image: "/assets/liveCasino/EG4225.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-061",
    },
    {
      name: "Blackjack VIP V",
      image: "/assets/liveCasino/EG4199.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-062",
    },
    {
      name: "Blackjack VIP 20",
      image: "/assets/liveCasino/EG4256.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-063",
    },
    {
      name: "Blackjack VIP 7",
      image: "/assets/liveCasino/EG4243.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-064",
    },
    {
      name: "Blackjack VIP I",
      image: "/assets/liveCasino/EG4227.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-065",
    },
    {
      name: "Blackjack VIP 16",
      image: "/assets/liveCasino/EG4252.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-066",
    },
    {
      name: "Blackjack VIP Beta",
      image: "/assets/liveCasino/EG4263.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-067",
    },
    {
      name: "Blackjack Silver G",
      image: "/assets/liveCasino/EG4218.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-068",
    },
    {
      name: "Blackjack VIP E",
      image: "/assets/liveCasino/EG4223.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-069",
    },
    {
      name: "Blackjack Silver F",
      image: "/assets/liveCasino/EG4217.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-070",
    },
    {
      name: "Blackjack VIP M",
      image: "/assets/liveCasino/EG4231.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-071",
    },
    {
      name: "Blackjack VIP 14",
      image: "/assets/liveCasino/EG4250.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-072",
    },
    {
      name: "Blackjack VIP 10",
      image: "/assets/liveCasino/EG4246.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-073",
    },
    {
      name: "Blackjack Silver D",
      image: "/assets/liveCasino/EG4215.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-074",
    },
    {
      name: "Blackjack Silver A",
      image: "/assets/liveCasino/EG4140.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-075",
    },
    {
      name: "Blackjack VIP Z",
      image: "/assets/liveCasino/EG4359.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-076",
    },
    {
      name: "Emperor Dragon Tiger",
      image: "/assets/liveCasino/EG4154.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-077",
    },
    {
      name: "Speed Roulette",
      image: "/assets/liveCasino/EG4186.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-078",
    },
    {
      name: "VIP Roulette",
      image: "/assets/liveCasino/EG4194.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-079",
    },
    {
      name: "Emperor Roulette",
      image: "/assets/liveCasino/EG4155.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-080",
    },
    {
      name: "Salon Privé Roulette",
      image: "/assets/liveCasino/EG4181.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-081",
    },
    {
      name: "Blackjack B",
      image: "/assets/liveCasino/EG4211.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-082",
    },
    {
      name: "Blackjack C",
      image: "/assets/liveCasino/EG4212.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-083",
    },
    {
      name: "Blackjack VIP 11",
      image: "/assets/liveCasino/EG4247.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-084",
    },
    {
      name: "Blackjack VIP 13",
      image: "/assets/liveCasino/EG4249.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-085",
    },
    {
      name: "Blackjack VIP 17",
      image: "/assets/liveCasino/EG4253.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-086",
    },
    {
      name: "Blackjack VIP 18",
      image: "/assets/liveCasino/EG4254.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-087",
    },
    {
      name: "Blackjack VIP 19",
      image: "/assets/liveCasino/EG4255.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-088",
    },
    {
      name: "Blackjack VIP 2",
      image: "/assets/liveCasino/EG4238.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-089",
    },
    {
      name: "Blackjack VIP 21",
      image: "/assets/liveCasino/EG4257.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-090",
    },
    {
      name: "Blackjack VIP 22",
      image: "/assets/liveCasino/EG4258.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-091",
    },
    {
      name: "Blackjack VIP 26",
      image: "/assets/liveCasino/EG4260.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-092",
    },
    {
      name: "Blackjack VIP 27",
      image: "/assets/liveCasino/EG4261.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-093",
    },
    {
      name: "Blackjack VIP 3",
      image: "/assets/liveCasino/EG4239.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-094",
    },
    {
      name: "Blackjack VIP 4",
      image: "/assets/liveCasino/EG4240.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-095",
    },
    {
      name: "Blackjack VIP 5",
      image: "/assets/liveCasino/EG4241.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-096",
    },
    {
      name: "Blackjack VIP 6",
      image: "/assets/liveCasino/EG4242.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-097",
    },
    {
      name: "Blackjack VIP 8",
      image: "/assets/liveCasino/EG4244.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-098",
    },
    {
      name: "Blackjack VIP 9",
      image: "/assets/liveCasino/EG4245.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-099",
    },
    {
      name: "Blackjack VIP A",
      image: "/assets/liveCasino/EG4219.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-100",
    },
    {
      name: "Blackjack VIP C",
      image: "/assets/liveCasino/EG4221.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-101",
    },
    {
      name: "Blackjack VIP F",
      image: "/assets/liveCasino/EG4224.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-102",
    },
    {
      name: "Blackjack VIP H",
      image: "/assets/liveCasino/EG4226.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-103",
    },
    {
      name: "Blackjack VIP J",
      image: "/assets/liveCasino/EG4228.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-104",
    },
    {
      name: "Blackjack VIP K",
      image: "/assets/liveCasino/EG4229.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-105",
    },
    {
      name: "Blackjack VIP L",
      image: "/assets/liveCasino/EG4230.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-106",
    },
    {
      name: "Blackjack VIP N",
      image: "/assets/liveCasino/EG4232.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-107",
    },
    {
      name: "Blackjack VIP O",
      image: "/assets/liveCasino/EG4233.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-108",
    },
    {
      name: "Blackjack VIP P",
      image: "/assets/liveCasino/EG4198.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-109",
    },
    {
      name: "Blackjack VIP Q",
      image: "/assets/liveCasino/EG4234.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-110",
    },
    {
      name: "Blackjack VIP R",
      image: "/assets/liveCasino/EG4235.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-111",
    },
    {
      name: "Blackjack VIP S",
      image: "/assets/liveCasino/EG4236.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-112",
    },
    {
      name: "Blackjack VIP T",
      image: "/assets/liveCasino/EG4197.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-113",
    },
    {
      name: "Crazy Time A",
      image: "/assets/liveCasino/EG4148.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-114",
    },
    {
      name: "Blackjack Fortune VIP",
      image: "/assets/liveCasino/EG4136.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-115",
    },
    {
      name: "Blackjack Grand VIP",
      image: "/assets/liveCasino/EG4137.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-116",
    },
    {
      name: "Blackjack Platinum VIP",
      image: "/assets/liveCasino/EG4139.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-117",
    },
    {
      name: "Blackjack Diamond VIP",
      image: "/assets/liveCasino/EG4265.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-118",
    },
    {
      name: "Baccarat A",
      image: "/assets/liveCasino/EG4132.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-120",
    },
    {
      name: "Salon Privé Baccarat G",
      image: "/assets/liveCasino/EG4207.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-121",
    },
    {
      name: "Baccarat B",
      image: "/assets/liveCasino/EG4201.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-122",
    },
    {
      name: "Salon Privé Baccarat B",
      image: "/assets/liveCasino/EG4202.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-124",
    },
    {
      name: "Salon Privé Baccarat A",
      image: "/assets/liveCasino/EG4179.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-125",
    },
    {
      name: "Salon Privé Baccarat C",
      image: "/assets/liveCasino/EG4203.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-126",
    },
    {
      name: "Salon Privé Baccarat D",
      image: "/assets/liveCasino/EG4204.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-127",
    },
    {
      name: "Salon Privé Baccarat E",
      image: "/assets/liveCasino/EG4205.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-128",
    },
    {
      name: "Salon Privé Baccarat F",
      image: "/assets/liveCasino/EG4206.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-129",
    },
    {
      name: "Salon Privé Baccarat H",
      image: "/assets/liveCasino/EG4208.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-130",
    },
    {
      name: "Salon Privé Baccarat I",
      image: "/assets/liveCasino/EG4209.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-131",
    },
    {
      name: "Salon Privé Baccarat J",
      image: "/assets/liveCasino/EG4210.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-132",
    },
    {
      name: "Lightning Baccarat",
      image: "/assets/liveCasino/EG4167.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-133",
    },
    {
      name: "No Commission Speed Baccarat A",
      image: "/assets/liveCasino/EG4175.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-134",
    },
    {
      name: "No Commission Speed Baccarat B",
      image: "/assets/liveCasino/EG4275.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-135",
    },
    {
      name: "No Commission Speed Baccarat C",
      image: "/assets/liveCasino/EG4276.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-136",
    },
    {
      name: "Speed Baccarat F",
      image: "/assets/liveCasino/EG4282.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-137",
    },
    {
      name: "Speed Baccarat I",
      image: "/assets/liveCasino/EG4285.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-138",
    },
    {
      name: "Speed Baccarat B",
      image: "/assets/liveCasino/EG4278.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-139",
    },
    {
      name: "Speed Baccarat H",
      image: "/assets/liveCasino/EG4284.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-140",
    },
    {
      name: "Speed Baccarat Q",
      image: "/assets/liveCasino/EG4293.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-141",
    },
    {
      name: "Speed Baccarat M",
      image: "/assets/liveCasino/EG4289.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-142",
    },
    {
      name: "Speed Baccarat X",
      image: "/assets/liveCasino/EG4300.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-143",
    },
    {
      name: "Speed Baccarat O",
      image: "/assets/liveCasino/EG4291.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-144",
    },
    {
      name: "Speed Baccarat A",
      image: "/assets/liveCasino/EG4184.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-145",
    },
    {
      name: "Speed Baccarat C",
      image: "/assets/liveCasino/EG4279.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-146",
    },
    {
      name: "Emperor Speed Baccarat B",
      image: "/assets/liveCasino/EG4360.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-147",
    },
    {
      name: "Speed Baccarat E",
      image: "/assets/liveCasino/EG4281.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-148",
    },
    {
      name: "Speed Baccarat P",
      image: "/assets/liveCasino/EG4292.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-149",
    },
    {
      name: "Emperor Speed Baccarat A",
      image: "/assets/liveCasino/EG4156.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-150",
    },
    {
      name: "Speed Baccarat K",
      image: "/assets/liveCasino/EG4287.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-151",
    },
    {
      name: "Speed Baccarat W",
      image: "/assets/liveCasino/EG4299.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-152",
    },
    {
      name: "Speed Baccarat G",
      image: "/assets/liveCasino/EG4283.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-154",
    },
    {
      name: "Speed Baccarat L",
      image: "/assets/liveCasino/EG4288.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-155",
    },
    {
      name: "Speed Baccarat N",
      image: "/assets/liveCasino/EG4290.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-156",
    },
    {
      name: "Speed Baccarat J",
      image: "/assets/liveCasino/EG4286.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-157",
    },
    {
      name: "Speed Baccarat D",
      image: "/assets/liveCasino/EG4280.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-158",
    },
    {
      name: "Speed Baccarat 1",
      image: "/assets/liveCasino/EG4302.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-159",
    },
    {
      name: "Speed Baccarat 2",
      image: "/assets/liveCasino/EG4303.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-160",
    },
    {
      name: "Speed Baccarat 3",
      image: "/assets/liveCasino/EG4304.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-161",
    },
    {
      name: "Speed Baccarat R",
      image: "/assets/liveCasino/EG4294.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-162",
    },
    {
      name: "Speed Baccarat S",
      image: "/assets/liveCasino/EG4295.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-163",
    },
    {
      name: "Speed Baccarat T",
      image: "/assets/liveCasino/EG4296.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-164",
    },
    {
      name: "Speed Baccarat U",
      image: "/assets/liveCasino/EG4297.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-165",
    },
    {
      name: "Speed Baccarat V",
      image: "/assets/liveCasino/EG4298.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-166",
    },
    {
      name: "Speed Baccarat Z",
      image: "/assets/liveCasino/EG4301.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-167",
    },
    {
      name: "Imperial Quest",
      image: "/assets/liveCasino/EG4325.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-169",
    },
    {
      name: "Auto-Roulette",
      image: "/assets/liveCasino/EG4129.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-170",
    },
    {
      name: "Auto-Roulette VIP",
      image: "/assets/liveCasino/EG4130.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-171",
    },
    {
      name: "Bac Bo",
      image: "/assets/liveCasino/EG4131.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-172",
    },
    {
      name: "Speed Blackjack H",
      image: "/assets/liveCasino/EG4309.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-173",
    },
    {
      name: "Dead or Alive: Saloon",
      image: "/assets/liveCasino/EG4149.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-176",
    },
    {
      name: "Speed Blackjack D",
      image: "/assets/liveCasino/EG4185.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-177",
    },
    {
      name: "Fan Tan",
      image: "/assets/liveCasino/EG4158.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-178",
    },
    {
      name: "Golden Wealth Baccarat",
      image: "/assets/liveCasino/EG4162.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-179",
    },
    {
      name: "Immersive Roulette",
      image: "/assets/liveCasino/EG4163.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-180",
    },
    {
      name: "Peek Baccarat",
      image: "/assets/liveCasino/EG4176.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-182",
    },
    {
      name: "Funky Time",
      image: "/assets/liveCasino/EG4326.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-183",
    },
    {
      name: "Speed Blackjack E",
      image: "/assets/liveCasino/EG4307.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-184",
    },
    {
      name: "Speed Blackjack G",
      image: "/assets/liveCasino/EG4308.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-185",
    },
    {
      name: "Speed Blackjack I",
      image: "/assets/liveCasino/EG4310.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-186",
    },
    {
      name: "Speed Blackjack J",
      image: "/assets/liveCasino/EG4311.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-187",
    },
    {
      name: "Speed Blackjack K",
      image: "/assets/liveCasino/EG4305.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-188",
    },
    {
      name: "Speed Blackjack L",
      image: "/assets/liveCasino/EG4306.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-189",
    },
    {
      name: "Speed Blackjack M",
      image: "/assets/liveCasino/EG4196.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-190",
    },
    {
      name: "Speed VIP Blackjack A",
      image: "/assets/liveCasino/EG4187.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-191",
    },
    {
      name: "Speed VIP Blackjack B",
      image: "/assets/liveCasino/EG4312.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-192",
    },
    {
      name: "Speed VIP Blackjack C",
      image: "/assets/liveCasino/EG4313.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-193",
    },
    {
      name: "Speed VIP Blackjack D",
      image: "/assets/liveCasino/EG4314.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-194",
    },
    {
      name: "Speed VIP Blackjack E",
      image: "/assets/liveCasino/EG4315.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-195",
    },
    {
      name: "Speed VIP Blackjack F",
      image: "/assets/liveCasino/EG4316.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-196",
    },
    {
      name: "Speed VIP Blackjack G",
      image: "/assets/liveCasino/EG4317.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-197",
    },
    {
      name: "Speed VIP Blackjack H",
      image: "/assets/liveCasino/EG4318.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-198",
    },
    {
      name: "Speed VIP Blackjack I",
      image: "/assets/liveCasino/EG4319.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-199",
    },
    {
      name: "Speed VIP Blackjack J",
      image: "/assets/liveCasino/EG4320.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-200",
    },
    {
      name: "Speed VIP Blackjack K",
      image: "/assets/liveCasino/EG4321.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-201",
    },
    {
      name: "Speed VIP Blackjack L",
      image: "/assets/liveCasino/EG4322.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-202",
    },
    {
      name: "Speed VIP Blackjack M",
      image: "/assets/liveCasino/EG4323.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-203",
    },
    {
      name: "Super Andar Bahar",
      image: "/assets/liveCasino/EG4188.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-204",
    },
    {
      name: "Emperor Speed Baccarat D",
      image: "/assets/liveCasino/EG4327.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-210",
    },
    {
      name: "Emperor Sic Bo A",
      image: "/assets/liveCasino/EG4328.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-211",
    },
    {
      name: "Speed Auto Roulette",
      image: "/assets/liveCasino/EG4183.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-212",
    },
    {
      name: "Football Studio Roulette",
      image: "/assets/liveCasino/EG4277.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-214",
    },
    {
      name: "Salon Privé Blackjack A",
      image: "/assets/liveCasino/EG4180.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-215",
    },
    {
      name: "Salon Privé Blackjack B",
      image: "/assets/liveCasino/EG4266.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-216",
    },
    {
      name: "Salon Privé Blackjack C",
      image: "/assets/liveCasino/EG4267.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-217",
    },
    {
      name: "Salon Privé Blackjack D",
      image: "/assets/liveCasino/EG4268.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-218",
    },
    {
      name: "Salon Privé Blackjack E",
      image: "/assets/liveCasino/EG4269.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-219",
    },
    {
      name: "Salon Privé Blackjack F",
      image: "/assets/liveCasino/EG4270.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-220",
    },
    {
      name: "Salon Privé Blackjack G",
      image: "/assets/liveCasino/EG4271.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-221",
    },
    {
      name: "Salon Privé Blackjack H",
      image: "/assets/liveCasino/EG4272.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-222",
    },
    {
      name: "Salon Privé Blackjack I",
      image: "/assets/liveCasino/EG4273.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-223",
    },
    {
      name: "Salon Privé Blackjack J",
      image: "/assets/liveCasino/EG4274.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-224",
    },
    {
      name: "Video Poker",
      image: "/assets/liveCasino/EG4497.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-227",
    },
    {
      name: "Gold Vault Roulette",
      image: "/assets/liveCasino/EG4329.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-228",
    },
    {
      name: "Emperor Bac Bo",
      image: "/assets/liveCasino/EG4396.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-230",
    },
    {
      name: "Bonsai Speed Baccarat A",
      image: "/assets/liveCasino/EG4392.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-231",
    },
    {
      name: "Bonsai Speed Baccarat B",
      image: "/assets/liveCasino/EG4393.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-232",
    },
    {
      name: "Bonsai Speed Baccarat C",
      image: "/assets/liveCasino/EG4394.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-233",
    },
    {
      name: "Blackjack VIP 28",
      image: "/assets/liveCasino/EG4336.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-234",
    },
    {
      name: "Blackjack VIP 29",
      image: "/assets/liveCasino/EG4337.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-235",
    },
    {
      name: "Salon Privé Baccarat K",
      image: "/assets/liveCasino/EG4460.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-236",
    },
    {
      name: "Salon Privé Baccarat L",
      image: "/assets/liveCasino/EG4461.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-237",
    },
    {
      name: "Speed VIP Blackjack N",
      image: "/assets/liveCasino/EG4351.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-238",
    },
    {
      name: "Speed VIP Blackjack O",
      image: "/assets/liveCasino/EG4352.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-239",
    },
    {
      name: "Speed VIP Blackjack P",
      image: "/assets/liveCasino/EG4353.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-240",
    },
    {
      name: "Speed VIP Blackjack Q",
      image: "/assets/liveCasino/EG4354.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-241",
    },
    {
      name: "Blackjack VIP 30",
      image: "/assets/liveCasino/EG4338.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-243",
    },
    {
      name: "Prosperity Tree Baccarat",
      image: "/assets/liveCasino/EG4330.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-245",
    },
    {
      name: "Speed Baccarat 4",
      image: "/assets/liveCasino/EG4477.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-247",
    },
    {
      name: "Speed Baccarat 5",
      image: "/assets/liveCasino/EG4478.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-248",
    },
    {
      name: "Speed Baccarat 6",
      image: "/assets/liveCasino/EG4479.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-249",
    },
    {
      name: "Speed Baccarat 9",
      image: "/assets/liveCasino/EG4482.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-250",
    },
    {
      name: "Speed Baccarat 10",
      image: "/assets/liveCasino/EG4471.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-253",
    },
    {
      name: "Speed Baccarat 11",
      image: "/assets/liveCasino/EG4472.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-254",
    },
    {
      name: "Red Door Roulette",
      image: "/assets/liveCasino/EG4334.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-257",
    },
    {
      name: "Speed Super Sic Bo",
      image: "/assets/liveCasino/EG4483.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-260",
    },
    {
      name: "Crazy Pachinko",
      image: "/assets/liveCasino/EG4333.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-261",
    },
    {
      name: "Speed Baccarat 12",
      image: "/assets/liveCasino/EG4473.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-262",
    },
    {
      name: "Evo Speed Blackjack 1",
      image: "/assets/liveCasino/EG4398.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-263",
    },
    {
      name: "Evo Speed Blackjack 2",
      image: "/assets/liveCasino/EG4409.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-264",
    },
    {
      name: "Evo Speed Blackjack 3",
      image: "/assets/liveCasino/EG4411.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-265",
    },
    {
      name: "Evo Speed Blackjack 4",
      image: "/assets/liveCasino/EG4412.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-266",
    },
    {
      name: "Evo Speed Blackjack 5",
      image: "/assets/liveCasino/EG4413.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-267",
    },
    {
      name: "Evo Speed Blackjack 6",
      image: "/assets/liveCasino/EG4414.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-268",
    },
    {
      name: "Evo Speed Blackjack 7",
      image: "/assets/liveCasino/EG4415.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-269",
    },
    {
      name: "Evo Speed Blackjack 8",
      image: "/assets/liveCasino/EG4416.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-270",
    },
    {
      name: "Salon Privé Baccarat M",
      image: "/assets/liveCasino/EG4462.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-271",
    },
    {
      name: "Salon Privé Baccarat N",
      image: "/assets/liveCasino/EG4463.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-272",
    },
    {
      name: "Speed Baccarat 7",
      image: "/assets/liveCasino/EG4480.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-273",
    },
    {
      name: "Speed Baccarat 8",
      image: "/assets/liveCasino/EG4481.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-274",
    },
    {
      name: "Blackjack VIP 31",
      image: "/assets/liveCasino/EG4339.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-275",
    },
    {
      name: "Blackjack VIP 32",
      image: "/assets/liveCasino/EG4340.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-276",
    },
    {
      name: "Hindi Speed Baccarat B",
      image: "/assets/liveCasino/EG4446.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-277",
    },
    {
      name: "Evo Speed Blackjack 9",
      image: "/assets/liveCasino/EG4417.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-278",
    },
    {
      name: "Evo Speed Blackjack 10",
      image: "/assets/liveCasino/EG4399.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-279",
    },
    {
      name: "Evo Speed Blackjack 11",
      image: "/assets/liveCasino/EG4400.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-280",
    },
    {
      name: "Blackjack VIP 33",
      image: "/assets/liveCasino/EG4341.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-281",
    },
    {
      name: "Blackjack VIP 34",
      image: "/assets/liveCasino/EG4363.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-282",
    },
    {
      name: "Blackjack VIP 35",
      image: "/assets/liveCasino/EG4343.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-283",
    },
    {
      name: "Blackjack VIP 38",
      image: "/assets/liveCasino/EG4346.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-286",
    },
    {
      name: "Blackjack VIP 41",
      image: "/assets/liveCasino/EG4347.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-287",
    },
    {
      name: "Blackjack VIP 44",
      image: "/assets/liveCasino/EG4350.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-290",
    },
    {
      name: "Stock Market",
      image: "/assets/liveCasino/EG4494.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-291",
    },
    {
      name: "Free Bet VIP Blackjack A",
      image: "/assets/liveCasino/EG4429.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-314",
    },
    {
      name: "Free Bet VIP Blackjack B",
      image: "/assets/liveCasino/EG4430.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
    },
    {
      name: "Blackjack VIP 36",
      image: "/assets/liveCasino/EG4344.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-332",
    },
    {
      name: "Blackjack VIP 37",
      image: "/assets/liveCasino/EG4345.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-333",
    },

    {
      name: "Blackjack VIP 50",
      image: "/assets/liveCasino/EG4370.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-339",
    },
    {
      name: "Lightning Dragon Tiger",
      image: "/assets/liveCasino/EG4448.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-344",
    },
    {
      name: "Lightning Sic Bo",
      image: "/assets/liveCasino/EG4449.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-362",
    },
    {
      name: "Balloon Race",
      image: "/assets/liveCasino/EG4362.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-363",
    },
    {
      name: "Salon Privé Blackjack K",
      image: "/assets/liveCasino/EG4464.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-365",
    },
    {
      name: "Salon Privé Blackjack L",
      image: "/assets/liveCasino/EG4465.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-366",
    },
    {
      name: "Salon Privé Blackjack M",
      image: "/assets/liveCasino/EG4466.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-367",
    },
    {
      name: "Salon Privé Blackjack N",
      image: "/assets/liveCasino/EG4467.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-368",
    },
    {
      name: "Lightning Storm",
      image: "/assets/liveCasino/EG4450.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-369",
    },
    {
      name: "Lightning Ball",
      image: "/assets/liveCasino/EG4447.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-376",
    },
    {
      name: "Platinum Privé Blackjack 1",
      image: "/assets/liveCasino/EG4451.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-377",
    },
    {
      name: "Platinum Privé Blackjack 2",
      image: "/assets/liveCasino/EG4452.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-378",
    },
    {
      name: "Platinum Privé Blackjack 3",
      image: "/assets/liveCasino/EG4453.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-379",
    },
    {
      name: "Platinum Privé Blackjack 4",
      image: "/assets/liveCasino/EG4454.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-380",
    },
    {
      name: "Platinum Privé Blackjack 5",
      image: "/assets/liveCasino/EG4455.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-381",
    },
    {
      name: "Platinum Privé Blackjack 6",
      image: "/assets/liveCasino/EG4456.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-382",
    },
    {
      name: "Platinum Privé Blackjack 7",
      image: "/assets/liveCasino/EG4457.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-383",
    },
    {
      name: "Salon Privé Blackjack O",
      image: "/assets/liveCasino/EG4468.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-386",
    },
    {
      name: "Salon Privé Blackjack P",
      image: "/assets/liveCasino/EG4469.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-387",
    },
    {
      name: "Salon Privé Blackjack Q",
      image: "/assets/liveCasino/EG4470.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-388",
    },
    {
      name: "Super Speed Baccarat",
      image: "/assets/liveCasino/EG4505.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-146",
    },
    {
      name: "Crazy Balls",
      image: "/assets/liveCasino/EG4518.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-409",
    },
    {
      name: "Always 8 Baccarat",
      image: "/assets/liveCasino/EG4517.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-410",
    },
    {
      name: "Infinite Bet Stacker Blackjack",
      image: "/assets/liveCasino/EG4520.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-412",
    },
    {
      name: "Easy Blackjack",
      image: "/assets/liveCasino/EG4519.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-413",
    },
    {
      name: "Emperor Golden Wealth Baccarat",
      image: "/assets/liveCasino/EG4397.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-414",
    },
    {
      name: "Thai Speed Baccarat A",
      image: "/assets/liveCasino/EG4526.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-415",
    },
    {
      name: "Lotus Speed Baccarat A",
      image: "/assets/liveCasino/EG4524.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-416",
    },
    {
      name: "Lotus Speed Baccarat B",
      image: "/assets/liveCasino/EG4537.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-420",
    },
    {
      name: "Lotus Speed Baccarat C",
      image: "/assets/liveCasino/EG4541.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-421",
    },

    {
      name: "Race Track",
      image: "/assets/liveCasino/EG4534.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-426",
    },
    {
      name: "War",
      image: "/assets/liveCasino/EG4538.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-431",
    },
    {
      name: "Thai Speed Baccarat B",
      image: "/assets/liveCasino/EG4539.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-432",
    },
    {
      name: "Thai Speed Baccarat C",
      image: "/assets/liveCasino/EG4540.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-433",
    },
    {
      name: "Marble Race",
      image: "/assets/liveCasino/EG4542.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-434",
    },
    {
      name: "Super Color Game",
      image: "/assets/liveCasino/EG4544.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-435",
    },
    {
      name: "Lightning Bac Bo",
      image: "/assets/liveCasino/EG4545.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-440",
    },
    {
      name: "Ice Fishing",
      image: "/assets/liveCasino/EG4601.webp",
      platformImage: "/assets/platformHeader/EG4-WHITE.webp",
      platFormCode: "EVOLUTION",
      gameType: "LIVE",
      casinoType: "EVOLUTION-LIVE-449",
    },
  ],
  PP: [
    {
      name: "Speed Baccarat 11",
      image: "/assets/liveCasino/PP0282.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-022",

      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 12",
      image: "/assets/liveCasino/PP0281.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-023",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 13",
      image: "/assets/liveCasino/PP0298.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-024",
    },
    {
      name: "Baccarat 1",
      image: "/assets/liveCasino/PP0154.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-001",
    },
    {
      name: "Baccarat 2",
      image: "/assets/liveCasino/PP0155.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-002",
    },
    {
      name: "Speed Baccarat 14",
      image: "/assets/liveCasino/PP0156.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-003",
    },
    {
      name: "Baccarat 5",
      image: "/assets/liveCasino/PP0241.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-004",
    },
    {
      name: "Baccarat 6",
      image: "/assets/liveCasino/PP0242.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-005",
    },
    {
      name: "Baccarat 7",
      image: "/assets/liveCasino/PP0266.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-006",
    },
    {
      name: "Speed Baccarat 2",
      image: "/assets/liveCasino/PP0158.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-014",

      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 3",
      image: "/assets/liveCasino/PP0243.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-015",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 5",
      image: "/assets/liveCasino/PP0201.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-016",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 6",
      image: "/assets/liveCasino/PP0202.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-017",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 7",
      image: "/assets/liveCasino/PP0270.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-018",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 8",
      image: "/assets/liveCasino/PP0271.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-019",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 9",
      image: "/assets/liveCasino/PP0272.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-020",
      platFormCode: "PP",
    },
    {
      name: "Speed Baccarat 10",
      image: "/assets/liveCasino/PP0297.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-021",
      platFormCode: "PP",
    },
    {
      name: "Mega Sic Bo",
      image: "/assets/liveCasino/PP0167.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-025",
    },
    {
      name: "Speed Roulette 1",
      image: "/assets/liveCasino/PP0142.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-027",
    },
    {
      name: "Mega Wheel",
      image: "/assets/liveCasino/PP0179.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-038",
    },
    {
      name: "Mega Roulette",
      image: "/assets/liveCasino/PP0198.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-039",
    },
    {
      name: "Dragon Tiger",
      image: "/assets/liveCasino/PP0276.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-042",

      platFormCode: "PP",
    },
    {
      name: "Andar Bahar",
      image: "/assets/liveCasino/PP0248.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-043",
      platFormCode: "PP",
    },
    {
      name: "Sweet Bonanza Candyland",
      image: "/assets/liveCasino/PP0262.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-044",
    },
    {
      name: "Super 8 Baccarat",
      image: "/assets/liveCasino/PP0321.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-045",
    },
    {
      name: "Fortune 6 Baccarat",
      image: "/assets/liveCasino/PP0328.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-047",
    },
    {
      name: "Dice City",
      image: "/assets/liveCasino/PP0330.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-049",
    },
    {
      name: "Speed Baccarat 16",
      image: "/assets/liveCasino/PP0341.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-050",
    },
    {
      name: "Speed Baccarat 17",
      image: "/assets/liveCasino/PP0342.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-051",
    },
    {
      name: "Baccarat 9",
      image: "/assets/liveCasino/PP0340.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-052",
    },
    {
      name: "Speed Roulette 2",
      image: "/assets/liveCasino/PP0373.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-054",
    },
    {
      name: "Mega Baccarat",
      image: "/assets/liveCasino/PP0433.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-061",
    },
    {
      name: "Snakes & Ladders Live",
      image: "/assets/liveCasino/PP0449.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-062",
    },
    {
      name: "Vietnamese Roulette",
      image: "/assets/liveCasino/PP0652.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-068",
    },
    {
      name: "Thai Speed Baccarat 1",
      image: "/assets/liveCasino/PP0654.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-069",
    },
    {
      name: "Korean Speed Baccarat 3",
      image: "/assets/liveCasino/PP0625.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-070",
    },
    {
      name: "Korean Baccarat 1",
      image: "/assets/liveCasino/PP0626.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-071",
    },
    {
      name: "Indonesian Speed Baccarat 1",
      image: "/assets/liveCasino/PP0638.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-072",
    },
    {
      name: "Korean Roulette",
      image: "/assets/liveCasino/PP0574.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-073",
    },
    {
      name: "Brazilian Roulette",
      image: "/assets/liveCasino/PP0575.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-074",
    },
    {
      name: "Auto Mega Roulette",
      image: "/assets/liveCasino/PP0581.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-075",
    },
    {
      name: "Treasure Island",
      image: "/assets/liveCasino/PP0631.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-078",
    },
    {
      name: "Chinese Speed Baccarat 1",
      image: "/assets/liveCasino/PP0694.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-080",
    },
    {
      name: "Turkish Mega Roulette",
      image: "/assets/liveCasino/PP0741.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-081",
    },
    {
      name: "Japanese Speed Baccarat 3",
      image: "/assets/liveCasino/PP0709.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-099",
    },
    {
      name: "Chinese Speed Baccarat 2",
      image: "/assets/liveCasino/PP0716.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-114",
    },
    {
      name: "Vietnamese Speed Baccarat 1",
      image: "/assets/liveCasino/PP0737.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-115",
    },
    {
      name: "Japanese Speed Baccarat 1",
      image: "/assets/liveCasino/PP0677.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-118",
    },
    {
      name: "Chinese Speed Baccarat 3",
      image: "/assets/liveCasino/PP0768.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-139",
    },
    {
      name: "Mega Sic Bac",
      image: "/assets/liveCasino/PP0758.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-140",

      platFormCode: "PP",
    },
    {
      name: "Mega Roulette - Brazilian",
      image: "/assets/liveCasino/PP0834.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-141",
    },
    {
      name: "VIP Auto Roulette",
      image: "/assets/liveCasino/PP0850.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-142",
    },
    {
      name: "Bet Behind Pro Blackjack",
      image: "/assets/liveCasino/PP0852.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-143",
    },
    {
      name: "Italian Mega Roulette",
      image: "/assets/liveCasino/PP0873.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-145",
    },
    {
      name: "Indonesian Roulette",
      image: "/assets/liveCasino/PP0882.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-146",
    },
    {
      name: "Fortune Roulette",
      image: "/assets/liveCasino/PP0916.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-163",
    },
    {
      name: "Vietnamese Speed Baccarat 2",
      image: "/assets/liveCasino/PP0923.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-174",
    },
    {
      name: "Immersive Roulette Deluxe",
      image: "/assets/liveCasino/PP0936.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-175",
    },
    {
      name: "American Roulette",
      image: "/assets/liveCasino/PP0942.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      gameType: "LIVE",
      casinoType: "PP-LIVE-176",

      platFormCode: "PP",
    },
    {
      name: "Vietnamese Speed Baccarat 3",
      image: "/assets/liveCasino/PP0947.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-177",
    },
    {
      name: "Thai Roulette",
      image: "/assets/liveCasino/PP0964.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-178",
    },
    {
      name: "Squeeze Baccarat",
      image: "/assets/liveCasino/PP0973.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-179",
    },
    {
      name: "Casino Hold’em",
      image: "/assets/liveCasino/PP1021.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-182",
    },
    {
      name: "Jacks or Better Draw Poker",
      image: "/assets/liveCasino/PP1026.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-183",
    },
    {
      name: "Privé Lounge Roulette Deluxe",
      image: "/assets/liveCasino/PP1031.webp",
      platformImage: "/assets/platformHeader/PP-WHITE.webp",
      platFormCode: "PP",
      gameType: "LIVE",
      casinoType: "PP-LIVE-184",
    },
  ],
  VIACASINO: [
    {
      name: "Classic Baccarat",
      image: "/assets/liveCasino/VIA002.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-001",
    },
    {
      name: "Speed ​​Baccarat",
      image: "/assets/liveCasino/VIA004.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-002",
    },
    {
      name: "Lucky Natural",
      image: "/assets/liveCasino/VIA004.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-003",
    },
    {
      name: "Pair Baccarat",
      image: "/assets/liveCasino/VIA005.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-004",
    },
    {
      name: "Wealth SuperSix",
      image: "/assets/liveCasino/VIA006.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-005",
    },
    {
      name: "Dragon Tiger",
      image: "/assets/liveCasino/VIA007.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-006",

      platFormCode: "VIACASINO",
    },
    {
      name: "Classic Sic Bo",
      image: "/assets/liveCasino/VIA008.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-007",
    },
    {
      name: "Thai Hi Lo",
      image: "/assets/liveCasino/VIA009.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-008",

      platFormCode: "VIACASINO",
    },
    {
      name: "Tai Xiu",
      image: "/assets/liveCasino/VIA010.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-009",
    },
    {
      name: "Color Game",
      image: "/assets/liveCasino/VIA011.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-010",
    },
    {
      name: "Thai Fish Prawn Crab",
      image: "/assets/liveCasino/VIA012.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-011",

      platFormCode: "VIACASINO",
    },
    {
      name: "Viet Fish Prawn Crab",
      image: "/assets/liveCasino/VIA013.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-012",
    },
    {
      name: "Xoc Dia",
      image: "/assets/liveCasino/VIA014.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-015",
    },
    {
      name: "Blockchain Classic Sic Bo",
      image: "/assets/liveCasino/VIA015.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-017",
    },
    {
      name: "Blockchain Tai Xiu",
      image: "/assets/liveCasino/VIA017.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-019",
    },
    {
      name: "Lotto Lucky Natural",
      image: "/assets/liveCasino/VIA018.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-022",
    },
    {
      name: "Lotto Xoc Dia",
      image: "/assets/liveCasino/VIA019.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-023",
    },
    {
      name: "Lotto Lucky Wheel",
      image: "/assets/liveCasino/VIA020.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-024",
    },
    {
      name: "Crazy Marbles",
      image: "/assets/liveCasino/VIA024.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-025",
    },
    {
      name: "Tornado Marbles",
      image: "/assets/liveCasino/VIA025.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-026",
    },
    {
      name: "Blockchain Thai FishShrimpCrab",
      image: "/assets/liveCasino/VIA026.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-027",
    },
    {
      name: "Blockchain Viet FishShrimpCrab",
      image: "/assets/liveCasino/VIA027.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-028",
    },
    {
      name: "Blockchain Xoc Dia",
      image: "/assets/liveCasino/VIA028.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-029",
    },
    {
      name: "Blockchain Color Game",
      image: "/assets/liveCasino/VIA029.webp",
      platformImage: "/assets/platformHeader/VIA-WHITE.webp",
      platFormCode: "VIACASINO",
      gameType: "LIVE",
      casinoType: "VIACASINO-LIVE-030",
    },
  ],
  PT: [
    {
      name: "Baccarat",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-001",
    },
    {
      name: "Dragon Tiger",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-002",
    },
    {
      name: "SicBo Deluxe",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-003",
    },
    {
      name: "Andar Bahar Live",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-004",
    },
    {
      name: "Bet on Baccarat Live",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-005",
    },
    {
      name: "All Bets Blackjack",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-007",
    },
    {
      name: "Sette E Mezzo",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-009",
    },
    {
      name: "Unlimited Blackjack",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-010",
    },
    {
      name: "Adventures Beyond Wonderland",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-011",
    },
    {
      name: "Spin a Win",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-015",
    },
    {
      name: "3 Card Brag",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-016",
    },
    {
      name: "Casino HoldÂ´em",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-017",
    },
    {
      name: "Bet on Poker Live",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-019",
    },
    {
      name: "American Roulette",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-021",
    },
    {
      name: "Deutsches Speed Roulette",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-022",
    },
    {
      name: "Football French Roulette",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-023",
    },
    {
      name: "Football Roulette",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-024",
    },
    {
      name: "French Roulette",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-025",
    },
    {
      name: "Quantum Auto Roulette",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-026",
    },
    {
      name: "Spread Bet Roulette",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-027",
    },
    {
      name: "Mega Fire Blaze Roulette Live",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-028",
    },
    {
      name: "Bet On Dragon Tiger Live",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-030",
    },
    {
      name: "Italian Cashback Blackjack",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-031",
    },
    {
      name: "Roulette",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-032",
    },
    {
      name: "Grand Baccarat",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-034",
    },
    {
      name: "Speed 6 Scanner Baccarat",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-035",
    },
    {
      name: "Grand Baccarat NC",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-037",
    },
    {
      name: "Speed 6 Scanner Baccarat NC",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-038",
    },
    {
      name: "Blackjack Italiano 1",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-041",
    },
    {
      name: "Blackjack Italiano 2",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-042",
    },
    {
      name: "Blackjack Italiano VIP",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-043",
    },
    {
      name: "Deutsches Blackjack",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-044",
    },
    {
      name: "Royale Blackjack 1",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-045",
    },
    {
      name: "Royale Blackjack 3",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-052",
    },
    {
      name: "Soho All Bets Blackjack",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-054",
    },
    {
      name: "Greek Roulette",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-055",
    },
    {
      name: "Hindi Roulette",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-056",
    },
    {
      name: "Prestige Roulette",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-057",
    },
    {
      name: "Speed Auto Roulette",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-058",
    },
    {
      name: "Roleta Brasileira",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-059",
    },
    {
      name: "Roulette Italiana",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-060",
    },
    {
      name: "Auto Roulette",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-061",
    },
    {
      name: "Bucharest Roulette",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-063",
    },
    {
      name: "Turkish Roulette",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-064",
    },
    {
      name: "Bucharest French Roulette",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-066",
    },
    {
      name: "Quantum Roulette Live",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-067",
    },
    {
      name: "Blackjack 9",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-068",
    },
    {
      name: "Blackjack 3",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-069",
    },
    {
      name: "Blackjack 4",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-070",
    },
    {
      name: "Blackjack 5",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-071",
    },
    {
      name: "Blackjack 6",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-072",
    },
    {
      name: "Blackjack 7",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-073",
    },
    {
      name: "Blackjack 8",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-074",
    },
    {
      name: "Baccarat NC",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-075",
    },
    {
      name: "Greek Quantum Roulette",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-076",
    },
    {
      name: "Ruleta Automatica Cuantica",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-077",
    },
    {
      name: "Arabic Roulette",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-078",
    },
    {
      name: "Quantum Ruleta España",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-079",
    },
    {
      name: "Ruyi French Roulette",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-080",
    },
    {
      name: "Ruyi Roulette",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-081",
    },
    {
      name: "Slingshot Ruleta Espana",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-083",
    },
    {
      name: "The Greatest Cards Show",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-086",
    },
    {
      name: "Spin a Win Wild Live",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-088",
    },
    {
      name: "Japanese Squeeze Baccarat",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-091",
    },
    {
      name: "Japanese Squeeze Baccarat NC",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-092",
    },
    {
      name: "Ru Yi Speed Baccarat",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-093",
    },
    {
      name: "Ru Yi Speed Baccarat NC",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-094",
    },
    {
      name: "Speed Baccarat Korean",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-095",
    },
    {
      name: "Speed Baccarat Korean NC",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-096",
    },
    {
      name: "Baccarat Brasileira",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-097",
    },
    {
      name: "Baccarat Brasileira NC",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-098",
    },
    {
      name: "Speed SicBo",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-099",
    },
    {
      name: "Auto Roulette 2",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-100",
    },
    {
      name: "x1000 Quantum Roulette",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-102",
    },
    {
      name: "Mega Fire Blaze Blackjack Live",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-106",
    },
    {
      name: "Mega Fire Blaze Lucky Ball Brasileiro",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-108",
    },
    {
      name: "Speed Baccarat",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-109",
    },
    {
      name: "Mega Fire Blaze Lucky Ball Live",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-110",
    },
    {
      name: "Blackjack Soirée 1",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-111",
    },
    {
      name: "Blackjack Soirée 2",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-112",
    },
    {
      name: "Blackjack Soirée 3",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-113",
    },
    {
      name: "Soirée Privée Blackjack",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-114",
    },
    {
      name: "Baccarat Soirée",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-115",
    },
    {
      name: "K-Pop Roulette Live",
      image: "/assets/liveCasino/PT0264.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
    },
    {
      name: "Gangnam Speed Baccarat",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-117",
    },
    {
      name: "Gangnam Speed Baccarat NC",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-118",
    },
    {
      name: "Emperor Baccarat",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-119",
    },
    {
      name: "Emperor Baccarat NC",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-120",
    },
    {
      name: "Blackjack Soirée Gold 1",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-121",
    },
    {
      name: "Blackjack Soirée Gold 2",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-122",
    },
    {
      name: "Blackjack Soirée Gold 3",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-123",
    },
    {
      name: "Blackjack Soirée Gold 4",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-124",
    },
    {
      name: "Punto Banco Soirée Gold",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-125",
    },
    {
      name: "All Bets Blackjack Brasileira",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-126",
    },
    {
      name: "Blackjack 10",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-127",
    },
    {
      name: "Sticky Bandits Roulette Live",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-128",
    },
    {
      name: "Baccarat Soirée NC",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-129",
    },
    {
      name: "Lucky Ball Roulette Live",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-130",
    },
    {
      name: "Cash Collect Roulette Live",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-131",
    },
    {
      name: "Blackjack VZN 1",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-132",
    },
    {
      name: "Blackjack VZN 2",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-133",
    },
    {
      name: "Blackjack VZN 3",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-134",
    },
    {
      name: "Blackjack VZN 4",
      image: "/assets/liveCasino/PT0058.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-135",
    },
    {
      name: "Blackjack VZN 5",
      image: "/assets/liveCasino/PT0052.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-136",
    },
    {
      name: "Blackjack VZN 6",
      image: "/assets/liveCasino/PT0304.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-137",
    },
    {
      name: "Blackjack VZN 7",
      image: "/assets/liveCasino/PT0249.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-138",
    },
    {
      name: "Blackjack VZN 8",
      image: "/assets/liveCasino/PT0364.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-139",
    },
    {
      name: "Blackjack VZN 9",
      image: "/assets/liveCasino/PT0549.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-140",
    },
    {
      name: "Blackjack VZN 10",
      image: "/assets/liveCasino/PT0615.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-141",
    },
    {
      name: "Elite Roulette",
      image: "/assets/liveCasino/PT0572.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-142",
    },
    {
      name: "Quantum Baccarat Live",
      image: "/assets/liveCasino/PT0698.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-143",
    },
    {
      name: "Speed Baccarat 1",
      image: "/assets/liveCasino/PT0731.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-144",
    },
    {
      name: "Speed Baccarat 2",
      image: "/assets/liveCasino/PT0732.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-145",
    },
    {
      name: "Super Speed Baccarat",
      image: "/assets/liveCasino/PT0730.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-146",
    },
    {
      name: "Super Card Blackjack Live",
      image: "/assets/liveCasino/PT0762.webp",
      platformImage: "/assets/platformHeader/PT-WHITE.webp",
      platFormCode: "PT",
      gameType: "LIVE",
      casinoType: "PT-LIVE-147",
    },
  ],
  SEXY: [
    {
      name: "Pok Deng",
      image: "/assets/liveCasino/SEX014.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-018",
    },
    {
      name: "Sedie",
      image: "/assets/liveCasino/SEX013.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-017",
    },
    {
      name: "Extra Hi Lo",
      image: "/assets/liveCasino/SEX011.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-016",
    },
    {
      name: "Thai Fish Prawn Crab",
      image: "/assets/liveCasino/SEX009.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-015",
    },
    {
      name: "Thai Hi Lo",
      image: "/assets/liveCasino/SEX008.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-014",
    },
    {
      name: "Roulette",
      image: "/assets/liveCasino/SEX005.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-009",
    },
    {
      name: "Dragon Tiger",
      image: "/assets/liveCasino/SEX003.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-006",
    },
    {
      name: "Baccarat",
      image: "/assets/liveCasino/SEX002.webp",
      platformImage: "/assets/platformHeader/SEX-WHITE.webp",
      platFormCode: "SEXYBCRT",
      gameType: "LIVE",
      casinoType: "MX-LIVE-002",
    },
    // {
    //   name: "Baccarat Classic",
    //   image: "/assets/liveCasino/SEX015.webp",
    //   platformImage: "/assets/platformHeader/SEX-WHITE.webp",
    //   platFormCode: "SEXYBCRT",
    //   gameType: "LIVE",
    //   casinoType: "MX-LIVE-001",
    // },
  ],
};

export const Fishing = {
  FC: [
    {
      name: "Gods Grant Fortune",
      image: "/assets/fishing/FC0053.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-006",
    },
    {
      name: "Star Hunter",
      image: "/assets/fishing/FC0027.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-005",
    },
    {
      name: "Fierce Fishing",
      image: "/assets/fishing/FC0020.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-004",
    },
    {
      name: "Bao Chuan Fishing",
      image: "/assets/fishing/FC0019.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-002",
    },
    {
      name: "Monkey King Fishing",
      image: "/assets/fishing/FC0018.webp",
      platformImage:
        "/assets/platformHeader/FC-WHITE.webp",
      platFormCode: "FC",
      gameType: "FH",
      casinoType: "FC-FISH-001",
    },
  ],
  JILI: [
    {
      name: "Royal Fishing",
      image: "/assets/fishing/JL0002.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-001",
    },
    {
      name: "Bombing Fishing",
      image: "/assets/fishing/JL0003.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-002",
    },
    {
      name: "Jackpot Fishing",
      image: "/assets/fishing/JL0005.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-003",
    },
    {
      name: "Dinosaur Tycoon",
      image: "/assets/fishing/JL0004.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-004",
    },
    {
      name: "Happy Fishing",
      image: "/assets/fishing/JL0009.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-005",
    },
    {
      name: "Dragon Fortune",
      image: "/assets/fishing/JL0006.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "ILOVEU",
      gameType: "SLOT",
      casinoType: "ILOVEU-SLOT-040",
    },
    {
      name: "Mega Fishing",
      image: "/assets/fishing/JL0007.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-007",
    },
    {
      name: "Boom Legend",
      image: "/assets/fishing/JL0008.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-008",
    },
    {
      name: "Dinosaur Tycoon II",
      image: "/assets/fishing/JL0111.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-011",
    },
    {
      name: "Ocean King Jackpot",
      image: "/assets/fishing/JL0136.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-012",
    },
    {
      name: "Fortune King Jackpot",
      image: "/assets/fishing/JL0183.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-013",
    },
    {
      name: "FORTUNE ZOMBIE",
      image: "/assets/fishing/JL0231.webp",
      platformImage:
        "/assets/platformHeader/JL-WHITE.webp",
      platFormCode: "JILI",
      gameType: "FH",
      casinoType: "JILI-FISH-014",
    },
  ],
  YL: [
    {
      name: "Heroes of the Deep Sea",
      image:
        "/assets/fishing/YL0019.webp",
      platformImage:
        "/assets/platformHeader/YL-WHITE.webp",
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-005",
    },
    {
      name: "Jackpot Fishery",
      image:
        "/assets/fishing/YL0018.webp",
      platformImage:
        "/assets/platformHeader/YL-WHITE.webp",
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-004",
    },
    {
      name: "New Fishing Season",
      image:
        "/assets/fishing/YL0017.webp",
      platformImage:
        "/assets/platformHeader/YL-WHITE.webp",
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-003",
    },
    {
      name: "Shark Hunter",
      image:
        "/assets/fishing/YL0016.webp",
      platformImage:
        "/assets/platformHeader/YL-WHITE.webp",
      platFormCode: "YL",
      gameType: "FH",
      casinoType: "YL-FISH-002",
    },
    {
      name: "Fish Hunter 2",
      image:
        "/assets/fishing/YL0010.webp",
      platformImage:
        "/assets/platformHeader/YL-WHITE.webp",
    },
  ],
  JOKER: [
    {
      name: "Insect Paradise",
      image:
        "/assets/fishing/JK0109.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fishermans Wharf",
      image:
        "/assets/fishing/JK0082.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Raiden Hunter",
      image:
        "/assets/fishing/JK0081.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Legend of Phoenix",
      image:
        "/assets/fishing/JK0079.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunting: Yao Qian Shu",
      image:
        "/assets/fishing/JK0078.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunting: Li Kui Pi Yu",
      image:
        "/assets/fishing/JK0077.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunting: Happy Fish 5",
      image:
        "/assets/fishing/JK0076.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunting: Golden Toad",
      image:
        "/assets/fishing/JK0075.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunting: Da Sheng Nao Hai",
      image:
        "/assets/fishing/JK0074.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter Spongebob",
      image:
        "/assets/fishing/JK0072.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter Monster Awaken",
      image:
        "/assets/fishing/JK0071.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter Haiba",
      image:
        "/assets/fishing/JK0070.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter 2 Ex - Pro",
      image:
        "/assets/fishing/JK0069.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter 2 Ex - Novice",
      image:
        "/assets/fishing/JK0068.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter 2 Ex - Newbie",
      image:
        "/assets/fishing/JK0067.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter 2 Ex - My Club",
      image:
        "/assets/fishing/JK0066.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter 2",
      image:
        "/assets/fishing/JK0065.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter - The Mosaic Gold Dragon",
      image:
        "/assets/fishing/JK0064.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish Hunter",
      image:
        "/assets/fishing/JK0063.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish - Monster Legend",
      image:
        "/assets/fishing/JK0062.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Fish",
      image:
        "/assets/fishing/JK0061.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Dinosaurs Hunter T-Rex Awaken",
      image:
        "/assets/fishing/JK0043.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
    {
      name: "Bird Paradise",
      image:
        "/assets/fishing/JK0019.webp",
      platformImage:
        "/assets/platformHeader/JK-WHITE.webp",
    },
  ],
  SPADE: [
    {
      name: "Fishing Legend",
      image: "/assets/fishing/SG0179.webp",
      platformImage:
        "/assets/platformHeader/SG-WHITE.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-005",
    },
    {
      name: "Fishing War",
      image: "/assets/fishing/SG0131.webp",
      platformImage:
        "/assets/platformHeader/SG-WHITE.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-002",
    },
    {
      name: "Fishing God",
      image: "/assets/fishing/SG0130.webp",
      platformImage:
        "/assets/platformHeader/SG-WHITE.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-001",
    },
    {
      name: "Alien Hunter",
      image: "/assets/fishing/SG0129.webp",
      platformImage:
        "/assets/platformHeader/SG-WHITE.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-003",
    },
    {
      name: "Zombie Party",
      image: "/assets/fishing/SG0128.webp",
      platformImage:
        "/assets/platformHeader/SG-WHITE.webp",
      platFormCode: "SPADE",
      gameType: "FH",
      casinoType: "SG-FISH-004",
    },
  ],
  FASTSPIN: [
    {
      name: "Fishing Treasure",
      image: "/assets/fishing/FS0045.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "FH",
      casinoType: "FastSpin-FISH-001",
    },
    {
      name: "Ocean Carnival",
      image: "/assets/fishing/FS0046.webp",
      platformImage:
        "/assets/platformHeader/FS-WHITE.webp",
      platFormCode: "FASTSPIN",
      gameType: "FH",
      casinoType: "FastSpin-FISH-002",
    },
  ],
  JDB: [
    {
      name: "Cai Shen Fishing",
      image: "/assets/fishing/JDB082.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-008",
    },
    {
      name: "Shade Dragons Fishing",
      image: "/assets/fishing/JDB083.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-009",
    },
    {
      name: "Dragon Master",
      image: "/assets/fishing/JDB152.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-011",
    },
    {
      name: "Fishing Disco",
      image: "/assets/fishing/JDB154.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-012",
    },
    {
      name: "Spirit Tide Legend",
      image: "/assets/fishing/JDB206.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-013",
    },
    {
      name: "Fighter Fire",
      image: "/assets/fishing/JDB213.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-014",
    },
    {
      name: "Dragon Fishing II",
      image: "/assets/fishing/JDB081.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-015",
    },
    {
      name: "Dragon Fishing",
      image: "/assets/fishing/JDB080.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-016",
    },
    {
      name: "Dragon of Demons",
      image: "/assets/fishing/JDB234.webp",
      platformImage:
        "/assets/platformHeader/JDB-WHITE.webp",
      platFormCode: "JDB",
      gameType: "FH",
      casinoType: "JDB-FISH-017",
    },
  ],
};
